import { useState, useEffect, useMemo, useRef, useCallback, useLayoutEffect } from 'react';
import { useLottie } from 'lottie-react';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { getCookie, isLowerVersion, isWebview, closeWebView, openExternalBrowser } from '@socar-inc/utils';

var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  __defProp(target, "default", { value: mod, enumerable: true }) ,
  mod
));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// ../../node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "../../node_modules/lodash/lodash.js"(exports, module) {
    (function() {
      var undefined2;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined2 : object[key];
        };
      }
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined2 : object[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined2) {
            result = result === undefined2 ? current : result + current;
          }
        }
        return result;
      }
      function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [key, object[key]];
        });
      }
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object, key) {
        return object == null ? undefined2 : object[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index] = [key, value];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
          }
        }
        return result;
      }
      function setToArray(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = value;
        });
        return result;
      }
      function setToPairs(set) {
        var index = -1, result = Array(set.size);
        set.forEach(function(value) {
          result[++index] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {
        }
        return index;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _3.defaults(root.Object(), context, _3.pick(root, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap && new WeakMap();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = /* @__PURE__ */ function() {
          function object() {
          }
          return function(proto) {
            if (!isObject(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result2 = new object();
            object.prototype = undefined2;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index += dir;
              var iterIndex = -1, value = array[index];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined2 : result2;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined2;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          return index < 0 ? undefined2 : data[index][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values2[index]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object, key, value) {
          if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        function baseAssignValue(object, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object[key] = value;
          }
        }
        function baseAt(object, paths) {
          var index = -1, length = paths.length, result2 = Array2(length), skip = object == null;
          while (++index < length) {
            result2[index] = skip ? undefined2 : get(object, paths[index]);
          }
          return result2;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined2) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined2) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result2 !== undefined2) {
            return result2;
          }
          if (!isObject(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (length--) {
            var key = props[length], predicate = source[key], value = object[key];
            if (value === undefined2 && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index, collection2) {
            result2 = !!predicate(value, index, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index = -1, length = array.length;
          while (++index < length) {
            var value = array[index], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index, collection2) {
            if (predicate(value, index, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0, length = path.length;
          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }
          return index && index == length ? object : undefined2;
        }
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object);
          return isArray(object) ? result2 : arrayPush(result2, symbolsFunc(object));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }
        function baseHasIn(object, key) {
          return object != null && key in Object2(object);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index = -1, seen = caches[0];
          outer:
            while (++index < length && result2.length < maxLength) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value, key, object2) {
            setter(accumulator, iteratee2(value), key, object2);
          });
          return accumulator;
        }
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length, length = index, noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result2 = [];
          for (var key in Object2(object)) {
            if (hasOwnProperty.call(object, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object) {
          if (!isObject(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result2 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object) {
            var objValue = get(object, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index, "value": value };
          });
          return baseSortBy(result2, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value, path) {
            return hasIn(object, path);
          });
        }
        function basePickBy(object, paths, predicate) {
          var index = -1, length = paths.length, result2 = {};
          while (++index < length) {
            var path = paths[index], value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index < length) {
            var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
          while (length--) {
            result2[fromRight ? length : ++index] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string, n) {
          var result2 = "";
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n % 2) {
              result2 += string;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string += string;
            }
          } while (n);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        function baseSet(object, path, value, customizer) {
          if (!isObject(object)) {
            return object;
          }
          path = castPath(path, object);
          var index = -1, length = path.length, lastIndex = length - 1, nested = object;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array2(length);
          while (++index < length) {
            result2[index] = array[index + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index, collection2) {
            result2 = predicate(value, index, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -Infinity ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1, result2 = Array2(length);
          while (++index < length) {
            var array = arrays[index], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result2[index] = baseDifference(result2[index] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index < length) {
            var value = index < valsLength ? values2[index] : undefined2;
            assignFunc(result2, props[index], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object, other, orders) {
          var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index < length) {
            var result2 = compareAscending(objCriteria[index], othCriteria[index]);
            if (result2) {
              if (index >= ordersLength) {
                return result2;
              }
              var order = orders[index];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index = -1, length = source.length;
          array || (array = Array2(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1, length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object = Object2(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee2(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined2,
                args,
                holders,
                undefined2,
                undefined2,
                arity - length
              );
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
              while (++index2 < length) {
                result2 = funcs[index2].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result2 = value;
            }
            if (other !== undefined2) {
              if (result2 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= -4;
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function(values2) {
          return new Set(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= -97;
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= -25;
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject(objValue) && isObject(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined2 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index < arrLength) {
            var arrValue = array[index], othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result2 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
          return object.placeholder;
        }
        function getIteratee() {
          var result2 = lodash.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object) {
          var result2 = keys(object), length = result2.length;
          while (length--) {
            var key = result2[length], value = object[key];
            result2[length] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined2;
            var unmasked = true;
          } catch (e) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object2(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result2 = [];
          while (object) {
            arrayPush(result2, getSymbols(object));
            object = getPrototype(object);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start, end, transforms) {
          var index = -1, length = transforms.length;
          while (++index < length) {
            var data = transforms[index], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1, length = path.length, result2 = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result2 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result2 || ++index != length) {
            return result2;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index, object) {
          if (!isObject(object)) {
            return false;
          }
          var type = typeof index;
          if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
            return eq(object[index], value);
          }
          return false;
        }
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined2 || key in Object2(object));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object) {
          var result2 = [];
          if (object != null) {
            for (var key in Object2(object)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array2(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
          }
          return array;
        }
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index < size2) {
            var rand = baseRandom(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result2 = [];
          if (string.charCodeAt(0) === 46) {
            result2.push("");
          }
          string.replace(rePropName, function(match, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -Infinity ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
          while (index < length) {
            result2[resIndex++] = baseSlice(array, index, index += size2);
          }
          return result2;
        }
        function compact(array) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index < length) {
            var pair = pairs[index];
            result2[pair[0]] = pair[1];
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result2.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
            return baseAt(object, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined2 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
        }
        function before(n, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined2;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result2 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }
        memoize.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index = -1, length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle2(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(/* @__PURE__ */ function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result2 = customizer ? customizer(value, other) : undefined2;
          return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
        }
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        function isFinite(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        function isNaN(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -9007199254740991 && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -Infinity) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -9007199254740991, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults = baseRest(function(object, sources) {
          object = Object2(object);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get(object, path, defaultValue) {
          var result2 = object == null ? undefined2 : baseGet(object, path);
          return result2 === undefined2 ? defaultValue : result2;
        }
        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        function mapKeys(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, iteratee2(value, key, object2), value);
          });
          return result2;
        }
        function mapValues(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, key, iteratee2(value, key, object2));
          });
          return result2;
        }
        var merge = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object, paths) {
          var result2 = {};
          if (object == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index = -1, length = path.length;
          if (!length) {
            length = 1;
            object = undefined2;
          }
          while (++index < length) {
            var value = object == null ? undefined2 : object[toKey(path[index])];
            if (value === undefined2) {
              index = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }
        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
            return iteratee2(accumulator, value, index, object2);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        function clamp(number, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index) {
          word = word.toLowerCase();
          return result2 + (index ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string), n);
        }
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        function template(string, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined2;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result2.source = source;
          if (isError(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined2) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match, substring = result2;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index = result2.lastIndexOf(separator);
            if (index > -1) {
              result2 = result2.slice(0, index);
            }
          }
          return result2 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e) {
            return isError(e) ? e : new Error2(e);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop() {
        }
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined2 : baseGet(object, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index < n) {
            iteratee2(index);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId4(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle2;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt2;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId4;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(["drop", "take"], function(methodName, index) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined2 ? 1 : nativeMax(toInteger(n), 0);
            var result2 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
          var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index) {
          var takeName = "take" + (index ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index) {
          var dropName = "drop" + (index ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash, arrayPush([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined2
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _3 = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root._ = _3;
        define(function() {
          return _3;
        });
      } else if (freeModule) {
        (freeModule.exports = _3)._ = _3;
        freeExports._ = _3;
      } else {
        root._ = _3;
      }
    }).call(exports);
  }
});

// src/components/Button/index.tsx
var import_lodash = __toESM(require_lodash());

// src/libs/constants.ts
var ASSET_HOST_URL = process.env.NODE_ENV === "production" ? "https://frontend-design-system.socar.kr" : "https://frontend-design-system.socar.me";

// assets/animations/dark/basic_loading_blue050.json
var basic_loading_blue050_default = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 48, h: 16, nm: "indeterminate_basic_blue050", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Shape Layer 4", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 8, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 19, s: [100, 100, 100] }, { t: 23.0000009368092, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0, 0.764705882353, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "Shape Layer 3", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [24, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 2, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 6, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 17, s: [100, 100, 100] }, { t: 21.0000008553475, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0, 0.764705882353, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Shape Layer 2", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [8, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 0, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 15, s: [100, 100, 100] }, { t: 19.0000007738859, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0, 0.764705882353, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/dark/basic_loading_coral050.json
var basic_loading_coral050_default = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 48, h: 16, nm: "indeterminate_basic_blue050", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Shape Layer 4", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 8, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 19, s: [100, 100, 100] }, { t: 23.0000009368092, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0, 0, 0, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 0.396078431372549, 0.3411764705882353, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "Shape Layer 3", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [24, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 2, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 6, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 17, s: [100, 100, 100] }, { t: 21.0000008553475, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0, 0, 0, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 0.396078431372549, 0.3411764705882353, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Shape Layer 2", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [8, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 0, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 15, s: [100, 100, 100] }, { t: 19.0000007738859, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0, 0, 0, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 0.396078431372549, 0.3411764705882353, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/dark/basic_loading_grey040.json
var basic_loading_grey040_default = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 48, h: 16, nm: "indeterminate_basic_grey040", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Shape Layer 4", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 8, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 19, s: [100, 100, 100] }, { t: 23.0000009368092, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0.352941176471, 0.380392156863, 0.4, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "Shape Layer 3", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [24, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 2, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 6, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 17, s: [100, 100, 100] }, { t: 21.0000008553475, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0.352941176471, 0.380392156863, 0.4, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Shape Layer 2", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [8, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 0, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 15, s: [100, 100, 100] }, { t: 19.0000007738859, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0.352941176471, 0.380392156863, 0.4, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/dark/basic_loading_white.json
var basic_loading_white_default = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 48, h: 16, nm: "indeterminate_basic_white", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Shape Layer 4", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 8, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 19, s: [100, 100, 100] }, { t: 23.0000009368092, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "Shape Layer 3", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [24, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 2, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 6, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 17, s: [100, 100, 100] }, { t: 21.0000008553475, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Shape Layer 2", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [8, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 0, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 15, s: [100, 100, 100] }, { t: 19.0000007738859, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/dark/basic_loading_white_dim.json
var basic_loading_white_dim_default = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 80, h: 80, nm: "indeterminate_basic_white_dim", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Shape Layer 4", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [56, 40, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 8, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 19, s: [100, 100, 100] }, { t: 23.0000009368092, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "Shape Layer 3", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 40, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 2, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 6, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 17, s: [100, 100, 100] }, { t: 21.0000008553475, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Shape Layer 2", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [24, 40, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 0, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 15, s: [100, 100, 100] }, { t: 19.0000007738859, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 4, ty: 4, nm: "Shape Layer 5", sr: 1, ks: { o: { a: 0, k: 50, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 40, 0], ix: 2 }, a: { a: 0, k: [1.13, -0.12, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [79, 79], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Ellipse Path 1", mn: "ADBE Vector Shape - Ellipse", hd: false }, { ty: "st", c: { a: 0, k: [0.086274509804, 0.113725490196, 0.141176470588, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0.086274509804, 0.113725490196, 0.141176470588, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [1.13, -0.12], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Ellipse 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/dark/circular_loading_blue050.json
var circular_loading_blue050_default = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 24, h: 24, nm: "indeterminate_circle_blue050", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "circle_small_fast", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [12, 12, 0], ix: 2 }, a: { a: 0, k: [-5.312, 11.743, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 2, ty: "el", s: { a: 0, k: [18.6, 18.6], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Ellipse Path 1", mn: "ADBE Vector Shape - Ellipse", hd: false }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0], y: [1] }, o: { x: [0.333], y: [0] }, t: 6, s: [0] }, { t: 26.0000010590017, s: [100] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] }, { t: 20.0000008146167, s: [100] }], ix: 2 }, o: { a: 0, k: 0, ix: 3 }, m: 1, ix: 2, nm: "Trim Paths 1", mn: "ADBE Vector Filter - Trim", hd: false }, { ty: "st", c: { a: 0, k: [0, 0.764705882353, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 1.4, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "tr", p: { a: 0, k: [-5.312, 11.555], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Ellipse 1", np: 4, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/dark/circular_loading_coral050.json
var circular_loading_coral050_default = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 24, h: 24, nm: "indeterminate_circle_blue050", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "circle_small_fast", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [12, 12, 0], ix: 2 }, a: { a: 0, k: [-5.312, 11.743, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 2, ty: "el", s: { a: 0, k: [18.6, 18.6], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Ellipse Path 1", mn: "ADBE Vector Shape - Ellipse", hd: false }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0], y: [1] }, o: { x: [0.333], y: [0] }, t: 6, s: [0] }, { t: 26.0000010590017, s: [100] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] }, { t: 20.0000008146167, s: [100] }], ix: 2 }, o: { a: 0, k: 0, ix: 3 }, m: 1, ix: 2, nm: "Trim Paths 1", mn: "ADBE Vector Filter - Trim", hd: false }, { ty: "st", c: { a: 0, k: [1, 0.396078431372549, 0.3411764705882353, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 1.4, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "tr", p: { a: 0, k: [-5.312, 11.555], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Ellipse 1", np: 4, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/light/basic_loading_coral050.json
var basic_loading_coral050_default2 = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 48, h: 16, nm: "indeterminate_basic_blue050", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Shape Layer 4", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 8, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 19, s: [100, 100, 100] }, { t: 23.0000009368092, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 0.43529411764705883, 0.3803921568627451, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "Shape Layer 3", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [24, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 2, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 6, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 17, s: [100, 100, 100] }, { t: 21.0000008553475, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 0.43529411764705883, 0.3803921568627451, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Shape Layer 2", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [8, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 0, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 15, s: [100, 100, 100] }, { t: 19.0000007738859, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 0.43529411764705883, 0.3803921568627451, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/light/basic_loading_grey040.json
var basic_loading_grey040_default2 = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 48, h: 16, nm: "indeterminate_basic_grey040", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Shape Layer 4", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 8, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 19, s: [100, 100, 100] }, { t: 23.0000009368092, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0.772549019608, 0.78431372549, 0.807843137255, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "Shape Layer 3", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [24, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 2, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 6, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 17, s: [100, 100, 100] }, { t: 21.0000008553475, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0.772549019608, 0.78431372549, 0.807843137255, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Shape Layer 2", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [8, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 0, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 15, s: [100, 100, 100] }, { t: 19.0000007738859, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0.772549019608, 0.78431372549, 0.807843137255, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/light/basic_loading_white.json
var basic_loading_white_default2 = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 48, h: 16, nm: "indeterminate_basic_white", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Shape Layer 4", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 8, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 19, s: [100, 100, 100] }, { t: 23.0000009368092, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "Shape Layer 3", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [24, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 2, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 6, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 17, s: [100, 100, 100] }, { t: 21.0000008553475, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Shape Layer 2", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [8, 8, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 0, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 15, s: [100, 100, 100] }, { t: 19.0000007738859, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/light/basic_loading_white_dim.json
var basic_loading_white_dim_default2 = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 80, h: 80, nm: "indeterminate_basic_white_dim", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "Shape Layer 4", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [56, 40, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 8, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 19, s: [100, 100, 100] }, { t: 23.0000009368092, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 2, ty: 4, nm: "Shape Layer 3", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 40, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 2, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 6, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 17, s: [100, 100, 100] }, { t: 21.0000008553475, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 3, ty: 4, nm: "Shape Layer 2", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [24, 40, 0], ix: 2 }, a: { a: 0, k: [-12.674, -4.111, 0], ix: 1 }, s: { a: 1, k: [{ i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 0, s: [0, 0, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.333, 0.333, 0.333], y: [0, 0, 0] }, t: 4, s: [100, 100, 100] }, { i: { x: [0.667, 0.667, 0.667], y: [1, 1, 1] }, o: { x: [0.167, 0.167, 0.167], y: [0, 0, 0] }, t: 15, s: [100, 100, 100] }, { t: 19.0000007738859, s: [0, 0, 100] }], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ ty: "rc", d: 1, s: { a: 0, k: [8, 8], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, r: { a: 0, k: 0, ix: 4 }, nm: "Rectangle Path 1", mn: "ADBE Vector Shape - Rect", hd: false }, { ty: "st", c: { a: 0, k: [0.913725011489, 0.921568986481, 0.933332974303, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [1, 1, 1, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [-12.674, -4.111], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Rectangle 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }, { ddd: 0, ind: 4, ty: 4, nm: "Shape Layer 5", sr: 1, ks: { o: { a: 0, k: 50, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [40, 40, 0], ix: 2 }, a: { a: 0, k: [1.13, -0.12, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 1, ty: "el", s: { a: 0, k: [79, 79], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Ellipse Path 1", mn: "ADBE Vector Shape - Ellipse", hd: false }, { ty: "st", c: { a: 0, k: [0.086274509804, 0.113725490196, 0.141176470588, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 0, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "fl", c: { a: 0, k: [0.086274509804, 0.113725490196, 0.141176470588, 1], ix: 4 }, o: { a: 0, k: 100, ix: 5 }, r: 1, bm: 0, nm: "Fill 1", mn: "ADBE Vector Graphic - Fill", hd: false }, { ty: "tr", p: { a: 0, k: [1.13, -0.12], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Ellipse 1", np: 3, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/light/circular_loading_blue050.json
var circular_loading_blue050_default2 = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 24, h: 24, nm: "indeterminate_circle_blue050", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "circle_small_fast", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [12, 12, 0], ix: 2 }, a: { a: 0, k: [-5.312, 11.743, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 2, ty: "el", s: { a: 0, k: [18.6, 18.6], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Ellipse Path 1", mn: "ADBE Vector Shape - Ellipse", hd: false }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0], y: [1] }, o: { x: [0.333], y: [0] }, t: 6, s: [0] }, { t: 26.0000010590017, s: [100] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] }, { t: 20.0000008146167, s: [100] }], ix: 2 }, o: { a: 0, k: 0, ix: 3 }, m: 1, ix: 2, nm: "Trim Paths 1", mn: "ADBE Vector Filter - Trim", hd: false }, { ty: "st", c: { a: 0, k: [0, 0.721568627451, 1, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 1.4, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "tr", p: { a: 0, k: [-5.312, 11.555], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Ellipse 1", np: 4, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// assets/animations/light/circular_loading_coral050.json
var circular_loading_coral050_default2 = { v: "5.6.5", fr: 29.9700012207031, ip: 0, op: 30.0000012219251, w: 24, h: 24, nm: "indeterminate_circle_blue050", ddd: 0, assets: [], layers: [{ ddd: 0, ind: 1, ty: 4, nm: "circle_small_fast", sr: 1, ks: { o: { a: 0, k: 100, ix: 11 }, r: { a: 0, k: 0, ix: 10 }, p: { a: 0, k: [12, 12, 0], ix: 2 }, a: { a: 0, k: [-5.312, 11.743, 0], ix: 1 }, s: { a: 0, k: [100, 100, 100], ix: 6 } }, ao: 0, shapes: [{ ty: "gr", it: [{ d: 2, ty: "el", s: { a: 0, k: [18.6, 18.6], ix: 2 }, p: { a: 0, k: [0, 0], ix: 3 }, nm: "Ellipse Path 1", mn: "ADBE Vector Shape - Ellipse", hd: false }, { ty: "tm", s: { a: 1, k: [{ i: { x: [0], y: [1] }, o: { x: [0.333], y: [0] }, t: 6, s: [0] }, { t: 26.0000010590017, s: [100] }], ix: 1 }, e: { a: 1, k: [{ i: { x: [0], y: [1] }, o: { x: [0.333], y: [0] }, t: 0, s: [0] }, { t: 20.0000008146167, s: [100] }], ix: 2 }, o: { a: 0, k: 0, ix: 3 }, m: 1, ix: 2, nm: "Trim Paths 1", mn: "ADBE Vector Filter - Trim", hd: false }, { ty: "st", c: { a: 0, k: [1, 0.43529411764705883, 0.3803921568627451, 1], ix: 3 }, o: { a: 0, k: 100, ix: 4 }, w: { a: 0, k: 1.4, ix: 5 }, lc: 1, lj: 1, ml: 4, bm: 0, nm: "Stroke 1", mn: "ADBE Vector Graphic - Stroke", hd: false }, { ty: "tr", p: { a: 0, k: [-5.312, 11.555], ix: 2 }, a: { a: 0, k: [0, 0], ix: 1 }, s: { a: 0, k: [100, 100], ix: 3 }, r: { a: 0, k: 0, ix: 6 }, o: { a: 0, k: 100, ix: 7 }, sk: { a: 0, k: 0, ix: 4 }, sa: { a: 0, k: 0, ix: 5 }, nm: "Transform" }], nm: "Ellipse 1", np: 4, cix: 2, bm: 0, ix: 1, mn: "ADBE Vector Group", hd: false }], ip: 0, op: 30.0000012219251, st: 0, bm: 0 }], markers: [] };

// src/libs/assetLoader.ts
var assetCache = {
  "/animations/light/basic_loading_coral050.json": basic_loading_coral050_default2,
  "/animations/light/basic_loading_grey040.json": basic_loading_grey040_default2,
  "/animations/light/basic_loading_white.json": basic_loading_white_default2,
  "/animations/light/basic_loading_white_dim.json": basic_loading_white_dim_default2,
  "/animations/light/circular_loading_blue050.json": circular_loading_blue050_default2,
  "/animations/light/circular_loading_coral050.json": circular_loading_coral050_default2,
  "/animations/dark/basic_loading_blue050.json": basic_loading_blue050_default,
  "/animations/dark/basic_loading_coral050.json": basic_loading_coral050_default,
  "/animations/dark/basic_loading_grey040.json": basic_loading_grey040_default,
  "/animations/dark/basic_loading_white.json": basic_loading_white_default,
  "/animations/dark/basic_loading_white_dim.json": basic_loading_white_dim_default,
  "/animations/dark/circular_loading_blue050.json": circular_loading_blue050_default,
  "/animations/dark/circular_loading_coral050.json": circular_loading_coral050_default
};
var load = (key) => __async(void 0, null, function* () {
  if (assetCache[key]) {
    return Promise.resolve(assetCache[key]);
  }
  return fetch(ASSET_HOST_URL + key).then((data) => {
    assetCache[key] = data;
    return data;
  });
});
var assetLoader_default = {
  load
};

// src/iconDist/svgIcons.json
var svgIcons_default = {
  gr_icon_credit: {
    width: 24,
    height: 24,
    path: "M12,22C17.5228,22,22,17.5228,22,12C22,6.4771,17.5228,2,12,2C6.4771,2,2,6.4771,2,12C2,17.5228,6.4771,22,12,22zM12,15C13.1104,15,14.0799,14.3967,14.5986,13.5L16.331,14.5002C15.4664,15.9946,13.8506,17,12,17C9.2386,17,7,14.7614,7,12C7,9.2386,9.2386,7,12,7C13.8504,7,15.4661,8.0052,16.3307,9.4993L14.5984,10.4995C14.0796,9.6031,13.1102,9,12,9C10.3431,9,9,10.3431,9,12C9,13.6569,10.3431,15,12,15z"
  },
  ic12_24_chevron_right2: {
    width: 12,
    height: 24,
    path: "M3.4949,4.5051L11.2399,12.2501L3.4949,19.9951L2.505,19.0051L9.261,12.2501L2.505,5.4951L3.4949,4.5051z"
  },
  ic12_24_divider_vertical: {
    width: 12,
    height: 24,
    path: "M5,5H7V19H5z"
  },
  ic12_24_divider_vertical_small: {
    width: 12,
    height: 24,
    path: "M5.3,7H6.7V17H5.3z"
  },
  ic12_24_field_dash: {
    width: 12,
    height: 24,
    path: "M2,11H10V13H2z"
  },
  ic12_24_field_slash: {
    width: 12,
    height: 24,
    path: "M7,6H9L5,18H3L7,6z"
  },
  ic12_24_hidden_circle_fill: {
    width: 12,
    height: 24,
    path: "M2,12C2,9.7909,3.7909,8,6,8C8.2091,8,10,9.7909,10,12C10,14.2091,8.2091,16,6,16C3.7909,16,2,14.2091,2,12z"
  },
  ic12_24_hidden_star: {
    width: 12,
    height: 24,
    path: "M3.3072,2.8L4.6928,2L6,4.2641L7.3072,2L8.6928,2.8L7.3856,5.0641H10V6.6641H7.3856L8.6928,8.9282L7.3072,9.7282L6,7.4641L4.6928,9.7282L3.3072,8.9282L4.6144,6.6641H2V5.0641H4.6144L3.3072,2.8z"
  },
  ic12_24_hidden_star2: {
    width: 12,
    height: 24,
    path: "M2.634,8L4.366,7L6,9.8301L7.634,7L9.366,8L7.7321,10.8301H11V12.8301H7.7321L9.366,15.6603L7.634,16.6603L6,13.8301L4.366,16.6603L2.634,15.6603L4.2679,12.8301H1V10.8301H4.2679L2.634,8z"
  },
  ic12_24_hidden_wave: {
    width: 12,
    height: 24,
    path: "M10.5,10.3009C10.5,10.8614,10.4327,11.3687,10.2982,11.823C10.1637,12.2773,9.978,12.6652,9.7413,12.9867C9.5045,13.3083,9.222,13.5575,8.8937,13.7345C8.5655,13.9115,8.2049,14,7.8121,14C7.5915,14,7.387,13.9764,7.1986,13.9292C7.0103,13.882,6.826,13.8112,6.6457,13.7168C6.4655,13.6224,6.2879,13.5015,6.113,13.354C5.9381,13.2065,5.7538,13.0324,5.5601,12.8319C5.3341,12.59,5.1215,12.4056,4.9224,12.2788C4.7233,12.1519,4.5108,12.0885,4.2847,12.0885C4.1233,12.0885,3.978,12.1283,3.8489,12.208C3.7197,12.2876,3.6094,12.3982,3.5179,12.5398C3.4265,12.6814,3.3565,12.8481,3.3081,13.0398C3.2596,13.2316,3.2354,13.4395,3.2354,13.6637L1.5,13.646C1.5,13.0796,1.5659,12.5708,1.6978,12.1195C1.8296,11.6681,2.0126,11.2861,2.2466,10.9735C2.4807,10.6608,2.7619,10.4204,3.0901,10.2522C3.4184,10.0841,3.7789,10,4.1718,10C4.6076,10,5.0031,10.0959,5.3583,10.2876C5.7134,10.4794,6.074,10.7699,6.4399,11.1593C6.6713,11.4071,6.8839,11.5929,7.0776,11.7168C7.2713,11.8407,7.4758,11.9027,7.691,11.9027C7.8525,11.9027,7.9991,11.8614,8.1309,11.7788C8.2628,11.6962,8.3758,11.5826,8.47,11.4381C8.5641,11.2935,8.6381,11.1239,8.6919,10.9292C8.7457,10.7345,8.7727,10.5221,8.7727,10.292L10.5,10.3009z"
  },
  ic12_24_new: {
    width: 12,
    height: 24,
    path: "M3,5C3,3.3431,4.3431,2,6,2C7.6569,2,9,3.3431,9,5C9,6.6569,7.6569,8,6,8C4.3431,8,3,6.6569,3,5z"
  },
  ic12_24_plus: {
    width: 12,
    height: 24,
    path: "M7,7H5V11H1V13H5V17H7V13H11V11H7V7z"
  },
  ic12_warn_fill: {
    width: 12,
    height: 12,
    path: "M5.92,1.3333L0.6666,10.4319H11.1733L5.92,1.3333zM5.4893,7.6472H6.2893V4.8986H5.4893V7.6472zM5.4953,9.0546H6.2833V8.2659H5.4953V9.0546z"
  },
  ic18_precontract: {
    width: 18,
    height: 18,
    path: "M13.77,2V3.16H15.36V15.07H2V3.16H3.59V2H5.33V3.16H12.03V2H13.77zM3.14,13.93H14.21V5.89H3.14V13.93zM11.28,7.03L12.04,7.78L7.71,12.13L5.33,9.71L6.08,8.96L7.72,10.61L11.28,7.03z"
  },
  ic18_answer: {
    width: 18,
    height: 18,
    path: "M10.4015,10.4063L9.0005,6.1673L7.5645,10.4063H10.4015zM7.7505,3.0103H10.2495L14.6235,15.0003H11.7865L10.8575,12.3153H7.1255L6.2135,15.0003H3.3765L7.7505,3.0103z"
  },
  ic18_arrow_right: {
    width: 18,
    height: 18,
    path: "M13.2972,8.4001L10.0757,5.1786L10.9243,4.3301L15.5912,8.997L10.9243,13.6639L10.0757,12.8154L13.291,9.6001H2.5V8.4001H13.2972z"
  },
  ic18_arrow_round_trip: {
    width: 18,
    height: 18,
    path: "M10.1743,2.5757L15.6985,8.1H2.25V6.9H12.8015L9.3257,3.4243L10.1743,2.5757zM7.8257,15.4243L2.3015,9.9L15.75,9.9V11.1H5.1985L8.6743,14.5757L7.8257,15.4243z"
  },
  ic18_business: {
    width: 18,
    height: 18,
    path: "M7.7002,4.2375C7.7002,4.2295,7.7072,4.2225,7.7152,4.2225H10.3852C10.3932,4.2225,10.4002,4.2295,10.4002,4.2375V5.4225H7.7002V4.2375zM14.7032,5.4225H11.8002V3.8215C11.8002,3.2695,11.3522,2.8215,10.8002,2.8215H7.3002C6.7472,2.8215,6.3002,3.2695,6.3002,3.8215V5.4225H3.2972C2.7462,5.4225,2.3002,5.8685,2.3002,6.4195V14.5255C2.3002,15.0755,2.7462,15.5225,3.2972,15.5225H14.7032C15.2532,15.5225,15.7002,15.0755,15.7002,14.5255V6.4195C15.7002,5.8685,15.2532,5.4225,14.7032,5.4225V5.4225z"
  },
  ic18_car_front: {
    width: 18,
    height: 18,
    path: "M13.5548,2.6001H4.4444L1.75,8.1443V13.8601H2.873V14.0666C2.873,15.003,3.6324,15.7666,4.5701,15.7666H5.2566C6.194,15.7666,6.9545,15.0034,6.9545,14.0666V13.8916H11.0462V14.0666C11.0462,15.003,11.8056,15.7666,12.7433,15.7666H13.4291C14.3664,15.7666,15.127,15.0034,15.127,14.0666V13.8601H16.25V8.1443L13.5548,2.6001zM2.75,8.3744L5.0702,3.6001H12.9291L15.25,8.3744V12.8601H14.127V14.0666C14.127,14.4528,13.8125,14.7666,13.4291,14.7666H12.7433C12.3604,14.7666,12.0462,14.4532,12.0462,14.0666V12.8916H5.9545V14.0666C5.9545,14.4528,5.64,14.7666,5.2566,14.7666H4.5701C4.1872,14.7666,3.873,14.4532,3.873,14.0666V12.8601H2.75V8.3744zM12,10.5754C12,11.1282,12.4489,11.5754,13.0005,11.5754C13.552,11.5754,14,11.1282,14,10.5754C14,10.0227,13.552,9.5754,13.0005,9.5754C12.4489,9.5754,12,10.0227,12,10.5754zM5,11.5754C4.4482,11.5754,4,11.1282,4,10.5754C4,10.0227,4.4482,9.5754,5,9.5754C5.5527,9.5754,6,10.0227,6,10.5754C6,11.1282,5.5527,11.5754,5,11.5754zM14,8.5754H4L5.9451,4.5754H12.0541L14,8.5754zM12.4015,7.5754H5.5982L6.5708,5.5754H11.4286L12.4015,7.5754z"
  },
  ic18_car_front_fill: {
    width: 18,
    height: 18,
    path: "M13.2599,11.7589C12.8047,11.7589,12.4342,11.3899,12.4342,10.9339C12.4342,10.4779,12.8047,10.1089,13.2599,10.1089C13.7152,10.1089,14.0849,10.4779,14.0849,10.9339C14.0849,11.3899,13.7152,11.7589,13.2599,11.7589V11.7589zM4.4549,9.0927L6.3089,5.1702H12.1319L13.9867,9.0927H4.4549zM5.1854,11.7589C4.7302,11.7589,4.3604,11.3899,4.3604,10.9339C4.3604,10.4779,4.7302,10.1089,5.1854,10.1089C5.6414,10.1089,6.0104,10.4779,6.0104,10.9339C6.0104,11.3899,5.6414,11.7589,5.1854,11.7589V11.7589zM13.4369,3.5247H9.2182H9.1559H4.9372L2.4254,8.6839V13.7847H3.5504V14.4912C3.5504,15.1527,4.0882,15.6912,4.7497,15.6912H5.4374C6.0989,15.6912,6.6374,15.1527,6.6374,14.4912V13.8162H9.1559H9.2182H11.7382V14.4912C11.7382,15.1527,12.2759,15.6912,12.9374,15.6912H13.6244C14.2859,15.6912,14.8244,15.1527,14.8244,14.4912V13.7847H15.9494V8.6839L13.4369,3.5247z"
  },
  ic18_check_on: {
    width: 18,
    height: 18,
    path: "M5.1476,9.5378L6.1266,8.5598L8.0116,10.4468L11.8296,6.6298L12.8056,7.6078L8.0116,12.4018L5.1476,9.5378zM16.2046,9.1018C16.2046,5.1858,13.0186,1.9998,9.1026,1.9998C5.1856,1.9998,2.0006,5.1858,2.0006,9.1018C2.0006,13.0178,5.1856,16.2048,9.1026,16.2048C13.0186,16.2048,16.2046,13.0178,16.2046,9.1018V9.1018z"
  },
  ic18_checkonly_on: {
    width: 18,
    height: 18,
    path: "M14.958,5L7.538,12.419L3.848,8.728L3,9.577L7.538,14.116L15.807,5.849L14.958,5z"
  },
  ic18_chevron_left: {
    width: 18,
    height: 18,
    path: "M10.495,13.49L11.485,12.5L7.979,8.995L11.485,5.49L10.495,4.5L6,8.995L10.495,13.49z"
  },
  ic18_chevron_less: {
    width: 18,
    height: 18,
    path: "M4.5,10.6951L5.49,11.6851L8.995,8.1791L12.5,11.6851L13.49,10.6951L8.995,6.2001L4.5,10.6951z"
  },
  ic18_chevron_more: {
    width: 18,
    height: 18,
    path: "M13.49,7.3899L12.5,6.3999L8.995,9.9059L5.49,6.3999L4.5,7.3899L8.995,11.8849L13.49,7.3899z"
  },
  ic18_chevron_right: {
    width: 18,
    height: 18,
    path: "M7.49,4.5L6.5,5.49L10.005,8.995L6.5,12.5L7.49,13.49L11.985,8.995L7.49,4.5z"
  },
  ic18_close: {
    width: 18,
    height: 18,
    path: "M13.5,3.5L8.924,8.076L4.349,3.5L3.5,4.349L8.076,8.924L3.5,13.5L4.349,14.349L8.924,9.773L13.5,14.349L14.349,13.5L9.773,8.924L14.349,4.349L13.5,3.5z"
  },
  ic18_credit: {
    width: 18,
    height: 18,
    path: "M9,16.5C13.1421,16.5,16.5,13.1421,16.5,9C16.5,4.8579,13.1421,1.5,9,1.5C4.8579,1.5,1.5,4.8579,1.5,9C1.5,13.1421,4.8579,16.5,9,16.5zM5.7542,7.5832C5.5847,8.0209,5.5,8.4692,5.5,8.9281C5.5,9.4081,5.5918,9.8811,5.7753,10.3471C5.9589,10.8059,6.2166,11.2225,6.5484,11.5966C6.8873,11.9637,7.2862,12.2602,7.7451,12.4861C8.211,12.705,8.7229,12.8144,9.2806,12.8144C9.7113,12.8144,10.1455,12.7473,10.5832,12.6132C11.0209,12.472,11.4128,12.2708,11.7587,12.0096C12.1046,11.7484,12.3517,11.4342,12.5,11.0671L10.8162,10.0611C10.7315,10.2871,10.6079,10.4671,10.4455,10.6012C10.2832,10.7353,10.1031,10.8342,9.9055,10.8977C9.7078,10.9542,9.5136,10.9824,9.323,10.9824C9.0547,10.9824,8.8111,10.9295,8.5923,10.8236C8.3805,10.7177,8.2005,10.573,8.0522,10.3894C7.9039,10.1988,7.791,9.9835,7.7133,9.7435C7.6357,9.5034,7.5968,9.2528,7.5968,8.9916C7.5968,8.7586,7.6286,8.5257,7.6921,8.2927C7.7627,8.0597,7.8651,7.8479,7.9992,7.6573C8.1404,7.4667,8.3169,7.3149,8.5287,7.202C8.7476,7.082,9.0053,7.022,9.3018,7.022C9.4924,7.022,9.6866,7.0502,9.8843,7.1067C10.089,7.1561,10.2761,7.2479,10.4455,7.382C10.622,7.5161,10.7562,7.7068,10.848,7.9538L12.4259,6.8314C12.1646,6.3372,11.7658,5.9418,11.2292,5.6453C10.6926,5.3418,10.0643,5.19,9.3442,5.19C8.7441,5.19,8.204,5.2994,7.7239,5.5183C7.2509,5.7301,6.8485,6.016,6.5166,6.376C6.1848,6.7361,5.9307,7.1385,5.7542,7.5832z"
  },
  ic18_delete: {
    width: 18,
    height: 18,
    path: "M6.6862,2.7678L7.4542,1.9998H11.2932L12.0602,2.7678H14.7472V4.3028H4.0002V2.7678H6.6862zM13.98,15.6303H4.768V5.1553H13.98V15.6303zM11.735,14.0963H10.659V6.9413H11.735V14.0963zM6.94,14.0963H8.016V6.9413H6.94V14.0963z"
  },
  ic18_delete_field: {
    width: 18,
    height: 18,
    path: "M12.316,11.4671L11.467,12.3161L8.951,9.8001L6.435,12.3161L5.587,11.4671L8.103,8.9511L5.587,6.4351L6.435,5.5861L8.951,8.1021L11.467,5.5861L12.316,6.4351L9.8,8.9511L12.316,11.4671zM8.951,1.6001C4.898,1.6001,1.6,4.8981,1.6,8.9511C1.6,13.0041,4.898,16.3021,8.951,16.3021C13.004,16.3021,16.302,13.0041,16.302,8.9511C16.302,4.8981,13.004,1.6001,8.951,1.6001V1.6001z"
  },
  ic18_delivery: {
    width: 18,
    height: 18,
    path: "M9.0002,2.9998C12.3132,2.9998,15.0002,5.6868,15.0002,8.9998C15.0002,12.3138,12.3132,14.9998,9.0002,14.9998C5.6862,14.9998,3.0002,12.3138,3.0002,8.9998C3.0002,5.6868,5.6862,2.9998,9.0002,2.9998M9.0002,6.7498C7.7572,6.7498,6.7502,7.7568,6.7502,8.9998C6.7502,10.2428,7.7572,11.2498,9.0002,11.2498C10.2422,11.2498,11.2502,10.2428,11.2502,8.9998C11.2502,7.7568,10.2422,6.7498,9.0002,6.7498"
  },
  ic18_description_dash: {
    width: 18,
    height: 18,
    path: "M7,8H11V10H7z"
  },
  ic18_description_dash2: {
    width: 18,
    height: 18,
    path: "M8,8H10V10H8z"
  },
  ic18_description_line: {
    width: 18,
    height: 18,
    path: "M6,6V12.5H12.5V11.5H7V6H6z"
  },
  ic18_electricity: {
    width: 18,
    height: 18,
    path: "M9,14.2002V11.8002H6.7L9,8.0002V10.4002H11.3L9,14.2002zM6,6.2002H12V3.7002H6V6.2002zM4,16.3002H14V1.7002H4V16.3002z"
  },
  ic18_fast_off: {
    width: 18,
    height: 18,
    path: "M3.4,3.46L2.7,4.16L5.73,7.19L3.5,10.8H9V16.1L11.13,12.59L13.75,15.21L14.45,14.51L3.4,3.46zM14.4,7.1999H9V1.8999L6.8,5.4599L12.19,10.8399L14.4,7.1999z"
  },
  ic18_fast_on: {
    width: 18,
    height: 18,
    path: "M9,7.1L8.99,1.77L3.5,10.7H9L8.99,16L14.4,7.1H9z"
  },
  ic18_help: {
    width: 18,
    height: 18,
    path: "M9,4.553C7.47,4.553,6.225,5.798,6.225,7.328H7.425C7.425,6.46,8.132,5.753,9,5.753C9.869,5.753,10.575,6.46,10.575,7.328C10.575,8.197,9.869,8.903,9,8.903H8.4V11.324H9.6V10.038C10.843,9.763,11.775,8.653,11.775,7.328C11.775,5.798,10.53,4.553,9,4.553V4.553zM9,15.5C5.416,15.5,2.5,12.584,2.5,9C2.5,5.415,5.416,2.5,9,2.5C12.584,2.5,15.5,5.415,15.5,9C15.5,12.584,12.584,15.5,9,15.5V15.5zM9,1.5C4.858,1.5,1.5,4.858,1.5,9C1.5,13.142,4.858,16.5,9,16.5C13.143,16.5,16.5,13.142,16.5,9C16.5,4.858,13.143,1.5,9,1.5V1.5zM8.4,13.574H9.6V12.399H8.4V13.574z"
  },
  ic18_hot: {
    width: 18,
    height: 18,
    path: "M10.9599,1.54C10.9599,1.54,6.7999,3,6.7999,7.5C6.46,7.2,5.7,6.2,6.0999,5C6.0999,5,3.6,7.1,3.71,11C3.79,13.92,6.08,16.3,9,16.3C11.9199,16.3,14.2899,13.93,14.2899,11.01C14.2999,7.4,9.5,4.4,10.9599,1.54zM10.8999,12.61C10.8999,13.66,10.0499,14.5,9.0099,14.5C7.96,14.5,7.12,13.65,7.12,12.61C7.12,12.61,7.12,12.61,7.12,12.6C7.0999,10.7,8.5,9,9.3,8.5C9.1199,10.33,10.5899,10.75,10.8499,12.18C10.8799,12.31,10.8999,12.44,10.8999,12.58C10.8999,12.58,10.8999,12.59,10.8999,12.61C10.8999,12.6,10.8999,12.6,10.8999,12.61z"
  },
  ic18_info_fill: {
    width: 18,
    height: 18,
    path: "M9.1,1.8C5.2,1.8,2.1,4.9001,2.1,8.8001C2.1,12.7,5.2,15.8,9.1,15.8C13,15.8,16.1,12.7,16.1,8.8001C16.1,4.9001,12.9,1.8,9.1,1.8zM9.7,13H8.5V7H9.7V13zM9.7,5.8H8.5V4.6001H9.7V5.8z"
  },
  ic18_info_line: {
    width: 18,
    height: 18,
    path: "M9,3C12.3,3,15,5.7,15,9C15,12.3,12.3,15,9,15C5.7,15,3,12.3,3,9C3,5.7,5.7,3,9,3zM9,2C5.1,2,2,5.1,2,9C2,12.9,5.1,16,9,16C12.9,16,16,12.9,16,9C16,5.1,12.9,2,9,2zM9.6,7.2H8.4V13H9.6V7.2zM9.6,5H8.4V6.2H9.6V5z"
  },
  ic18_key_return: {
    width: 18,
    height: 18,
    path: "M13.476,12.9815C13.528,12.9225,13.577,12.8615,13.626,12.8005C13.705,12.7075,13.783,12.6115,13.855,12.5125C13.885,12.4695,13.912,12.4245,13.942,12.3815C14,12.2945,14.059,12.2095,14.113,12.1195C14.619,11.2895,14.934,10.3295,14.985,9.2995H13.769C13.611,11.8045,11.544,13.7995,9,13.7995C6.353,13.7995,4.2,11.6465,4.2,9.0005C4.2,6.3535,6.353,4.2005,9,4.2005C10.185,4.2005,11.26,4.6445,12.095,5.3615C11.289,6.1725,10.572,6.8965,10.554,6.9145H14.346V3.0945C14.346,3.0945,13.705,3.7395,12.953,4.4985C11.896,3.5685,10.515,3.0005,9,3.0005C5.691,3.0005,3,5.6915,3,9.0005C3,12.3085,5.691,15.0005,9,15.0005C10.773,15.0005,12.364,14.2245,13.461,12.9975C13.466,12.9915,13.471,12.9865,13.476,12.9815"
  },
  ic18_letter_b: {
    width: 18,
    height: 18,
    path: "M11.0988,11.366C11.0988,10.994,10.9908,10.679,10.7778,10.42C10.5628,10.16,10.2928,10.031,9.9668,10.031H6.7718V12.65H9.8488C10.2078,12.65,10.5068,12.532,10.7438,12.296C10.9798,12.059,11.0988,11.749,11.0988,11.366V11.366zM6.7718,5.366V7.85H9.4938C9.7968,7.85,10.0678,7.749,10.3048,7.546C10.5408,7.344,10.6588,7.028,10.6588,6.6C10.6588,6.206,10.5548,5.901,10.3468,5.687C10.1378,5.473,9.8868,5.366,9.5948,5.366H6.7718zM13.9208,11.924C13.9208,12.442,13.8138,12.893,13.5998,13.276C13.3858,13.659,13.0928,13.977,12.7208,14.231C12.3488,14.484,11.9148,14.677,11.4198,14.805C10.9238,14.935,10.3998,15,9.8488,15H3.9998V3H10.6768C11.0928,3,11.4698,3.09,11.8078,3.27C12.1468,3.45,12.4338,3.684,12.6698,3.971C12.9078,4.259,13.0898,4.586,13.2198,4.952C13.3488,5.318,13.4138,5.693,13.4138,6.076C13.4138,6.65,13.2698,7.192,12.9828,7.699C12.6958,8.205,12.2648,8.589,11.6898,8.847C12.3778,9.051,12.9208,9.411,13.3208,9.929C13.7208,10.448,13.9208,11.113,13.9208,11.924V11.924z"
  },
  ic18_letter_c: {
    width: 18,
    height: 18,
    path: "M3.3032,8.8628C3.3032,8.1378,3.4392,7.4158,3.7112,6.6958C3.9832,5.9768,4.3802,5.3328,4.9012,4.7668C5.4222,4.1998,6.0572,3.7408,6.8042,3.3898C7.5522,3.0388,8.4022,2.8628,9.3542,2.8628C10.4872,2.8628,11.4702,3.1068,12.3032,3.5938C13.1362,4.0808,13.7562,4.7158,14.1642,5.4978L12.0232,6.9928C11.8862,6.6758,11.7142,6.4128,11.5042,6.2028C11.2942,5.9928,11.0642,5.8228,10.8162,5.6938C10.5662,5.5628,10.3112,5.4718,10.0512,5.4208C9.7902,5.3698,9.5352,5.3438,9.2862,5.3438C8.7532,5.3438,8.2882,5.4518,7.8922,5.6678C7.4952,5.8828,7.1672,6.1598,6.9072,6.4998C6.6462,6.8408,6.4532,7.2248,6.3282,7.6558C6.2042,8.0868,6.1422,8.5228,6.1422,8.9648C6.1422,9.4408,6.2152,9.8998,6.3632,10.3418C6.5102,10.7828,6.7222,11.1748,7.0002,11.5138C7.2772,11.8538,7.6122,12.1238,8.0032,12.3208C8.3942,12.5198,8.8332,12.6188,9.3202,12.6188C9.5692,12.6188,9.8262,12.5878,10.0942,12.5258C10.3592,12.4628,10.6152,12.3668,10.8582,12.2368C11.1012,12.1068,11.3252,11.9358,11.5292,11.7268C11.7332,11.5168,11.8972,11.2588,12.0232,10.9528L14.3002,12.2958C14.1182,12.7378,13.8492,13.1348,13.4932,13.4858C13.1362,13.8368,12.7252,14.1318,12.2602,14.3698C11.7952,14.6078,11.3032,14.7888,10.7822,14.9138C10.2602,15.0378,9.7512,15.0998,9.2522,15.0998C8.3792,15.0998,7.5782,14.9218,6.8472,14.5648C6.1162,14.2078,5.4882,13.7348,4.9602,13.1458C4.4332,12.5568,4.0252,11.8878,3.7372,11.1398C3.4482,10.3918,3.3032,9.6338,3.3032,8.8628"
  },
  ic18_letter_d: {
    width: 18,
    height: 18,
    path: "M11.7822,8.9835C11.7822,8.4545,11.7122,7.9735,11.5712,7.5405C11.4302,7.1075,11.2252,6.7335,10.9552,6.4185C10.6852,6.1035,10.3532,5.8605,9.9592,5.6925C9.5662,5.5245,9.1212,5.4395,8.6262,5.4395H6.9222V12.5605H8.6262C9.1332,12.5605,9.5832,12.4705,9.9772,12.2915C10.3702,12.1105,10.6992,11.8605,10.9632,11.5395C11.2282,11.2195,11.4302,10.8425,11.5712,10.4095C11.7122,9.9765,11.7822,9.5005,11.7822,8.9835V8.9835zM4.1552,14.9905V3.0095H8.6262C9.6162,3.0095,10.4832,3.1675,11.2252,3.4825C11.9682,3.7965,12.5892,4.2245,13.0902,4.7645C13.5912,5.3045,13.9672,5.9375,14.2202,6.6635C14.4742,7.3885,14.6002,8.1625,14.6002,8.9835C14.6002,9.8945,14.4592,10.7185,14.1782,11.4555C13.8972,12.1915,13.4942,12.8215,12.9712,13.3455C12.4492,13.8685,11.8182,14.2735,11.0822,14.5605C10.3452,14.8475,9.5262,14.9905,8.6262,14.9905H4.1552z"
  },
  ic18_letter_e: {
    width: 18,
    height: 18,
    path: "M13.499,12.566V15H4.501V3H13.499V5.433H7.272V7.766H12.722V10.014H7.272V12.566H13.499z"
  },
  ic18_minus: {
    width: 18,
    height: 18,
    path: "M15,9.5999H3V8.3999H15V9.5999z"
  },
  ic18_noti: {
    width: 18,
    height: 18,
    path: "M13.5427,13.2562L10.9717,13.251H10.971L9.1117,13.2472L4.6507,13.2375L4.662,7.8585C4.6672,5.4105,6.66,3.4222,9.1072,3.4222C9.1117,3.4222,9.1177,3.4222,9.1177,3.4222C10.305,3.4245,11.4202,3.8895,12.258,4.731C13.0965,5.5725,13.557,6.69,13.554,7.8772L13.5427,13.2562zM9.0945,15.1222H9.0922C8.5395,15.1207,8.067,14.7854,7.8593,14.3084L10.3298,14.3137C10.1198,14.7892,9.6457,15.1222,9.0945,15.1222V15.1222zM14.5928,13.2607L14.604,7.8795C14.607,6.4117,14.0385,5.0302,13.002,3.99C12.0968,3.0802,10.9283,2.5267,9.6675,2.4V1.5H8.5657V2.3992C5.7945,2.6723,3.618,5.013,3.612,7.8563L3.6008,13.2383L2.253,13.2353L2.25,14.2972L6.7605,14.3063C6.8595,14.7413,7.0725,15.1425,7.395,15.4658C7.8465,15.9203,8.4488,16.1707,9.09,16.1722H9.0953C10.23,16.1722,11.1795,15.378,11.4278,14.3168L15.9608,14.3257L15.9637,13.2638L14.5928,13.2607z"
  },
  ic18_num_01: {
    width: 18,
    height: 18,
    path: "M2.5,9.05C2.5,5.438,5.439,2.5,9.05,2.5C12.662,2.5,15.6,5.438,15.6,9.05C15.6,12.662,12.662,15.6,9.05,15.6C5.439,15.6,2.5,12.662,2.5,9.05zM1.5,9.05C1.5,13.213,4.887,16.6,9.05,16.6C13.213,16.6,16.6,13.213,16.6,9.05C16.6,4.887,13.213,1.5,9.05,1.5C4.887,1.5,1.5,4.887,1.5,9.05zM8.8036,6.6704H8.8356V13.0994H10.1946V5.3494H8.8246L6.7996,6.7724V8.0454L8.8036,6.6704z"
  },
  ic18_num_02: {
    width: 18,
    height: 18,
    path: "M2.5,9.05C2.5,5.438,5.438,2.5,9.05,2.5C12.661,2.5,15.6,5.438,15.6,9.05C15.6,12.662,12.661,15.6,9.05,15.6C5.438,15.6,2.5,12.662,2.5,9.05zM1.5,9.05C1.5,13.213,4.887,16.6,9.05,16.6C13.213,16.6,16.6,13.213,16.6,9.05C16.6,4.887,13.213,1.5,9.05,1.5C4.887,1.5,1.5,4.887,1.5,9.05zM11.7035,6.9192C11.7035,5.6732,10.6505,4.7002,9.0715,4.7002C7.4605,4.7002,6.3005,5.7252,6.3005,7.1712H7.5995C7.5995,6.3822,8.2335,5.8112,9.0715,5.8112C9.8395,5.8112,10.3495,6.3272,10.3495,7.0052C10.3495,7.5852,10.1245,7.9712,9.1145,8.9652L6.3755,11.6612V12.6062H11.8215V11.4732H8.2065V11.4462L9.9145,9.7702C11.2685,8.4382,11.7035,7.8372,11.7035,6.9192z"
  },
  ic18_num_03: {
    width: 18,
    height: 18,
    path: "M2.5,9.05C2.5,5.438,5.439,2.5,9.05,2.5C12.662,2.5,15.6,5.438,15.6,9.05C15.6,12.662,12.662,15.6,9.05,15.6C5.439,15.6,2.5,12.662,2.5,9.05zM1.5,9.05C1.5,13.213,4.887,16.6,9.05,16.6C13.213,16.6,16.6,13.213,16.6,9.05C16.6,4.887,13.213,1.5,9.05,1.5C4.887,1.5,1.5,4.887,1.5,9.05zM8.9384,8.5195H8.0524V9.5505H8.9704C9.9644,9.5505,10.5664,10.0115,10.5604,10.8395C10.5604,11.5485,9.9534,12.0475,9.0674,12.0475C8.1494,12.0475,7.5314,11.5855,7.4774,10.8825H6.1514C6.2204,12.2515,7.3704,13.1815,9.0674,13.1815C10.7644,13.1815,11.9684,12.2465,11.9684,10.8715C11.9684,9.7915,11.2104,9.1045,10.0664,8.9975V8.9705C11.0014,8.7775,11.6944,8.1325,11.6944,7.1545C11.6944,5.9565,10.6624,5.1195,9.0564,5.1195C7.4994,5.1195,6.4084,5.9995,6.3174,7.3855H7.6064C7.6554,6.6555,8.2404,6.2205,9.0564,6.2205C9.9104,6.2205,10.3624,6.6605,10.3624,7.3425C10.3624,8.0305,9.7924,8.5195,8.9384,8.5195z"
  },
  ic18_oil: {
    width: 18,
    height: 18,
    path: "M10.4414,12.792C10.1414,13.275,9.6104,13.6,9.0004,13.6C8.3894,13.6,7.8584,13.275,7.5584,12.792C7.3974,12.532,7.2994,12.229,7.2994,11.9C7.2994,11.713,7.3304,11.527,7.3914,11.35C7.4514,11.174,7.5464,11.016,7.6394,10.855C7.7324,10.693,7.8244,10.531,7.9174,10.37C8.0364,10.164,8.9644,8.563,9.0004,8.5C9.0354,8.563,9.9634,10.164,10.0824,10.37C10.1754,10.531,10.2684,10.693,10.3604,10.855C10.4534,11.016,10.5484,11.174,10.6084,11.35C10.6694,11.527,10.7004,11.713,10.7004,11.9C10.7004,12.229,10.6024,12.532,10.4414,12.792V12.792zM6.0004,6.2H12.0004V3.6999H6.0004V6.2zM4.0004,16.3H14.0004V1.7H4.0004V16.3z"
  },
  ic18_parking: {
    width: 18,
    height: 18,
    path: "M7.1475,8.8746H10.0405C10.3885,8.8746,10.6875,8.7256,10.9395,8.4256C11.1905,8.1256,11.3165,7.6886,11.3165,7.1136C11.3165,6.8146,11.2775,6.5566,11.1995,6.3406C11.1215,6.1246,11.0175,5.9446,10.8855,5.8016C10.7535,5.6576,10.6045,5.5526,10.4365,5.4866C10.2685,5.4216,10.1005,5.3886,9.9335,5.3886H7.1475V8.8746zM4.2005,15.2996V2.7996H10.1305C10.7415,2.7996,11.3015,2.9256,11.8115,3.1776C12.3195,3.4296,12.7575,3.7586,13.1225,4.1666C13.4885,4.5736,13.7755,5.0356,13.9855,5.5496C14.1955,6.0656,14.2995,6.5866,14.2995,7.1136C14.2995,7.6766,14.2015,8.2156,14.0035,8.7306C13.8055,9.2466,13.5295,9.7076,13.1765,10.1146C12.8235,10.5226,12.3955,10.8456,11.8915,11.0846C11.3885,11.3256,10.8315,11.4446,10.2205,11.4446H7.1475V15.2996H4.2005z"
  },
  ic18_person: {
    width: 18,
    height: 18,
    path: "M10.75,6C10.75,7.1046,9.8546,8,8.75,8C7.6454,8,6.75,7.1046,6.75,6C6.75,4.8954,7.6454,4,8.75,4C9.8546,4,10.75,4.8954,10.75,6zM11.75,6C11.75,7.6569,10.4069,9,8.75,9C7.0931,9,5.75,7.6569,5.75,6C5.75,4.3431,7.0931,3,8.75,3C10.4069,3,11.75,4.3431,11.75,6zM16,15H2L6,11H12L16,15zM13.5858,14H4.4142L6.4142,12H11.5858L13.5858,14z"
  },
  ic18_phone_fill: {
    width: 12,
    height: 15,
    path: "M1.7138,1.4992C1.7138,1.4992-1.1272,3.9067,2.9468,10.3747L3.0061,10.4692C7.0808,16.9387,9.9428,14.5649,9.9428,14.5649L11.1353,13.5637L8.7346,9.7522L7.5413,10.752C7.5413,10.752,6.6338,11.7307,4.8601,8.9152L4.8008,8.8215C3.0278,6.006,4.1153,5.3114,4.1153,5.3114L5.3078,4.3117L2.907,0.4995L1.7138,1.4992z"
  },
  ic18_pick_fill: {
    width: 18,
    height: 18,
    path: "M14.6624,15.6752L8.9999,10.1252L3.3374,15.6752V2.2502H14.6624V15.6752z"
  },
  ic18_plus: {
    width: 18,
    height: 18,
    path: "M8.4,9.6V15H9.6V9.6H15V8.4H9.6V3H8.4V8.4H3V9.6H8.4z"
  },
  ic18_poi: {
    width: 18,
    height: 18,
    path: "M8.9897,2.005L9.03,1.0058L9.0298,1.0058L8.9897,2.005zM4.4807,11.655L5.2562,11.0237L5.2546,11.0217L4.4807,11.655zM8.7217,16.865L7.9462,17.4963L8.7178,18.4443L9.4941,17.5001L8.7217,16.865zM13.0057,11.655L13.7782,12.2902L13.7856,12.281L13.0057,11.655zM15.1068,5.6088C14.1695,3.069,11.8397,1.1192,9.03,1.0058L8.9494,3.0042C10.8497,3.0809,12.5359,4.4191,13.2305,6.3012L15.1068,5.6088zM9.0298,1.0058C5.1752,0.8509,1.9997,3.9311,1.9997,7.752H3.9997C3.9997,5.0629,6.2342,2.8951,8.9495,3.0042L9.0298,1.0058zM1.9997,7.752C1.9997,9.5443,2.727,11.091,3.7068,12.2883L5.2546,11.0217C4.4964,10.0951,3.9997,8.9818,3.9997,7.752H1.9997zM3.7052,12.2863L7.9462,17.4963L9.4972,16.2337L5.2562,11.0237L3.7052,12.2863zM9.4941,17.5001L13.7781,12.2901L12.2333,11.0199L7.9493,16.2299L9.4941,17.5001zM13.7856,12.281C14.4766,11.42,15.0725,10.4478,15.3581,9.3245C15.6484,8.1827,15.6015,6.9502,15.1069,5.609L13.2305,6.301C13.5929,7.2838,13.605,8.1033,13.4198,8.8316C13.2299,9.5782,12.8158,10.294,12.2258,11.0291L13.7856,12.281zM8.7517,10.061C7.4717,10.061,6.4347,9.023,6.4347,7.7431C6.4347,6.463,7.4717,5.425,8.7517,5.425C10.0317,5.425,11.0697,6.463,11.0697,7.7431C11.0697,9.023,10.0317,10.061,8.7517,10.061"
  },
  ic18_poi_fill: {
    width: 18,
    height: 18,
    path: "M8.7517,10.061C7.4717,10.061,6.4347,9.023,6.4347,7.743C6.4347,6.463,7.4717,5.425,8.7517,5.425C10.0317,5.425,11.0697,6.463,11.0697,7.743C11.0697,9.023,10.0317,10.061,8.7517,10.061M14.1687,5.955C13.3527,3.744,11.3447,2.1,8.9897,2.005C5.7047,1.873,2.9997,4.497,2.9997,7.752C2.9997,9.263,3.6117,10.593,4.4807,11.655L8.7217,16.865L13.0057,11.655C14.2867,10.059,15.0257,8.279,14.1687,5.955"
  },
  ic18_premium: {
    width: 18,
    height: 18,
    path: "M9,15.3802L12.08,7.2002H5.92L9,15.3802zM1.77,7.2002L7.89,15.2702L4.85,7.2002H1.77zM11.96,6.2001L10.4,3.3301H7.6L6.04,6.2001H11.96zM4.9,6.2001L6.47,3.3301H4.44L1.84,6.2001H4.9zM13.1,6.2001H16.23L13.56,3.3301H11.53L13.1,6.2001zM13.15,7.2002L10.11,15.2602L16.32,7.2002H13.15z"
  },
  ic18_question: {
    width: 18,
    height: 18,
    path: "M8.9292,12.7291C9.4002,12.7291,9.8112,12.6531,10.1642,12.5001L8.1532,10.2761H10.8702L11.6472,11.1411C11.8352,10.8121,11.9762,10.4581,12.0712,10.0821C12.1642,9.7061,12.2112,9.3241,12.2112,8.9351C12.2112,8.4531,12.1412,7.9851,12.0002,7.5321C11.8582,7.0801,11.6472,6.6791,11.3642,6.3321C11.0822,5.9851,10.7382,5.7061,10.3322,5.4941C9.9262,5.2821,9.4592,5.1761,8.9292,5.1761C8.3762,5.1761,7.8972,5.2851,7.4912,5.5031C7.0852,5.7211,6.7432,6.0091,6.4682,6.3671C6.1912,6.7271,5.9852,7.1321,5.8492,7.5851C5.7142,8.0381,5.6472,8.5001,5.6472,8.9701C5.6472,9.4531,5.7182,9.9211,5.8592,10.3731C5.9992,10.8261,6.2082,11.2261,6.4852,11.5731C6.7612,11.9201,7.1052,12.2001,7.5172,12.4121C7.9292,12.6231,8.4002,12.7291,8.9292,12.7291V12.7291zM11.9652,14.5121C11.5172,14.7591,11.0382,14.9531,10.5262,15.0941C10.0142,15.2341,9.4762,15.3051,8.9112,15.3051C7.9822,15.3051,7.1352,15.1261,6.3702,14.7681C5.6052,14.4081,4.9522,13.9321,4.4112,13.3381C3.8702,12.7441,3.4502,12.0641,3.1502,11.2991C2.8502,10.5351,2.7002,9.7471,2.7002,8.9351C2.7002,8.1121,2.8562,7.3171,3.1672,6.5521C3.4792,5.7881,3.9142,5.1121,4.4732,4.5231C5.0322,3.9361,5.6942,3.4681,6.4582,3.1211C7.2232,2.7731,8.0582,2.6001,8.9652,2.6001C9.8942,2.6001,10.7412,2.7851,11.5062,3.1561C12.2702,3.5261,12.9232,4.0111,13.4652,4.6121C14.0052,5.2121,14.4232,5.8941,14.7182,6.6581C15.0112,7.4241,15.1582,8.2001,15.1582,8.9881C15.1582,9.7881,15.0172,10.5531,14.7352,11.2821C14.4522,12.0121,14.0532,12.6641,13.5352,13.2411L15.3352,15.2171H12.6172L11.9652,14.5121z"
  },
  ic18_reset: {
    width: 18,
    height: 18,
    path: "M12.661,10.3021L10.909,8.5491H12.114C12.031,7.8381,11.726,7.2031,11.229,6.7071C10.636,6.1131,9.844,5.7851,9.001,5.7851C8.158,5.7851,7.366,6.1131,6.772,6.7071C6.624,6.8561,6.485,7.0291,6.359,7.2231L6.292,7.3261L5.5,6.5341L5.549,6.4661C5.695,6.2611,5.846,6.0811,5.996,5.9311C6.799,5.1281,7.866,4.6861,9.001,4.6861C10.136,4.6861,11.203,5.1281,12.006,5.9301C12.71,6.6351,13.141,7.5611,13.228,8.5491H14.413L12.661,10.3021zM12.451,11.4091C12.305,11.6121,12.156,11.7911,12.006,11.9411C11.203,12.7431,10.136,13.1851,9.001,13.1851C7.866,13.1851,6.799,12.7431,5.996,11.9411C5.29,11.2341,4.857,10.3041,4.773,9.3151H3.574L5.327,7.5621L7.079,9.3151H5.889C5.972,10.0301,6.275,10.6671,6.772,11.1641C7.366,11.7591,8.158,12.0861,9.001,12.0861C9.844,12.0861,10.636,11.7591,11.229,11.1641C11.374,11.0201,11.512,10.8471,11.64,10.6511L11.707,10.5481L12.5,11.3401L12.451,11.4091zM8.971,1.6001C4.907,1.6001,1.6,4.9071,1.6,8.9711C1.6,13.0351,4.907,16.3421,8.971,16.3421C13.035,16.3421,16.342,13.0351,16.342,8.9711C16.342,4.9071,13.035,1.6001,8.971,1.6001V1.6001z"
  },
  ic18_return: {
    width: 18,
    height: 18,
    path: "M15.7372,9H14.793C14.7938,9.0352,14.7983,9.069,14.7983,9.105C14.7983,12.3038,12.1957,14.9062,8.9962,14.9062C5.7975,14.9062,3.1942,12.3038,3.1942,9.105C3.1942,5.9055,5.7975,3.303,8.9962,3.303C10.44,3.303,11.7585,3.8363,12.7747,4.7123C11.7705,5.7225,10.8337,6.666,10.8127,6.6878H15.219V2.25C15.219,2.25,14.3827,3.0922,13.4392,4.0425C12.252,2.9992,10.7017,2.3588,8.9962,2.3588C5.2702,2.3588,2.25,5.379,2.25,9.105C2.25,12.8303,5.2702,15.8513,8.9962,15.8513C12.7222,15.8513,15.7425,12.8303,15.7425,9.105C15.7425,9.069,15.738,9.0352,15.7372,9"
  },
  ic18_sale: {
    width: 18,
    height: 18,
    path: "M11.04,10.48C10.73,10.48,10.4799,10.73,10.4799,11.04C10.4799,11.35,10.73,11.6,11.04,11.6C11.35,11.6,11.6,11.35,11.6,11.04C11.6,10.73,11.35,10.48,11.04,10.48zM6.96,7.5199C7.2692,7.5199,7.52,7.2692,7.52,6.9599C7.52,6.6506,7.2692,6.3999,6.96,6.3999C6.6507,6.3999,6.4,6.6506,6.4,6.9599C6.4,7.2692,6.6507,7.5199,6.96,7.5199zM2.1999,3V7V7.2C3.19,7.2,4,8.01,4,9C4,9.99,3.19,10.8,2.1999,10.8V11V15H15.8V11V10.8C14.81,10.8,14,9.99,14,9C14,8.01,14.81,7.2,15.8,7.2V7V3H2.1999zM6.96,5.4C7.82,5.4,8.5199,6.1,8.5199,6.96C8.5199,7.82,7.82,8.52,6.96,8.52C6.0999,8.52,5.3999,7.82,5.3999,6.96C5.3999,6.1,6.0999,5.4,6.96,5.4zM5.6499,11.65L11.65,5.65L12.36,6.36L6.36,12.36L5.6499,11.65zM11.04,12.6C10.18,12.6,9.48,11.9,9.48,11.04C9.48,10.18,10.18,9.48,11.04,9.48C11.9,9.48,12.6,10.18,12.6,11.04C12.6,11.9,11.9,12.6,11.04,12.6z"
  },
  ic18_search: {
    width: 18,
    height: 18,
    path: "M8.169,12.339C5.87,12.339,4,10.468,4,8.17C4,5.871,5.87,4,8.169,4C10.468,4,12.338,5.871,12.338,8.17C12.338,10.468,10.468,12.339,8.169,12.339V12.339zM15.277,14.571L12.144,11.438C12.879,10.545,13.338,9.417,13.338,8.17C13.338,5.315,11.024,3,8.169,3C5.314,3,3,5.315,3,8.17C3,11.025,5.314,13.339,8.169,13.339C9.416,13.339,10.544,12.88,11.437,12.145L14.57,15.278L15.277,14.571z"
  },
  ic18_share: {
    width: 18,
    height: 18,
    path: "M12.8002,11.4C12.2902,11.4,11.8322,11.614,11.5052,11.955L6.5642,9.361C6.5872,9.244,6.6002,9.124,6.6002,9C6.6002,8.876,6.5872,8.755,6.5642,8.638L11.5052,6.045C11.8322,6.386,12.2902,6.6,12.8002,6.6C13.7942,6.6,14.6002,5.794,14.6002,4.8C14.6002,3.806,13.7942,3,12.8002,3C11.8062,3,11.0002,3.806,11.0002,4.8C11.0002,4.923,11.0132,5.044,11.0362,5.161L6.0952,7.754C5.7682,7.414,5.3102,7.2,4.8002,7.2C3.8062,7.2,3.0002,8.006,3.0002,9C3.0002,9.994,3.8062,10.8,4.8002,10.8C5.3102,10.8,5.7682,10.586,6.0962,10.245L11.0362,12.838C11.0122,12.955,11.0002,13.076,11.0002,13.2C11.0002,14.194,11.8062,15,12.8002,15C13.7942,15,14.6002,14.194,14.6002,13.2C14.6002,12.206,13.7942,11.4,12.8002,11.4"
  },
  ic18_shine: {
    width: 18,
    height: 18,
    path: "M10.1,11.38C10.36,12.13,10.61,13,10.61,13C10.61,13,10.85,12.12,11.12,11.38C11.7,9.7401,12.94,8.43,14.6,7.9101L16.2,7.42C16.2,7.42,15.32,7.18,14.57,6.9101C12.93,6.33,11.61,5.1001,11.09,3.44V3.42C10.83,2.67,10.58,1.8,10.58,1.8C10.58,1.8,10.34,2.6801,10.07,3.42C9.5,5.0601,8.26,6.38,6.6,6.89L5,7.38C5,7.38,5.88,7.62,6.63,7.89C8.27,8.4701,9.59,9.7,10.11,11.36M4.83,15.44C5,15.93,5.16,16.5,5.16,16.5C5.16,16.5,5.32,15.93,5.49,15.44C5.87,14.37,6.68,13.52,7.76,13.18L8.8,12.86C8.8,12.86,8.23,12.7,7.74,12.53C6.67,12.15,5.81,11.35,5.47,10.27V10.26C5.3,9.7699,5.14,9.1999,5.14,9.1999C5.14,9.1999,4.98,9.7699,4.81,10.26C4.43,11.33,3.62,12.18,2.54,12.52L1.5,12.84C1.5,12.84,2.07,13,2.56,13.17C3.63,13.55,4.49,14.35,4.83,15.43"
  },
  ic18_socarzone: {
    width: 18,
    height: 18,
    path: "M14.1762,5.9575C13.3592,3.7455,11.3512,2.0995,8.9942,2.0045C5.7062,1.8725,3.0002,4.4985,3.0002,7.7565C3.0002,9.2685,3.6132,10.5995,4.4822,11.6625L8.7252,16.8755L13.0132,11.6625C14.2952,10.0635,15.0342,8.2835,14.1762,5.9575"
  },
  ic18_time: {
    width: 18,
    height: 18,
    path: "M1.54,8.993C1.54,4.877,4.877,1.54,8.993,1.54C13.11,1.54,16.446,4.877,16.446,8.993C16.446,13.109,13.11,16.446,8.993,16.446C4.877,16.446,1.54,13.109,1.54,8.993zM15.446,8.993C15.446,5.435,12.552,2.54,8.993,2.54C5.435,2.54,2.54,5.435,2.54,8.993C2.54,12.551,5.435,15.446,8.993,15.446C12.552,15.446,15.446,12.551,15.446,8.993zM8.4926,10.0146H12.7196V9.0146H9.4926V4.5206H8.4926V10.0146z"
  },
  ic18_time_fill: {
    width: 18,
    height: 18,
    path: "M8.993,1.54C4.877,1.54,1.54,4.877,1.54,8.993C1.54,13.109,4.877,16.446,8.993,16.446C13.11,16.446,16.446,13.109,16.446,8.993C16.446,4.877,13.11,1.54,8.993,1.54M12.7196,10.0148H8.4926V4.5207H9.4926V9.0147H12.7196V10.0148z"
  },
  ic18_train: {
    width: 18,
    height: 18,
    path: "M16.47,3.9225H6.6075L1.5375,8.9925V14.4075H16.4025V13.5075H2.4375V9.36L2.6925,9.105H8.0175V6.165H5.6325L6.9825,4.815H16.4775V3.915L16.47,3.9225zM7.11,7.0725V8.2125H3.5925L4.7325,7.0725H7.1175H7.11zM11.9025,9.1051V6.1726H8.97V9.1051H11.9025zM9.87,7.0726H11.0025V8.2051H9.87V7.0726zM15.795,9.1051V6.1726H12.8625V9.1051H15.795zM13.7625,7.0726H14.895V8.2051H13.7625V7.0726z"
  },
  ic18_warn_fill: {
    width: 18,
    height: 18,
    path: "M8.88,2L1,15.648H16.76L8.88,2zM8.234,11.471H9.434V7.348H8.234V11.471zM8.243,13.583H9.425V12.399H8.243V13.583z"
  },
  ic18_warn_outline: {
    width: 18,
    height: 18,
    path: "M8.949,2.5L1.5,15.402H16.399L8.949,2.5zM8.949,4.391L14.761,14.458H3.139L8.949,4.391zM8.4267,11.4534H9.3847V7.5564H8.4267V11.4534zM9.3857,13.3674H8.4277V12.4104H9.3857V13.3674z"
  },
  ic24_account_off: {
    width: 24,
    height: 24,
    path: "M11.8248,5C9.8618,5,8.2708,6.591,8.2708,8.555C8.2708,10.518,9.8618,12.109,11.8248,12.109C13.7878,12.109,15.3798,10.518,15.3798,8.555C15.3798,6.591,13.7878,5,11.8248,5zM3.0003,19.916L8.0373,14.944H15.6113L20.6503,19.916H15.4843H10.7853H3.0003z"
  },
  ic24_adddrivers: {
    width: 24,
    height: 24,
    path: "M9.5118,6.05C7.8098,6.05,6.4308,7.43,6.4308,9.132C6.4308,10.833,7.8098,12.213,9.5118,12.213C11.2128,12.213,12.5928,10.833,12.5928,9.132C12.5928,7.43,11.2128,6.05,9.5118,6.05zM13.4038,6.3281C13.7928,6.1531,14.2218,6.05,14.6758,6.05C16.3968,6.05,17.7908,7.4451,17.7908,9.1651C17.7908,10.885,16.3968,12.279,14.6758,12.279C14.2218,12.279,13.7928,12.177,13.4038,12.002C14.0518,11.232,14.4578,10.251,14.4578,9.1651C14.4578,8.0791,14.0518,7.098,13.4038,6.3281zM15.1568,14.7204H18.0488L22.4168,19.0304H19.5248L15.1568,14.7204zM2,19.03L6.367,14.72H12.932L17.3,19.03H12.822H8.748H2z"
  },
  ic24_airport: {
    width: 24,
    height: 24,
    path: "M17.7319,17.03L3.6659,11.91C2.4269,11.46,1.7269,10.26,2.1009,9.232C2.4749,8.203,3.7829,7.735,5.0209,8.186L8.8949,9.595L14.8199,6L17.8779,7.113L13.9909,11.45L16.6729,12.41L18.8949,11.318L21.7429,12.354L17.7319,17.03z"
  },
  ic24_answer: {
    width: 24,
    height: 24,
    path: "M13.8672,13.8721L11.9972,8.2181L10.0822,13.8721H13.8672zM10.3302,4.0051H13.6652L19.5002,20.0001H15.7152L14.4762,16.4181H9.4972L8.2812,20.0001H4.4952L10.3302,4.0051z"
  },
  ic24_arrow_fill: {
    width: 24,
    height: 24,
    path: "M12,2C6.49,2,2,6.49,2,12C2,17.51,6.49,22,12,22C17.51,22,22,17.51,22,12C22,6.49,17.51,2,12,2zM12.96,16.89L12.11,16.04L15.65,12.5H6.2V11.3H15.65L12.11,7.76L12.96,6.91L17.95,11.9L12.96,16.89z"
  },
  ic24_back: {
    width: 24,
    height: 24,
    path: "M11.494,3L3,11.495L11.494,19.99L12.485,19L5.679,12.195H19.989V10.795H5.679L12.485,3.99L11.494,3z"
  },
  ic24_camera: {
    width: 24,
    height: 24,
    path: "M8,12.9782C8,15.1872,9.791,16.9782,12,16.9782C14.209,16.9782,16,15.1872,16,12.9782C16,10.7692,14.209,8.9782,12,8.9782C9.791,8.9782,8,10.7692,8,12.9782zM16.291,4.0002L18.6,8.0002H22V19.9812H2V8.0002H5.4L7.709,4.0002H16.291zM9.4,12.9786C9.4,11.5446,10.566,10.3786,12,10.3786C13.434,10.3786,14.6,11.5446,14.6,12.9786C14.6,14.4126,13.434,15.5786,12,15.5786C10.566,15.5786,9.4,14.4126,9.4,12.9786z"
  },
  ic24_camera_front: {
    width: 24,
    height: 24,
    path: "M7.7087,4.0002L5.4007,8.0002H1.9997V19.9812H21.9997V8.0002H18.5997L16.2907,4.0002H7.7087zM3.4007,9.4002H5.4007H6.2087L6.6127,8.7002L8.5177,5.4002H15.4827L17.3887,8.7002L17.7927,9.4002H18.5997H20.5997V18.5822H3.4007V9.4002zM7.5997,10.9464L5.7877,12.7594H7.0457C7.1207,13.9464,7.6177,15.0744,8.4877,15.9454C9.4277,16.8854,10.6787,17.4044,12.0077,17.4044C13.3377,17.4044,14.5887,16.8854,15.5297,15.9454C15.7137,15.7604,15.8877,15.5494,16.0497,15.3224L15.2757,14.5494C15.1237,14.7824,14.9537,14.9974,14.7677,15.1834C14.0067,15.9454,13.0077,16.3244,12.0087,16.3244C11.0087,16.3244,10.0097,15.9444,9.2487,15.1834C8.5877,14.5224,8.2167,13.6634,8.1417,12.7594H9.4127L7.5997,10.9464zM8.4869,8.9044C9.4279,7.9644,10.6789,7.4454,12.0079,7.4454C13.3379,7.4454,14.5889,7.9644,15.5289,8.9034C16.3979,9.7734,16.8929,10.8974,16.9699,12.0814H18.2129L16.4009,13.8944L14.5869,12.0814H15.8769C15.7999,11.1804,15.4269,10.3254,14.7679,9.6664C14.0069,8.9054,13.0079,8.5254,12.0079,8.5254C11.0089,8.5254,10.0099,8.9054,9.2489,9.6664C9.0609,9.8544,8.8899,10.0704,8.7379,10.3044L7.9649,9.5304C8.1269,9.3024,8.3019,9.0904,8.4869,8.9044z"
  },
  ic24_camera_non: {
    width: 24,
    height: 24,
    path: "M3,4.9142L19.784,21.3982L20.682,20.4832L3.897,4.0012L3,4.9142zM11.8464,9.2122C13.7354,9.2122,15.2654,10.7432,15.2654,12.6322C15.2654,12.8402,15.2394,13.0422,15.2024,13.2402L20.3954,18.3402V8.3762H17.4894L15.5144,4.9562H8.1784L7.6674,5.8402L11.1784,9.2882C11.3944,9.2432,11.6164,9.2122,11.8464,9.2122zM9.7688,13.3987C9.9978,14.0167,10.4918,14.5027,11.1148,14.7197L9.7688,13.3987zM11.8464,16.0521C9.9574,16.0521,8.4264,14.5211,8.4264,12.6321C8.4264,12.4601,8.4484,12.2931,8.4754,12.1291L4.6544,8.3761H3.2974V18.6191H15.0844L12.4124,15.9951C12.2284,16.0281,12.0404,16.0521,11.8464,16.0521zM13.8029,11.8655C13.5729,11.2985,13.1179,10.8505,12.5459,10.6305L13.8029,11.8655z"
  },
  ic24_car_filter: {
    width: 24,
    height: 24,
    path: "M15.4365,12.1111C13.4655,12.5292,11.9152,14.0857,11.5062,16.0601H9V16.0578H6.6064V17.6218C6.6064,18.1978,6.1394,18.6638,5.5634,18.6638H4.6074C4.0304,18.6638,3.5644,18.1978,3.5644,17.6218V16.0138H1.9994V9.6918L5.2584,2.9998H16.2404L19.4994,9.6918V12.9748C18.7957,12.4623,17.9558,12.1254,17.0443,12.0287C16.841,11.8543,16.5781,11.7473,16.2904,11.7438C15.9526,11.7399,15.6511,11.8825,15.4365,12.1111zM6.3564,4.5L4,9.6008H17.5L15.1674,4.5H6.3564zM3.9084,12.9148C3.9014,13.5668,4.4284,14.1058,5.0794,14.1138C5.7324,14.1218,6.2714,13.5948,6.2794,12.9428C6.2864,12.2908,5.7594,11.7518,5.1084,11.7438C4.4554,11.7358,3.9164,12.2628,3.9084,12.9148zM13.6996,17.0999C13.6996,18.6439,14.9556,19.8999,16.4996,19.8999C18.0436,19.8999,19.3006,18.6439,19.3006,17.0999C19.3006,15.5559,18.0436,14.2999,16.4996,14.2999C14.9556,14.2999,13.6996,15.5559,13.6996,17.0999zM19.9176,19.5269L21.9106,21.5209L20.9216,22.5109L18.9276,20.5169C18.2406,21.0059,17.4066,21.2999,16.4996,21.2999C14.1806,21.2999,12.3006,19.4199,12.3006,17.0999C12.3006,14.7799,14.1806,12.8999,16.4996,12.8999C18.8196,12.8999,20.6996,14.7799,20.6996,17.0999C20.6996,18.0069,20.4056,18.8409,19.9176,19.5269z"
  },
  ic24_car_filter_line: {
    width: 24,
    height: 24,
    path: "M14.0002,17.014C14.0002,18.54,15.2422,19.781,16.7682,19.781C18.2932,19.781,19.5352,18.54,19.5352,17.014C19.5352,16.9493,19.5263,16.8865,19.5174,16.8236C19.513,16.7921,19.5085,16.7607,19.5052,16.729C19.4472,16.17,19.2262,15.664,18.8842,15.254C18.3762,14.645,17.6222,14.248,16.7682,14.248C15.7732,14.248,14.9062,14.781,14.4182,15.571C14.2002,15.927,14.0652,16.334,14.0262,16.771C14.0233,16.8006,14.0191,16.8297,14.0149,16.8587C14.0075,16.91,14.0002,16.961,14.0002,17.014zM6.4172,15.521H12.9152C13.3572,14.385,14.2742,13.5,15.4322,13.104C15.4284,13.0818,15.4226,13.0604,15.4167,13.0389C15.4069,13.0033,15.3972,12.9677,15.3972,12.929C15.3972,12.322,15.8892,11.829,16.4972,11.829C17.1042,11.829,17.5962,12.322,17.5962,12.929C17.5962,12.9324,17.5952,12.9358,17.5942,12.9394C17.5934,12.9421,17.5926,12.945,17.5922,12.948C18.0402,13.038,18.4532,13.215,18.8342,13.438V10.217L15.9532,4.3H6.1812L3.2992,10.217V15.479H4.7992V17.671C4.7992,17.864,4.9562,18.021,5.1502,18.021H6.0672C6.2602,18.021,6.4172,17.864,6.4172,17.671V15.521zM20.3032,19.16L22.0842,20.94L21.0942,21.93L19.3782,20.216C18.6642,20.8,17.7632,21.164,16.7682,21.164C14.4762,21.164,12.6182,19.306,12.6182,17.014C12.6182,16.9622,12.625,16.9123,12.6317,16.8623C12.6336,16.8485,12.6355,16.8348,12.6372,16.821H7.7162V17.671C7.7162,18.581,6.9762,19.321,6.0672,19.321H5.1502C4.2412,19.321,3.5002,18.581,3.5002,17.671V16.779H2.0002L2.0052,9.906L5.3692,3H16.7652L16.7792,3.028L20.1332,9.928V14.62C20.6182,15.299,20.9172,16.117,20.9172,17.014C20.9172,17.803,20.6852,18.532,20.3032,19.16zM7.9264,6.3435H14.2964L15.7294,9.3725H6.4934L7.9264,6.3435zM15.0564,5.1445H7.1664L4.5994,10.5725H17.6234L15.0564,5.1445zM5.731,11.8288C5.124,11.8288,4.631,12.3218,4.631,12.9288C4.631,13.5368,5.124,14.0288,5.731,14.0288C6.338,14.0288,6.831,13.5368,6.831,12.9288C6.831,12.3218,6.338,11.8288,5.731,11.8288z"
  },
  ic24_car_front: {
    width: 24,
    height: 24,
    path: "M18.019,17.037H19.586V11.442L16.546,5.2H11.437H11.349H6.239L3.2,11.442V17.037H4.767V19.248C4.767,19.493,4.966,19.693,5.211,19.693H6.169C6.414,19.693,6.614,19.493,6.614,19.248V17.081H11.349H11.437H16.172V19.248C16.172,19.493,16.371,19.693,16.616,19.693H17.574C17.819,19.693,18.019,19.493,18.019,19.248V17.037zM11.437,4H17.296L20.786,11.165V18.237H19.219V19.248C19.219,20.155,18.481,20.893,17.574,20.893H16.616C15.71,20.893,14.972,20.155,14.972,19.248V18.281H11.437H11.349H7.814V19.248C7.814,20.155,7.076,20.893,6.169,20.893H5.211C4.305,20.893,3.567,20.155,3.567,19.248V18.237H2V11.165L5.489,4H11.349H11.437zM8.0944,7.3879L6.5724,10.6059H16.3054L14.7834,7.3879H8.0944zM4.6774,11.8059L7.3344,6.1879H15.5434L18.2004,11.8059H4.6774zM5.8184,13.1445C5.1834,13.1445,4.6694,13.6595,4.6694,14.2935C4.6694,14.9285,5.1834,15.4425,5.8184,15.4425C6.4534,15.4425,6.9674,14.9285,6.9674,14.2935C6.9674,13.6595,6.4534,13.1445,5.8184,13.1445zM15.9165,14.2935C15.9165,13.6595,16.4305,13.1445,17.0655,13.1445C17.7005,13.1445,18.2145,13.6595,18.2145,14.2935C18.2145,14.9285,17.7005,15.4425,17.0655,15.4425C16.4305,15.4425,15.9165,14.9285,15.9165,14.2935z"
  },
  ic24_car_front_fill: {
    width: 24,
    height: 24,
    path: "M17.6799,15.6787C17.0729,15.6787,16.5789,15.1867,16.5789,14.5787C16.5789,13.9707,17.0729,13.4787,17.6799,13.4787C18.2869,13.4787,18.7799,13.9707,18.7799,14.5787C18.7799,15.1867,18.2869,15.6787,17.6799,15.6787V15.6787zM5.9399,12.1237L8.4119,6.8937H16.1759L18.6489,12.1237H5.9399zM6.9139,15.6787C6.3069,15.6787,5.8139,15.1867,5.8139,14.5787C5.8139,13.9707,6.3069,13.4787,6.9139,13.4787C7.5219,13.4787,8.0139,13.9707,8.0139,14.5787C8.0139,15.1867,7.5219,15.6787,6.9139,15.6787V15.6787zM17.9159,4.6997H12.2909H12.2079H6.5829L3.2339,11.5787V18.3797H4.7339V19.3217C4.7339,20.2037,5.4509,20.9217,6.3329,20.9217H7.2499C8.1319,20.9217,8.8499,20.2037,8.8499,19.3217V18.4217H12.2079H12.2909H15.6509V19.3217C15.6509,20.2037,16.3679,20.9217,17.2499,20.9217H18.1659C19.0479,20.9217,19.7659,20.2037,19.7659,19.3217V18.3797H21.2659V11.5787L17.9159,4.6997z"
  },
  ic24_car_search_line: {
    width: 24,
    height: 24,
    path: "M14.0002,17.014C14.0002,18.54,15.2422,19.781,16.7682,19.781C18.2932,19.781,19.5352,18.54,19.5352,17.014C19.5352,16.9493,19.5263,16.8865,19.5174,16.8236C19.513,16.7921,19.5085,16.7607,19.5052,16.729C19.4472,16.17,19.2262,15.664,18.8842,15.254C18.3762,14.645,17.6222,14.248,16.7682,14.248C15.7732,14.248,14.9062,14.781,14.4182,15.571C14.2002,15.927,14.0652,16.334,14.0262,16.771C14.0233,16.8006,14.0191,16.8297,14.0149,16.8587C14.0075,16.91,14.0002,16.961,14.0002,17.014zM6.4172,15.521H12.9152C13.3572,14.385,14.2742,13.5,15.4322,13.104C15.4284,13.0818,15.4226,13.0604,15.4167,13.0389C15.4069,13.0033,15.3972,12.9677,15.3972,12.929C15.3972,12.322,15.8892,11.829,16.4972,11.829C17.1042,11.829,17.5962,12.322,17.5962,12.929C17.5962,12.9324,17.5952,12.9358,17.5942,12.9394C17.5934,12.9421,17.5926,12.945,17.5922,12.948C18.0402,13.038,18.4532,13.215,18.8342,13.438V10.217L15.9532,4.3H6.1812L3.2992,10.217V15.479H4.7992V17.671C4.7992,17.864,4.9562,18.021,5.1502,18.021H6.0672C6.2602,18.021,6.4172,17.864,6.4172,17.671V15.521zM20.3032,19.16L22.0842,20.94L21.0942,21.93L19.3782,20.216C18.6642,20.8,17.7632,21.164,16.7682,21.164C14.4762,21.164,12.6182,19.306,12.6182,17.014C12.6182,16.9622,12.625,16.9123,12.6317,16.8623C12.6336,16.8485,12.6355,16.8348,12.6372,16.821H7.7162V17.671C7.7162,18.581,6.9762,19.321,6.0672,19.321H5.1502C4.2412,19.321,3.5002,18.581,3.5002,17.671V16.779H2.0002L2.0052,9.906L5.3692,3H16.7652L16.7792,3.028L20.1332,9.928V14.62C20.6182,15.299,20.9172,16.117,20.9172,17.014C20.9172,17.803,20.6852,18.532,20.3032,19.16zM7.9264,6.3435H14.2964L15.7294,9.3725H6.4934L7.9264,6.3435zM15.0564,5.1445H7.1664L4.5994,10.5725H17.6234L15.0564,5.1445zM5.731,11.8288C5.124,11.8288,4.631,12.3218,4.631,12.9288C4.631,13.5368,5.124,14.0288,5.731,14.0288C6.338,14.0288,6.831,13.5368,6.831,12.9288C6.831,12.3218,6.338,11.8288,5.731,11.8288z"
  },
  ic24_change: {
    width: 24,
    height: 24,
    path: "M14.495,4.505L20.1899,10.2H4.5V8.8H16.8101L13.505,5.495L14.495,4.505zM9.505,19.495L3.81,13.8H19.5V15.2H7.1899L10.495,18.505L9.505,19.495z"
  },
  ic24_charge_electricity: {
    width: 24,
    height: 24,
    path: "M2.0002,12C2.0002,6.477,6.4772,2,12.0002,2C17.5222,2,22.0002,6.477,22.0002,12C22.0002,17.523,17.5222,22,12.0002,22C6.4772,22,2.0002,17.523,2.0002,12zM20.6002,12C20.6002,7.258,16.7422,3.4,12.0002,3.4C7.2582,3.4,3.4002,7.258,3.4002,12C3.4002,16.742,7.2582,20.6,12.0002,20.6C16.7422,20.6,20.6002,16.742,20.6002,12zM12.319,4.9086V10.4956H17.604L12.274,19.1536V13.5226H6.91L12.319,4.9086z"
  },
  ic24_chat: {
    width: 24,
    height: 24,
    path: "M3,3V17.338H3.011V20.606L6.925,17.338H20.887V3H3zM14.865,11.395H17.329V8.931H14.865V11.395zM10.794,11.395H13.257V8.931H10.794V11.395zM6.71,11.395H9.174V8.931H6.71V11.395z"
  },
  ic24_chat_line: {
    width: 24,
    height: 24,
    path: "M4,18.208V5H20.476V18.208H7.615L4.01,21.217V18.208H4zM5.2,17.008L5.21,18.208V18.652L6.846,17.286L7.18,17.008H7.615H19.277V6.2H5.2V17.008zM9.445,12.6071H6.981V10.1431H9.445V12.6071zM11.065,12.6071H13.529V10.1431H11.065V12.6071zM17.6,12.6071H15.136V10.1431H17.6V12.6071z"
  },
  ic24_check_on: {
    width: 24,
    height: 24,
    path: "M6.4048,12.232L7.3948,11.242L10.5268,14.374L16.6048,8.295L17.5948,9.286L10.5268,16.354L6.4048,12.232zM21.9998,12C21.9998,6.486,17.5138,2,11.9998,2C6.4858,2,1.9998,6.486,1.9998,12C1.9998,17.514,6.4858,22,11.9998,22C17.5138,22,21.9998,17.514,21.9998,12V12z"
  },
  ic24_checkonly: {
    width: 24,
    height: 24,
    path: "M9.3076,18.0693L3.3196,12.0823L4.3096,11.0913L9.3076,16.0903L19.2826,6.1143L20.2726,7.1053L9.3076,18.0693z"
  },
  ic24_checksheet: {
    width: 24,
    height: 24,
    path: "M4,3V20.348H19.063V7.069L15.048,3H4zM14.904,8.826L15.872,9.785L10.35,15.344L7.299,12.25L8.268,11.294L10.355,13.407L14.904,8.826z"
  },
  ic24_chevron_left: {
    width: 24,
    height: 24,
    path: "M15.745,4L8,11.744L15.745,19.49L16.735,18.5L9.98,11.744L16.735,4.99L15.745,4z"
  },
  ic24_chevron_right: {
    width: 24,
    height: 24,
    path: "M8.99,4L8,4.99L14.754,11.744L8,18.5L8.99,19.49L16.735,11.744L8.99,4z"
  },
  ic24_close: {
    width: 24,
    height: 24,
    path: "M18.432,4L11.603,10.829L4.991,4.217L4,5.207L10.613,11.819L4.433,18L5.422,18.99L11.603,12.81L18.001,19.207L18.991,18.217L12.594,11.819L19.422,4.991L18.432,4z"
  },
  ic24_credit: {
    width: 24,
    height: 24,
    path: "M12,2C10.0222,2,8.0888,2.5865,6.4443,3.6853C4.7998,4.7841,3.5181,6.3459,2.7612,8.1732C2.0043,10.0004,1.8063,12.0111,2.1921,13.9509C2.578,15.8907,3.5304,17.6725,4.9289,19.0711C6.3275,20.4696,8.1093,21.422,10.0491,21.8079C11.9889,22.1937,13.9996,21.9957,15.8268,21.2388C17.6541,20.4819,19.2159,19.2002,20.3147,17.5557C21.4135,15.9112,22,13.9778,22,12C22,9.3478,20.9464,6.8043,19.0711,4.9289C17.1957,3.0536,14.6522,2,12,2V2zM12,20.6C10.2991,20.6,8.6364,20.0956,7.2221,19.1506C5.8078,18.2057,4.7055,16.8625,4.0546,15.2911C3.4037,13.7196,3.2334,11.9905,3.5652,10.3222C3.8971,8.654,4.7161,7.1216,5.9189,5.9189C7.1216,4.7161,8.654,3.8971,10.3222,3.5652C11.9905,3.2334,13.7196,3.4037,15.2911,4.0546C16.8625,4.7055,18.2057,5.8078,19.1506,7.2221C20.0956,8.6364,20.6,10.2991,20.6,12C20.5974,14.28,19.6904,16.466,18.0782,18.0782C16.466,19.6904,14.2801,20.5974,12,20.6zM12.37,8.26C12.9684,8.2625,13.5574,8.4081,14.088,8.6847C14.6186,8.9613,15.0753,9.3609,15.42,9.85L15.47,9.93L16.82,9.15L16.76,9.06C16.1285,8.1177,15.2109,7.4034,14.1426,7.0224C13.0742,6.6414,11.9117,6.6138,10.8265,6.9438C9.7413,7.2739,8.7909,7.9439,8.1155,8.8552C7.4401,9.7665,7.0756,10.8707,7.0756,12.005C7.0756,13.1393,7.4401,14.2435,8.1155,15.1548C8.7909,16.0661,9.7413,16.7362,10.8265,17.0662C11.9117,17.3962,13.0742,17.3686,14.1426,16.9876C15.2109,16.6066,16.1285,15.8922,16.76,14.95L16.82,14.86L15.47,14.08L15.42,14.16C15.0492,14.6841,14.5497,15.104,13.9696,15.3791C13.3895,15.6543,12.7483,15.7755,12.1078,15.731C11.4673,15.6866,10.8491,15.478,10.3125,15.1253C9.776,14.7727,9.3393,14.2878,9.0445,13.7175C8.7496,13.1471,8.6066,12.5105,8.6291,11.8688C8.6516,11.2272,8.8389,10.6021,9.173,10.0539C9.5071,9.5056,9.9767,9.0526,10.5367,8.7384C11.0966,8.4242,11.728,8.2594,12.37,8.26V8.26z"
  },
  ic24_creditcard: {
    width: 24,
    height: 24,
    path: "M22,18.75H2V5H22V18.75zM20.601,17.349H3.4V11.959H20.601V17.349zM20.601,8.958H3.4V6.4H20.601V8.958z"
  },
  ic24_creditcard2: {
    width: 24,
    height: 24,
    path: "M2.18,5V19H21.78V5H2.18zM20.48,17.7H3.48V10.7H20.48V17.7zM20.48,8.9H3.48V6.3H20.48V8.9zM19,14.6H16.4V16.4H19V14.6z"
  },
  ic24_delete: {
    width: 24,
    height: 24,
    path: "M8.5,4L9.5,3H14.5L15.5,4H19V6H5V4H8.5zM18,21H6V7.001H18V21zM15.075,18.699H13.675V9.136H15.075V18.699zM10.231,18.699H8.831V9.136H10.231V18.699z"
  },
  ic24_delete_field: {
    width: 24,
    height: 24,
    path: "M16.4243,15.5758L15.5753,16.4248L12.0003,12.8488L8.4243,16.4248L7.5753,15.5758L11.1513,11.9998L7.5753,8.4248L8.4243,7.5758L12.0003,11.1518L15.5753,7.5758L16.4243,8.4248L12.8483,11.9998L16.4243,15.5758zM12.0003,1.9998C6.4863,1.9998,2.0003,6.4868,2.0003,11.9998C2.0003,17.5138,6.4863,21.9998,12.0003,21.9998C17.5133,21.9998,22.0003,17.5138,22.0003,11.9998C22.0003,6.4868,17.5133,1.9998,12.0003,1.9998V1.9998z"
  },
  ic24_delivery: {
    width: 24,
    height: 24,
    path: "M12,20C16.4183,20,20,16.4183,20,12C20,7.5817,16.4183,4,12,4C7.5817,4,4,7.5817,4,12C4,16.4183,7.5817,20,12,20zM12,15C13.6569,15,15,13.6569,15,12C15,10.3431,13.6569,9,12,9C10.3431,9,9,10.3431,9,12C9,13.6569,10.3431,15,12,15z"
  },
  ic24_discount: {
    width: 24,
    height: 24,
    path: "M2.0019,9.9052L2.0029,5.1472L21.8679,5.1522L21.8669,9.9102H21.8659C20.5739,9.9102,19.5269,10.9582,19.5259,12.2502C19.5259,13.5432,20.5739,14.5912,21.8659,14.5922L21.8649,19.3502L1.9999,19.3452L2.0009,14.5872H2.0019C3.2939,14.5872,4.3419,13.5392,4.3419,12.2472C4.3419,10.9542,3.2949,9.9062,2.0019,9.9052zM20.7219,6.2982L3.1489,6.2932L3.1479,8.9532C4.5099,9.4292,5.4879,10.7272,5.4879,12.2472C5.4869,13.7682,4.5079,15.0642,3.1469,15.5392L3.1459,18.1992L20.7189,18.2042L20.7199,15.5442C19.3589,15.0682,18.3799,13.7702,18.3799,12.2502C18.3799,10.7302,19.3599,9.4322,20.7209,8.9582L20.7219,6.2982zM9.4594,8.7751C8.5054,8.7751,7.7314,9.5501,7.7314,10.5041C7.7314,10.8787,7.8507,11.2256,8.0534,11.5087C8.2187,11.7396,8.4394,11.9281,8.6962,12.0547C8.9264,12.1683,9.1855,12.2321,9.4594,12.2321C10.4144,12.2321,11.1884,11.4581,11.1884,10.5041C11.1884,9.5501,10.4144,8.7751,9.4594,8.7751zM9.4594,11.2761C9.7364,11.2761,9.9804,11.1298,10.1173,10.9103C10.1906,10.7924,10.233,10.6533,10.233,10.5048C10.233,10.0768,9.886,9.7308,9.459,9.7308C9.2627,9.7308,9.0833,9.8043,8.947,9.9255C8.7878,10.0673,8.6874,10.2741,8.6874,10.5041C8.6874,10.9301,9.0334,11.2761,9.4594,11.2761zM10.5015,15.788L14.4555,8.904L13.1425,8.905L9.1895,15.788H10.5015zM14.2168,12.4221C13.2628,12.4221,12.4888,13.1951,12.4888,14.1511C12.4888,15.1051,13.2628,15.8781,14.2168,15.8781C15.1718,15.8781,15.9458,15.1051,15.9458,14.1511C15.9458,13.1951,15.1718,12.4221,14.2168,12.4221zM14.2168,13.3771C14.6428,13.3771,14.9898,13.7241,14.9898,14.1511C14.9898,14.5761,14.6428,14.9221,14.2168,14.9221C13.7908,14.9221,13.4448,14.5761,13.4448,14.1511C13.4448,13.7241,13.7908,13.3771,14.2168,13.3771z"
  },
  ic24_discount_fill: {
    width: 24,
    height: 24,
    path: "M2,9.76V5H21.87V9.76C20.58,9.76,19.53,10.81,19.53,12.1C19.53,13.39,20.58,14.44,21.87,14.44V19.2H2V14.44C3.29,14.44,4.34,13.39,4.34,12.1C4.34,10.81,3.29,9.76,2,9.76zM9.65,8.42C8.68,8.42,7.9,9.2,7.9,10.17C7.9,11.14,8.68,11.92,9.65,11.92C10.62,11.92,11.4,11.14,11.4,10.17C11.4,9.2,10.62,8.42,9.65,8.42zM13.35,8.52L9.4,15.4H10.71L14.66,8.52H13.35zM12.8,13.57C12.8,14.54,13.58,15.32,14.55,15.32C15.52,15.32,16.3,14.54,16.3,13.57C16.3,12.6,15.52,11.82,14.55,11.82C13.58,11.82,12.8,12.6,12.8,13.57zM9.65,10.9199C10.0642,10.9199,10.4,10.5841,10.4,10.1699C10.4,9.7557,10.0642,9.4199,9.65,9.4199C9.2358,9.4199,8.9,9.7557,8.9,10.1699C8.9,10.5841,9.2358,10.9199,9.65,10.9199zM14.55,14.3198C14.9642,14.3198,15.3,13.984,15.3,13.5698C15.3,13.1556,14.9642,12.8198,14.55,12.8198C14.1358,12.8198,13.8,13.1556,13.8,13.5698C13.8,13.984,14.1358,14.3198,14.55,14.3198z"
  },
  ic24_download: {
    width: 24,
    height: 24,
    path: "M11.0065,13.745V3H12.4065V13.745L17.4285,8.722L18.4185,9.712L11.7065,16.424L4.9945,9.712L5.9845,8.722L11.0065,13.745zM4,20.3056V16.2606H5.4V18.9046H18.343V16.3466H19.744V20.3056H4z"
  },
  ic24_driverlicense: {
    width: 24,
    height: 24,
    path: "M2,18.75H22V5H2V18.75zM3.4,17.349H20.601V6.4H3.4V17.349zM8.8501,8.8748C8.0601,8.8748,7.4201,9.5148,7.4201,10.3048C7.4201,11.0948,8.0601,11.7348,8.8501,11.7348C9.6401,11.7348,10.2801,11.0948,10.2801,10.3048C10.2801,9.5148,9.6401,8.8748,8.8501,8.8748zM7.3265,12.8748H10.3735L12.3995,14.8748H10.3225H8.4315H5.2995L7.3265,12.8748z"
  },
  ic24_driverlicense_fill: {
    width: 24,
    height: 24,
    path: "M2,5V18.44H22V5H2zM8.61,8.11C9.53,8.11,10.28,8.86,10.28,9.78C10.28,10.13,10.17,10.45,10,10.71C9.88,10.89,9.72,11.04,9.55,11.16C9.28,11.34,8.96,11.44,8.61,11.44C8.26,11.44,7.95,11.34,7.68,11.16C7.5,11.04,7.35,10.89,7.23,10.71C7.05,10.44,6.95,10.12,6.95,9.78C6.95,8.85,7.69,8.11,8.61,8.11zM10.33,15.11H8.13H4.47L6.83,12.78H10.38L12.74,15.11H10.33z"
  },
  ic24_electricity_fill: {
    width: 24,
    height: 24,
    path: "M12,19V15.4H8.8L12,10V13.6H15.217L12,19zM8,8H16V4.7999H8V8zM5.5,21.8H18.5V2.1999H5.5V21.8z"
  },
  ic24_etc_share: {
    width: 24,
    height: 24,
    path: "M16.547,14.923C15.997,14.923,15.501,15.123,15.107,15.446L9.534,12.23C9.561,12.09,9.577,11.948,9.577,11.802C9.577,11.618,9.55,11.442,9.509,11.27L15.095,8.045C15.491,8.372,15.993,8.577,16.547,8.577C17.811,8.577,18.836,7.553,18.836,6.289C18.836,5.025,17.811,3.999,16.546,3.999C15.283,3.999,14.258,5.025,14.258,6.289C14.258,6.506,14.298,6.712,14.355,6.909L8.815,10.109C8.41,9.743,7.878,9.514,7.289,9.514C6.025,9.514,4.999,10.538,4.999,11.802C4.999,13.066,6.025,14.091,7.289,14.091C7.912,14.091,8.476,13.84,8.889,13.435L14.355,16.591C14.298,16.79,14.258,16.995,14.258,17.211C14.258,18.476,15.283,19.5,16.547,19.5C17.811,19.5,18.836,18.476,18.836,17.212C18.836,15.948,17.811,14.922,16.546,14.922"
  },
  ic24_expand_less: {
    width: 24,
    height: 24,
    path: "M4.6225,15.1225L5.6125,16.1125L12.3665,9.3585L19.1225,16.1125L20.1125,15.1225L12.3665,7.3776L4.6225,15.1225z"
  },
  ic24_expand_more: {
    width: 24,
    height: 24,
    path: "M20.1125,8.3674L19.1225,7.3774L12.3685,14.1314L5.6125,7.3774L4.6225,8.3674L12.3685,16.1124L20.1125,8.3674z"
  },
  ic24_filter: {
    width: 24,
    height: 24,
    path: "M10.9945,2.9998V6.4228H9.4915V10.8238H10.9945V20.4008H12.3945V10.8238H13.8925V6.4228H12.3945V2.9998H10.9945zM10.8915,7.8228H10.9945H12.3945H12.4925V9.4228H12.3945H10.9945H10.8915V7.8228zM16.5205,2.9998V12.4198H15.0215V16.8198H16.5205V20.4008H17.9205V16.8198H19.4215V12.4198H17.9205V2.9998H16.5205zM16.4215,13.8208H16.5205H17.9205H18.0205V15.4198H17.9205H16.5205H16.4215V13.8208zM5.5,12.4206V3.0016H6.9V12.4206H8.4V16.8206H6.9V20.4006H5.5V16.8206H4V12.4206H5.5zM5.5,13.8206H5.4V15.4196H5.5H6.9H6.999V13.8206H6.9H5.5z"
  },
  ic24_filter_on: {
    width: 24,
    height: 24,
    path: "M10.9945,2.9998V6.4228H9.4915V10.8238H10.9945V20.4008H12.3945V10.8238H13.8925V6.4228H12.3945V2.9998H10.9945zM10.8915,7.8228H10.9945H12.3945H12.4925V9.4228H12.3945H10.9945H10.8915V7.8228zM16.5205,2.9998V12.4198H15.0215V16.8198H16.5205V20.4008H17.9205V16.8198H19.4215V12.4198H17.9205V2.9998H16.5205zM16.4215,13.8208H16.5205H17.9205H18.0205V15.4198H17.9205H16.5205H16.4215V13.8208zM5.5,12.4206V3.0016H6.9V12.4206H8.4V16.8206H6.9V20.4006H5.5V16.8206H4V12.4206H5.5zM5.5,13.8206H5.4V15.4196H5.5H6.9H6.999V13.8206H6.9H5.5zM20,2C20,0.8954,20.8954,0,22,0C23.1046,0,24,0.8954,24,2C24,3.1046,23.1046,4,22,4C20.8954,4,20,3.1046,20,2z"
  },
  ic24_flash_off: {
    width: 24,
    height: 24,
    path: "M9.1826,6.8512L12.2286,2.0002V9.8127L12.2596,9.8437H12.2286V9.8132L9.1826,6.8512zM7.676,9.2483L3,4.6993L3.977,3.6963L20.644,19.9043L19.667,20.9083L15.395,16.7543L12.166,22.0003V14.0933H4.634L7.676,9.2483zM19.6484,9.8428L12.2594,9.8438L16.8814,14.3388L19.6484,9.8428z"
  },
  ic24_flash_on: {
    width: 24,
    height: 24,
    path: "M11.593,2L4,14.093H11.531V22L19.013,9.843L11.593,9.844V2z"
  },
  ic24_flashlight_off: {
    width: 24,
    height: 24,
    path: "M5.6397,3.1002V3.0002H19.4367V6.7662L15.4527,10.7502V12.8112L5.6397,3.1002zM9.624,10.8819L3,4.3259L3.985,3.3309L20.151,19.3309L19.168,20.3249L15.452,16.6499V21.0159H12.625H12.453H9.624V10.8819zM13.538,14.7549L11.538,12.7749V16.0469H13.538V14.7549z"
  },
  ic24_flashlight_on: {
    width: 24,
    height: 24,
    path: "M5,3V6.766L8.984,10.75V21.015H11.812H11.984H14.812V10.75L18.796,6.766V3H5zM10.898,16.046H12.899V12.421H10.898V16.046z"
  },
  ic24_forward: {
    width: 24,
    height: 24,
    path: "M11.495,19.99L19.989,11.495L11.495,3L10.504,3.99L17.31,10.795H3V12.195H17.31L10.504,19L11.495,19.99z"
  },
  ic24_help: {
    width: 24,
    height: 24,
    path: "M2.0001,11.9998C2.0001,6.4778,6.4771,1.9998,12.0001,1.9998C17.5231,1.9998,22.0001,6.4778,22.0001,11.9998C22.0001,17.5228,17.5231,21.9998,12.0001,21.9998C6.4771,21.9998,2.0001,17.5228,2.0001,11.9998zM20.6001,11.9998C20.6001,7.2578,16.7421,3.3998,12.0001,3.3998C7.2581,3.3998,3.4001,7.2578,3.4001,11.9998C3.4001,16.7418,7.2581,20.5998,12.0001,20.5998C16.7421,20.5998,20.6001,16.7418,20.6001,11.9998zM11.3003,15.0999V11.9719H12.0003C13.2133,11.9719,14.2003,10.9849,14.2003,9.7709C14.2003,8.5579,13.2133,7.5719,12.0003,7.5719C10.7873,7.5719,9.8003,8.5579,9.8003,9.7709H8.4003C8.4003,7.7869,10.0153,6.1709,12.0003,6.1709C13.9853,6.1709,15.6003,7.7869,15.6003,9.7709C15.6003,11.5169,14.3513,12.9769,12.7003,13.3039V15.0999H11.3003zM11.3,18.1H12.7V16.7H11.3V18.1z"
  },
  ic24_help_fill: {
    width: 24,
    height: 24,
    path: "M12.7,13.303V15.1H11.3V11.971H12C13.213,11.971,14.2,10.984,14.2,9.771C14.2,8.558,13.213,7.572,12,7.572C10.787,7.572,9.8,8.558,9.8,9.771H8.4C8.4,7.786,10.015,6.171,12,6.171C13.985,6.171,15.6,7.786,15.6,9.771C15.6,11.517,14.351,12.976,12.7,13.303V13.303zM11.3,18.1H12.7V16.7H11.3V18.1zM2,12C2,17.513,6.486,22,12,22C17.513,22,22,17.513,22,12C22,6.486,17.513,2,12,2C6.486,2,2,6.486,2,12z"
  },
  ic24_history: {
    width: 24,
    height: 24,
    path: "M4,20.348V3H15.048L19.063,7.07V20.348H4zM9.8,9.8H7V7H9.8V9.8zM7,13.2H16V11.8H7V13.2zM16,16.4H7V15H16V16.4z"
  },
  ic24_history_line: {
    width: 24,
    height: 24,
    path: "M15.56,3.1899H4.37V20.7399H19.63V7.3199L15.56,3.1899zM15,4.5599L18.28,7.8799V19.3699H5.74V4.5599H15zM10.1,7.2H7.5V10H10.1V7.2zM16.5,12H7.5V13.2H16.5V12zM16.5,15H7.5V16.2H16.5V15z"
  },
  ic24_home: {
    width: 24,
    height: 24,
    path: "M20.3335,11.4043L12.1775,3.2483L4.0215,11.4043V21.0003H9.7285V15.2423H14.5415V21.0003H20.3335V11.4043z"
  },
  ic24_home_line: {
    width: 24,
    height: 24,
    path: "M3,11.5V21.5H9.999V15.5H13V21.5H20V11.5L11.5,3L3,11.5zM4.4,12.08L11.5,4.979L18.601,12.08V20.1H14.4V15.5V14.1H13H9.999H8.6V15.5V20.1H4.4V12.08z"
  },
  ic24_income: {
    width: 24,
    height: 24,
    path: "M14.2205,7.806L17.7375,4L21.2535,7.806H20.1625V20.019H15.4825V7.806H14.2205zM9.333,20.0191H14.014V10.6191H9.333V20.0191zM3,20.0191H7.681V13.9621H3V20.0191z"
  },
  ic24_info_fill: {
    width: 24,
    height: 24,
    path: "M11.5,17H12.9V10.15H11.5V17zM11.5,8.55H12.9V7.15H11.5V8.55zM2,12C2,17.514,6.486,22,12,22C15.6424,22,18.8363,20.0425,20.5848,17.1242C21.4832,15.6247,22,13.8716,22,12C22,6.486,17.514,2,12,2C6.486,2,2,6.486,2,12z"
  },
  ic24_inquire: {
    width: 24,
    height: 24,
    path: "M12.9514,12.512V14.183H11.6484V11.273H12.3004C13.4284,11.273,14.3464,10.355,14.3464,9.227C14.3464,8.099,13.4284,7.181,12.3004,7.181C11.1724,7.181,10.2544,8.099,10.2544,9.227H8.9524C8.9524,7.382,10.4544,5.879,12.3004,5.879C14.1454,5.879,15.6474,7.382,15.6474,9.227C15.6474,10.851,14.4864,12.208,12.9514,12.512V12.512zM11.6484,16.973H12.9514V15.671H11.6484V16.973zM12.3004,2C7.1724,2,3.0004,6.172,3.0004,11.3C3.0004,13.415,3.7184,15.361,4.9114,16.925L4.2264,21.096L8.1564,19.614C9.4054,20.239,10.8094,20.6,12.3004,20.6C17.4284,20.6,21.5994,16.428,21.5994,11.3C21.5994,6.172,17.4284,2,12.3004,2V2z"
  },
  ic24_inquire_line: {
    width: 24,
    height: 24,
    path: "M11.7008,3.3995C7.1238,3.3995,3.3998,7.0175,3.3998,11.4655C3.3998,13.2315,3.9878,14.9165,5.0998,16.3375L5.2908,16.5805L4.7768,19.6275L7.7288,18.5435L7.9968,18.6725C9.1658,19.2445,10.4118,19.5325,11.7008,19.5325C16.2768,19.5325,19.9998,15.9145,19.9998,11.4655C19.9998,7.0175,16.2768,3.3995,11.7008,3.3995zM2.9958,21.7725L3.8088,16.9505C2.6248,15.3345,1.9998,13.4445,1.9998,11.4655C1.9998,6.2465,6.3508,2.0005,11.7008,2.0005C17.0488,2.0005,21.3998,6.2465,21.3998,11.4655C21.3998,16.6855,17.0488,20.9325,11.7008,20.9325C10.2988,20.9325,8.9388,20.6385,7.6568,20.0605L2.9958,21.7725zM11.9513,12.5118V14.1828H10.6483V11.2728H11.3003C12.4283,11.2728,13.3463,10.3548,13.3463,9.2268C13.3463,8.0988,12.4283,7.1808,11.3003,7.1808C10.1723,7.1808,9.2543,8.0988,9.2543,9.2268H7.9523C7.9523,7.3818,9.4543,5.8788,11.3003,5.8788C13.1453,5.8788,14.6473,7.3818,14.6473,9.2268C14.6473,10.8508,13.4863,12.2078,11.9513,12.5118zM11.952,16.9729H10.649V15.6709H11.952V16.9729z"
  },
  ic24_key_close: {
    width: 24,
    height: 24,
    path: "M19.129,22.3795H4.4V12.0925H19.129V22.3795zM16.961,6.1965V10.6925H20.529V23.7795H3V10.6925H6.568V6.1965C6.568,3.3315,8.899,1.0005,11.764,1.0005C14.629,1.0005,16.961,3.3315,16.961,6.1965zM7.968,6.1965V10.6925H15.561V6.1965C15.561,4.1035,13.858,2.4005,11.764,2.4005C9.671,2.4005,7.968,4.1035,7.968,6.1965zM11.7641,18.2257L9.5581,20.4327L8.5681,19.4427L10.7741,17.2367L8.5681,15.0297L9.5581,14.0397L11.7641,16.2457L13.9711,14.0397L14.9611,15.0297L12.7551,17.2367L14.9611,19.4427L13.9711,20.4327L11.7641,18.2257z"
  },
  ic24_key_close_fill: {
    width: 24,
    height: 24,
    path: "M16.87,10.63V6.17C16.87,3.32,14.55,1,11.71,1C8.86,1,6.54,3.32,6.54,6.17V10.64H3V23.64H20.41V10.64H16.87V10.63zM7.94,6.17C7.94,4.09,9.63,2.4,11.71,2.4C13.79,2.4,15.48,4.09,15.48,6.17V10.64H7.94V6.17zM14.9,19.3L13.91,20.29L11.7,18.08L9.5,20.29L8.51,19.3L10.72,17.09L8.51,14.88L9.5,13.9L11.71,16.11L13.92,13.9L14.91,14.89L12.7,17.1L14.9,19.3z"
  },
  ic24_key_horn: {
    width: 24,
    height: 24,
    path: "M16.988,12.552C16.988,12.105,16.705,11.724,16.313,11.589V13.515C16.705,13.38,16.988,12.999,16.988,12.552zM4.4,13.552L14.913,18.542V6.215L4.4,11.206V13.552zM16.313,4V10.158C17.482,10.313,18.388,11.327,18.388,12.552C18.388,13.777,17.482,14.791,16.313,14.947V20.757L3,14.437V10.322L16.313,4zM18.3064,8.3999L19.1304,7.2689C20.8124,8.4949,21.8174,10.4799,21.8174,12.5779C21.8174,14.4919,20.9924,16.3029,19.5554,17.5479L18.6384,16.4899C19.7684,15.5109,20.4164,14.0849,20.4164,12.5779C20.4164,10.9249,19.6274,9.3639,18.3064,8.3999z"
  },
  ic24_key_horn_fill: {
    width: 24,
    height: 24,
    path: "M16.988,12.552C16.988,12.105,16.705,11.724,16.313,11.589V13.515C16.705,13.38,16.988,12.999,16.988,12.552zM16.313,4V10.159C17.482,10.313,18.388,11.327,18.388,12.552C18.388,13.777,17.482,14.791,16.313,14.947V20.757L3,14.437V10.322L16.313,4zM18.3064,8.3999L19.1304,7.2689C20.8124,8.4959,21.8174,10.4799,21.8174,12.5789C21.8174,14.4919,20.9924,16.3029,19.5554,17.5479L18.6384,16.4899C19.7684,15.5109,20.4164,14.0849,20.4164,12.5789C20.4164,10.9249,19.6274,9.3639,18.3064,8.3999z"
  },
  ic24_key_light: {
    width: 24,
    height: 24,
    path: "M12.29,3L2,20.64H22.58L12.29,3zM12.29,5.778L20.142,19.24H4.437L12.29,5.778zM8.605,16.679H16.009L12.307,10.333L8.605,16.679zM12.307,13.111L13.572,15.279H11.043L12.307,13.111z"
  },
  ic24_key_light_fill: {
    width: 24,
    height: 24,
    path: "M1.9995,19.9515L11.8865,3.0005H11.8875L21.7745,19.9515H1.9995zM16.0755,16.7055L11.8355,9.6695L7.5945,16.7055H16.0755zM9.8749,15.5293L11.8829,12.0503L13.8909,15.5293H9.8749z"
  },
  ic24_key_open: {
    width: 24,
    height: 24,
    path: "M19.012,11.0328V21.2318H4.4V11.0328H19.012zM7.94,5.1668V9.6328H20.412V22.6318H3V9.6328H6.539V5.1668C6.539,2.3178,8.857-0.0002,11.706-0.0002C14.555-0.0002,16.873,2.3178,16.873,5.1668H15.472C15.472,3.0898,13.783,1.4008,11.706,1.4008C9.629,1.4008,7.94,3.0898,7.94,5.1668zM13.7404,16.0465C13.7404,14.8865,12.7964,13.9425,11.6364,13.9425C10.4764,13.9425,9.5324,14.8865,9.5324,16.0465C9.5324,17.2055,10.4764,18.1495,11.6364,18.1495C12.7964,18.1495,13.7404,17.2055,13.7404,16.0465zM15.1394,16.0465C15.1394,17.9815,13.5714,19.5495,11.6364,19.5495C9.7014,19.5495,8.1334,17.9815,8.1334,16.0465C8.1334,14.1105,9.7014,12.5425,11.6364,12.5425C13.5714,12.5425,15.1394,14.1105,15.1394,16.0465z"
  },
  ic24_key_open_fill: {
    width: 24,
    height: 24,
    path: "M7.7089,17.1345C7.7089,19.3425,9.4979,21.1315,11.7059,21.1315C13.9129,21.1315,15.7029,19.3425,15.7029,17.1345C15.7029,14.9275,13.9129,13.1385,11.7059,13.1385C9.4979,13.1385,7.7089,14.9275,7.7089,17.1345zM7.9399,6.1665V10.6325H20.4119V23.6315H2.9999V10.6325H6.5389V6.1665C6.5389,3.3185,8.8569,0.9995,11.7059,0.9995C14.5549,0.9995,16.8729,3.3185,16.8729,6.1665H15.4729C15.4729,4.0895,13.7829,2.4005,11.7059,2.4005C9.6289,2.4005,7.9399,4.0895,7.9399,6.1665zM9.3069,17.134C9.3069,15.812,10.3829,14.735,11.7059,14.735C13.0289,14.735,14.1049,15.812,14.1049,17.134C14.1049,18.458,13.0289,19.535,11.7059,19.535C10.3829,19.535,9.3069,18.458,9.3069,17.134z"
  },
  ic24_key_return: {
    width: 24,
    height: 24,
    path: "M20.983,12H19.724C19.725,12.047,19.731,12.092,19.731,12.14C19.731,16.405,16.261,19.875,11.995,19.875C7.73,19.875,4.259,16.405,4.259,12.14C4.259,7.874,7.73,4.404,11.995,4.404C13.92,4.404,15.678,5.115,17.033,6.283C15.694,7.63,14.445,8.888,14.417,8.917H20.292V3C20.292,3,19.177,4.123,17.919,5.39C16.336,3.999,14.269,3.145,11.995,3.145C7.027,3.145,3,7.172,3,12.14C3,17.107,7.027,21.135,11.995,21.135C16.963,21.135,20.99,17.107,20.99,12.14C20.99,12.092,20.984,12.047,20.983,12"
  },
  ic24_letter_b: {
    width: 24,
    height: 24,
    path: "M15.4653,15.1542C15.4653,14.6592,15.3213,14.2392,15.0363,13.8922C14.7513,13.5482,14.3903,13.3742,13.9553,13.3742H9.6953V16.8672H13.7973C14.2783,16.8672,14.6753,16.7102,14.9913,16.3942C15.3063,16.0792,15.4653,15.6662,15.4653,15.1542V15.1542zM9.6953,7.1542V10.4672H13.3243C13.7293,10.4672,14.0903,10.3322,14.4053,10.0612C14.7203,9.7912,14.8783,9.3712,14.8783,8.8002C14.8783,8.2742,14.7393,7.8682,14.4623,7.5832C14.1843,7.2972,13.8493,7.1542,13.4593,7.1542H9.6953zM19.2283,15.8982C19.2283,16.5892,19.0853,17.1902,18.7993,17.7012C18.5143,18.2122,18.1233,18.6362,17.6283,18.9742C17.1323,19.3122,16.5533,19.5682,15.8923,19.7412C15.2313,19.9142,14.5333,20.0002,13.7973,20.0002H6.0003V4.0002H14.9023C15.4573,4.0002,15.9603,4.1202,16.4113,4.3602C16.8613,4.6002,17.2453,4.9122,17.5603,5.2952C17.8763,5.6782,18.1193,6.1142,18.2933,6.6022C18.4653,7.0912,18.5523,7.5912,18.5523,8.1012C18.5523,8.8672,18.3603,9.5892,17.9773,10.2642C17.5943,10.9402,17.0193,11.4512,16.2533,11.7972C17.1703,12.0672,17.8953,12.5492,18.4273,13.2392C18.9613,13.9302,19.2283,14.8172,19.2283,15.8982V15.8982z"
  },
  ic24_letter_c: {
    width: 24,
    height: 24,
    path: "M4.5244,11.8448C4.5244,10.8978,4.7014,9.9528,5.0574,9.0118C5.4134,8.0718,5.9314,7.2308,6.6134,6.4898C7.2944,5.7488,8.1254,5.1488,9.1024,4.6898C10.0804,4.2308,11.1914,3.9998,12.4354,3.9998C13.9174,3.9998,15.2024,4.3198,16.2914,4.9558C17.3794,5.5938,18.1914,6.4228,18.7244,7.4458L15.9244,9.4008C15.7464,8.9858,15.5204,8.6418,15.2474,8.3668C14.9714,8.0938,14.6714,7.8698,14.3464,7.7008C14.0204,7.5308,13.6874,7.4108,13.3464,7.3448C13.0044,7.2788,12.6724,7.2438,12.3464,7.2438C11.6494,7.2438,11.0424,7.3858,10.5244,7.6668C10.0054,7.9488,9.5764,8.3118,9.2354,8.7558C8.8944,9.1998,8.6424,9.7038,8.4804,10.2678C8.3164,10.8298,8.2354,11.4008,8.2354,11.9788C8.2354,12.6008,8.3314,13.1998,8.5244,13.7788C8.7164,14.3558,8.9944,14.8668,9.3574,15.3118C9.7204,15.7558,10.1584,16.1088,10.6694,16.3668C11.1804,16.6258,11.7544,16.7558,12.3904,16.7558C12.7164,16.7558,13.0534,16.7148,13.4024,16.6338C13.7504,16.5518,14.0834,16.4268,14.4014,16.2558C14.7194,16.0858,15.0134,15.8638,15.2794,15.5898C15.5464,15.3158,15.7604,14.9778,15.9244,14.5768L18.9024,16.3338C18.6654,16.9118,18.3124,17.4308,17.8464,17.8888C17.3794,18.3488,16.8424,18.7338,16.2354,19.0448C15.6284,19.3558,14.9834,19.5928,14.3024,19.7558C13.6204,19.9188,12.9544,19.9998,12.3024,19.9998C11.1614,19.9998,10.1134,19.7668,9.1574,19.2998C8.2024,18.8338,7.3804,18.2148,6.6904,17.4458C6.0024,16.6748,5.4684,15.8008,5.0914,14.8228C4.7134,13.8448,4.5244,12.8528,4.5244,11.8448"
  },
  ic24_letter_d: {
    width: 24,
    height: 24,
    path: "M15.5703,11.9775C15.5703,11.2725,15.4763,10.6305,15.2893,10.0535C15.1013,9.4764,14.8273,8.9774,14.4673,8.5574C14.1073,8.1374,13.6653,7.8144,13.1393,7.5895C12.6153,7.3655,12.0223,7.2515,11.3623,7.2515H9.0903V16.7475H11.3623C12.0383,16.7475,12.6373,16.6265,13.1633,16.3875C13.6873,16.1475,14.1263,15.8135,14.4783,15.3855C14.8313,14.9585,15.1013,14.4565,15.2893,13.8785C15.4763,13.3015,15.5703,12.6665,15.5703,11.9775V11.9775zM5.4003,19.9875V4.0125H11.3623C12.6823,4.0125,13.8383,4.2225,14.8273,4.6425C15.8173,5.0625,16.6463,5.6315,17.3133,6.3525C17.9813,7.0724,18.4833,7.9154,18.8213,8.8834C19.1593,9.8505,19.3273,10.8825,19.3273,11.9775C19.3273,13.1925,19.1393,14.2905,18.7643,15.2735C18.3893,16.2555,17.8533,17.0955,17.1563,17.7935C16.4593,18.4915,15.6183,19.0315,14.6363,19.4135C13.6533,19.7955,12.5623,19.9875,11.3623,19.9875H5.4003z"
  },
  ic24_letter_e: {
    width: 24,
    height: 24,
    path: "M17.999,16.755V20H6.001V4H17.999V7.244H9.696V10.355H16.962V13.352H9.696V16.755H17.999z"
  },
  ic24_map: {
    width: 24,
    height: 24,
    path: "M20.95,17.4907V4.001L14.7501,6.2555L9.4925,4.3437C9.4147,4.3149,9.3326,4.3003,9.25,4.3003C9.1674,4.3003,9.0853,4.3149,9.0075,4.3436L3.05,6.51V19.9997L9.25,17.7451L14.5012,19.6547C14.6565,19.7137,14.8296,19.7163,14.9892,19.6582L20.95,17.4907zM14.05,18.0009L9.95,16.51V5.9997L14.05,7.4906V18.0009zM15.45,18.001V7.4907L19.55,5.9998V16.5101L15.45,18.001zM8.55,5.9997V16.51L4.45,18.0009V7.4906L8.55,5.9997z"
  },
  ic24_menu: {
    width: 24,
    height: 24,
    path: "M4,7.4005H20.101V6.0005H4V7.4005zM4,13.1505H20.101V11.7505H4V13.1505zM20.101,18.9005H4V17.5005H20.101V18.9005z"
  },
  ic24_minus: {
    width: 24,
    height: 24,
    path: "M4,11H20V12.4H4z"
  },
  ic24_more_horiz: {
    width: 24,
    height: 24,
    path: "M6,10C4.9,10,4,10.9,4,12C4,13.1,4.9,14,6,14C7.1,14,8,13.1,8,12C8,10.9,7.1,10,6,10zM18,10C16.9,10,16,10.9,16,12C16,13.1,16.9,14,18,14C19.1,14,20,13.1,20,12C20,10.9,19.1,10,18,10zM12,10C10.9,10,10,10.9,10,12C10,13.1,10.9,14,12,14C13.1,14,14,13.1,14,12C14,10.9,13.1,10,12,10z"
  },
  ic24_morepic: {
    width: 24,
    height: 24,
    path: "M19.2006,18.7999H20.5996V3.3999H5.2006V4.7999H19.2006V18.7999zM10.0004,18.7999H13.7734H16.7994L13.4034,14.6999L12.0014,16.3889L9.1914,12.5669L4.6004,18.7999H10.0004zM15.3284,10.2549C15.3284,9.3439,14.5884,8.6059,13.6784,8.6059C12.7674,8.6059,12.0294,9.3439,12.0294,10.2549C12.0294,11.1659,12.7674,11.9039,13.6784,11.9039C14.5884,11.9039,15.3284,11.1659,15.3284,10.2549zM18.2004,20.7999H3.2004V5.7999H18.2004V20.7999z"
  },
  ic24_morepic_line: {
    width: 24,
    height: 24,
    path: "M20.5996,18.7999H19.2006V4.7999H5.2006V3.3999H20.5996V18.7999zM3.2,20.8001H18.2V5.8001H3.2V20.8001zM4.6,19.4001H16.8V7.2001H4.6V19.4001zM10.3037,18.1905H5.7002L9.6142,12.8775L12.0091,16.1359L13.2047,14.6955L16.0997,18.1905H13.5192H10.3037zM13.4397,12.3119C14.2157,12.3119,14.8447,11.6819,14.8447,10.9059C14.8447,10.1299,14.2157,9.4999,13.4397,9.4999C12.6617,9.4999,12.0327,10.1299,12.0327,10.9059C12.0327,11.6819,12.6617,12.3119,13.4397,12.3119z"
  },
  ic24_morepic_video: {
    width: 24,
    height: 24,
    path: "M3,18H21V5H3V18zM9.6018,7.9708L15.6018,11.5L9.6018,15.0292V7.9708z"
  },
  ic24_mylocation: {
    width: 24,
    height: 24,
    path: "M5.8001,11.8995C5.8001,15.2635,8.5361,17.9995,11.9001,17.9995C15.2631,17.9995,18.0001,15.2635,18.0001,11.8995C18.0001,8.5365,15.2631,5.7995,11.9001,5.7995C8.5361,5.7995,5.8001,8.5365,5.8001,11.8995zM19.3651,11.1995H21.8001V12.6005H19.3651C19.0321,16.1775,16.1771,19.0315,12.6001,19.3645V21.7995H11.2001V19.3645C7.6221,19.0315,4.7681,16.1775,4.4351,12.6005H2.0001V11.1995H4.4351C4.7681,7.6225,7.6221,4.7685,11.2001,4.4355V1.9995H12.6001V4.4355C16.1771,4.7685,19.0311,7.6225,19.3651,11.1995zM11.9001,14.8999C13.5571,14.8999,14.9001,13.5569,14.9001,11.8999C14.9001,10.2429,13.5571,8.8999,11.9001,8.8999C10.2431,8.8999,8.9001,10.2429,8.9001,11.8999C8.9001,13.5569,10.2431,14.8999,11.9001,14.8999z"
  },
  ic24_mypage: {
    width: 24,
    height: 24,
    path: "M14.6852,6.683C14.6852,5.313,13.5722,4.199,12.2022,4.199C10.8332,4.199,9.7192,5.313,9.7192,6.683C9.7192,8.053,10.8332,9.167,12.2022,9.167C13.5722,9.167,14.6852,8.053,14.6852,6.683zM15.8862,6.683C15.8862,8.715,14.2332,10.366,12.2022,10.366C10.1712,10.366,8.5192,8.715,8.5192,6.683C8.5192,4.652,10.1712,3,12.2022,3C14.2332,3,15.8862,4.652,15.8862,6.683zM13.0326,13.0829C12.9885,13.0759,12.9444,13.0689,12.899,13.0642C12.67,13.0422,12.438,13.0292,12.202,13.0292C11.967,13.0292,11.734,13.0422,11.505,13.0642C11.4604,13.0688,11.4165,13.0758,11.3724,13.0828C11.3405,13.0879,11.3084,13.093,11.276,13.0972C11.246,13.1014,11.216,13.1055,11.1859,13.1096C11.0658,13.1259,10.9456,13.1422,10.828,13.1662C10.7717,13.1775,10.7166,13.1918,10.6617,13.2062C10.6288,13.2148,10.596,13.2233,10.563,13.2312C10.432,13.2622,10.301,13.2932,10.173,13.3322C10.1057,13.3522,10.0395,13.376,9.9728,13.4C9.9493,13.4084,9.9257,13.4169,9.902,13.4252C9.8854,13.431,9.8688,13.4368,9.8521,13.4426C9.7486,13.4787,9.6448,13.5148,9.544,13.5562C9.4746,13.5852,9.407,13.617,9.3398,13.6487C9.3188,13.6586,9.2979,13.6685,9.277,13.6782C9.2637,13.6844,9.2503,13.6906,9.237,13.6968C9.1384,13.7424,9.04,13.788,8.944,13.8382C8.8801,13.872,8.8172,13.9091,8.7542,13.9462C8.7315,13.9596,8.7088,13.9729,8.686,13.9862C8.582,14.0462,8.478,14.1082,8.378,14.1732C8.3123,14.2165,8.2489,14.2616,8.1856,14.3067C8.1671,14.3199,8.1486,14.3331,8.13,14.3462L8.1179,14.355C8.026,14.422,7.9351,14.4883,7.847,14.5582C7.767,14.6222,7.69,14.6882,7.614,14.7542C7.525,14.8322,7.439,14.9102,7.354,14.9912C7.281,15.0612,7.21,15.1342,7.139,15.2092C7.059,15.2932,6.981,15.3782,6.905,15.4662C6.837,15.5442,6.772,15.6242,6.708,15.7052C6.636,15.7952,6.567,15.8882,6.5,15.9822L6.4908,15.9953C6.4348,16.0751,6.3781,16.1557,6.325,16.2382C6.262,16.3362,6.202,16.4362,6.143,16.5382C6.1383,16.5463,6.1337,16.5544,6.1291,16.5625C6.0827,16.6433,6.0367,16.7235,5.994,16.8062C5.939,16.9122,5.889,17.0192,5.839,17.1272H5.839C5.796,17.2202,5.753,17.3132,5.715,17.4082C5.67,17.5192,5.63,17.6332,5.59,17.7472C5.583,17.7676,5.5761,17.788,5.569,17.8084C5.5428,17.8848,5.5167,17.9611,5.493,18.0392C5.4592,18.1531,5.431,18.2698,5.403,18.3857L5.4,18.3982C5.3929,18.429,5.3854,18.4596,5.378,18.4901C5.3615,18.5578,5.3451,18.6253,5.332,18.6942C5.3116,18.7977,5.2972,18.9032,5.2829,19.0085C5.2796,19.0324,5.2763,19.0563,5.273,19.0802C5.2696,19.1036,5.2661,19.127,5.2626,19.1504C5.2516,19.2241,5.2406,19.2981,5.233,19.3732C5.2325,19.3827,5.2322,19.3927,5.232,19.4027C5.2317,19.4127,5.2315,19.4227,5.231,19.4322H19.174C19.173,19.4227,19.1727,19.4127,19.1725,19.4027C19.1722,19.3927,19.172,19.3827,19.171,19.3732C19.1639,19.2955,19.1526,19.219,19.1412,19.1428C19.1381,19.1219,19.135,19.1011,19.132,19.0802C19.1287,19.0563,19.1254,19.0324,19.1221,19.0085C19.1078,18.9032,19.0934,18.7977,19.073,18.6942C19.0586,18.6186,19.0403,18.5447,19.0218,18.4703C19.0158,18.4464,19.0099,18.4223,19.004,18.3982C18.976,18.2782,18.947,18.1572,18.912,18.0392C18.8839,17.9466,18.8524,17.8566,18.8206,17.766L18.814,17.7472C18.775,17.6332,18.735,17.5192,18.69,17.4082C18.6576,17.3293,18.6225,17.2518,18.5874,17.1745C18.5803,17.1587,18.5731,17.143,18.566,17.1272C18.516,17.0192,18.466,16.9122,18.411,16.8062C18.364,16.7152,18.313,16.6272,18.261,16.5382C18.203,16.4362,18.143,16.3352,18.08,16.2382C18.024,16.1522,17.965,16.0672,17.905,15.9832C17.837,15.8882,17.768,15.7942,17.696,15.7042C17.633,15.6242,17.568,15.5442,17.501,15.4662C17.425,15.3782,17.346,15.2932,17.266,15.2082C17.195,15.1342,17.124,15.0612,17.051,14.9912C16.966,14.9102,16.879,14.8322,16.791,14.7542C16.7805,14.7452,16.77,14.7362,16.7596,14.7272C16.6932,14.6702,16.6271,14.6135,16.558,14.5582C16.466,14.4852,16.371,14.4162,16.274,14.3462C16.2622,14.3378,16.2504,14.3293,16.2386,14.3208C16.1693,14.2711,16.0996,14.221,16.027,14.1732C15.927,14.1082,15.823,14.0462,15.719,13.9862C15.6975,13.9737,15.6761,13.9611,15.6546,13.9484C15.5903,13.9106,15.526,13.8727,15.46,13.8382C15.3642,13.7876,15.2652,13.7418,15.1659,13.6958C15.1533,13.6899,15.1406,13.6841,15.128,13.6782C15.1006,13.6656,15.0735,13.6527,15.0463,13.6398C14.9851,13.6108,14.924,13.5818,14.861,13.5562C14.7602,13.5148,14.6564,13.4787,14.5529,13.4426C14.5362,13.4368,14.5196,13.431,14.503,13.4252C14.4793,13.4169,14.4557,13.4084,14.4322,13.4C14.3655,13.376,14.2993,13.3522,14.232,13.3322C14.104,13.2932,13.973,13.2622,13.842,13.2312V13.2312C13.8073,13.223,13.773,13.2141,13.7388,13.2051C13.6853,13.1911,13.6319,13.1772,13.577,13.1662C13.4589,13.1423,13.3388,13.126,13.2189,13.1097C13.1886,13.1056,13.1583,13.1014,13.128,13.0972C13.0958,13.093,13.0642,13.088,13.0326,13.0829zM4,20.0322C4,15.5092,7.68,11.8302,12.202,11.8302C16.725,11.8302,20.405,15.5092,20.405,20.0322V20.6312H4V20.0322z"
  },
  ic24_noti: {
    width: 24,
    height: 24,
    path: "M18.057,17.675L14.629,17.668H14.628L12.149,17.663L6.201,17.65L6.216,10.478C6.223,7.214,8.88,4.563,12.143,4.563C12.149,4.563,12.157,4.563,12.157,4.563C13.74,4.566,15.227,5.186,16.344,6.308C17.462,7.43,18.076,8.92,18.072,10.503L18.057,17.675zM12.126,20.163H12.123C11.386,20.161,10.756,19.714,10.479,19.078L13.773,19.085C13.493,19.719,12.861,20.163,12.126,20.163V20.163zM19.457,17.681L19.472,10.506C19.476,8.549,18.718,6.707,17.336,5.32C16.129,4.107,14.571,3.369,12.89,3.2V2H11.421V3.199C7.726,3.563,4.824,6.684,4.816,10.475L4.801,17.651L3.004,17.647L3,19.063L9.014,19.075C9.146,19.655,9.43,20.19,9.86,20.621C10.462,21.227,11.265,21.561,12.12,21.563H12.127C13.64,21.563,14.906,20.504,15.237,19.089L21.281,19.101L21.285,17.685L19.457,17.681z"
  },
  ic24_noti_on: {
    width: 24,
    height: 24,
    path: "M18.057,17.675L14.629,17.668H14.628L12.149,17.663L6.201,17.65L6.216,10.478C6.223,7.214,8.88,4.563,12.143,4.563C12.149,4.563,12.157,4.563,12.157,4.563C13.74,4.566,15.227,5.186,16.344,6.308C17.462,7.43,18.076,8.92,18.072,10.503L18.057,17.675zM12.126,20.163H12.123C11.386,20.161,10.756,19.714,10.479,19.078L13.773,19.085C13.493,19.719,12.861,20.163,12.126,20.163V20.163zM19.457,17.681L19.472,10.506C19.476,8.549,18.718,6.707,17.336,5.32C16.129,4.107,14.571,3.369,12.89,3.2V2H11.421V3.199C7.726,3.563,4.824,6.684,4.816,10.475L4.801,17.651L3.004,17.647L3,19.063L9.014,19.075C9.146,19.655,9.43,20.19,9.86,20.621C10.462,21.227,11.265,21.561,12.12,21.563H12.127C13.64,21.563,14.906,20.504,15.237,19.089L21.281,19.101L21.285,17.685L19.457,17.681zM20,2C20,0.8954,20.8954,0,22,0C23.1046,0,24,0.8954,24,2C24,3.1046,23.1046,4,22,4C20.8954,4,20,3.1046,20,2z"
  },
  ic24_number_1: {
    width: 24,
    height: 24,
    path: "M12,22C17.5228,22,22,17.5228,22,12C22,6.4771,17.5228,2,12,2C6.4771,2,2,6.4771,2,12C2,17.5228,6.4771,22,12,22zM12.896,14.6679V7.0239H11.48L8.888,9.2559L9.836,10.3359L11.3,9.0039L11.252,9.7839V14.6679H9.5V15.9999H14.444V14.6679H12.896z"
  },
  ic24_number_2: {
    width: 24,
    height: 24,
    path: "M12,22C17.5228,22,22,17.5228,22,12C22,6.4771,17.5228,2,12,2C6.4771,2,2,6.4771,2,12C2,17.5228,6.4771,22,12,22zM12.908,7.0719C12.564,6.9439,12.184,6.8799,11.768,6.8799C10.944,6.8799,10.252,7.0999,9.692,7.5399C9.14,7.9799,8.792,8.6599,8.648,9.5799L10.22,9.8439C10.228,9.7239,10.236,9.6159,10.244,9.5199C10.26,9.4239,10.284,9.3319,10.316,9.2439C10.412,8.9799,10.576,8.7519,10.808,8.5599C11.04,8.3599,11.324,8.2599,11.66,8.2599C12.052,8.2599,12.36,8.3679,12.584,8.5839C12.816,8.7919,12.932,9.1039,12.932,9.5199C12.932,9.9839,12.8,10.4119,12.536,10.8039C12.272,11.1959,11.912,11.6199,11.456,12.0759L8.444,15.0399V15.9999H14.696V14.4879H11.816C11.68,14.4879,11.536,14.4959,11.384,14.5119C11.24,14.5199,11.088,14.5439,10.928,14.5839L12.788,12.7119C13.012,12.4799,13.228,12.2399,13.436,11.9919C13.652,11.7439,13.844,11.4879,14.012,11.2239C14.18,10.9599,14.316,10.6839,14.42,10.3959C14.532,10.0999,14.592,9.7959,14.6,9.4839C14.6,9.0999,14.528,8.7479,14.384,8.4279C14.248,8.1079,14.056,7.8359,13.808,7.6119C13.56,7.3799,13.26,7.1999,12.908,7.0719z"
  },
  ic24_number_3: {
    width: 24,
    height: 24,
    path: "M12,22C17.5228,22,22,17.5228,22,12C22,6.4771,17.5228,2,12,2C6.4771,2,2,6.4771,2,12C2,17.5228,6.4771,22,12,22zM12.968,7.0839C12.632,6.9559,12.252,6.8879,11.828,6.8799C10.98,6.8799,10.28,7.0959,9.728,7.5279C9.184,7.9599,8.824,8.6359,8.648,9.5559C8.912,9.5959,9.172,9.6439,9.428,9.6999C9.692,9.7479,9.952,9.7919,10.208,9.8319C10.248,9.6159,10.3,9.4159,10.364,9.2319C10.436,9.0399,10.528,8.8759,10.64,8.7399C10.76,8.6039,10.908,8.4959,11.084,8.4159C11.26,8.3359,11.476,8.2959,11.732,8.2959C12.124,8.2959,12.428,8.3999,12.644,8.6079C12.868,8.8079,12.976,9.1159,12.968,9.5319C12.968,9.7239,12.94,9.8999,12.884,10.0599C12.828,10.2119,12.728,10.3479,12.584,10.4679C12.44,10.5799,12.24,10.6679,11.984,10.7319C11.736,10.7959,11.412,10.8319,11.012,10.8399V12.0399C11.484,12.0399,11.856,12.0759,12.128,12.1479C12.408,12.2119,12.62,12.3079,12.764,12.4359C12.908,12.5559,13,12.7039,13.04,12.8799C13.088,13.0559,13.112,13.2479,13.112,13.4559C13.112,13.6239,13.08,13.7879,13.016,13.9479C12.952,14.1079,12.852,14.2519,12.716,14.3799C12.588,14.4999,12.424,14.5999,12.224,14.6799C12.032,14.7519,11.804,14.7879,11.54,14.7879C11.324,14.7879,11.124,14.7399,10.94,14.6439C10.756,14.5479,10.588,14.4239,10.436,14.2719C10.284,14.1119,10.156,13.9359,10.052,13.7439C9.948,13.5519,9.872,13.3599,9.824,13.1679L8.36,13.7439C8.48,14.1359,8.628,14.4879,8.804,14.7999C8.98,15.1039,9.196,15.3639,9.452,15.5799C9.716,15.7879,10.02,15.9479,10.364,16.0599C10.708,16.1719,11.108,16.2279,11.564,16.2279C11.988,16.2279,12.388,16.1679,12.764,16.0479C13.148,15.9279,13.484,15.7519,13.772,15.5199C14.06,15.2799,14.292,14.9839,14.468,14.6319C14.644,14.2799,14.736,13.8759,14.744,13.4199C14.744,12.8919,14.624,12.4559,14.384,12.1119C14.152,11.7599,13.772,11.4839,13.244,11.2839C13.628,11.0999,13.948,10.8519,14.204,10.5399C14.46,10.2199,14.588,9.8039,14.588,9.2919C14.596,8.9559,14.536,8.6439,14.408,8.3559C14.28,8.0679,14.092,7.8159,13.844,7.5999C13.604,7.3839,13.312,7.2119,12.968,7.0839z"
  },
  ic24_number_4: {
    width: 24,
    height: 24,
    path: "M12,22C17.5228,22,22,17.5228,22,12C22,6.4771,17.5228,2,12,2C6.4771,2,2,6.4771,2,12C2,17.5228,6.4771,22,12,22zM15.068,12.4719H13.94V6.9399H12.392C11.688,7.8599,10.996,8.7839,10.316,9.7119C9.636,10.6399,8.944,11.5639,8.24,12.4839V13.8279H12.488V15.9999H13.94V13.8279H15.068V12.4719zM12.488,9.3999V9.6999V12.4959H9.872L12.512,8.9439C12.504,9.1039,12.496,9.2559,12.488,9.3999z"
  },
  ic24_number_5: {
    width: 24,
    height: 24,
    path: "M12,22C17.5228,22,22,17.5228,22,12C22,6.4771,17.5228,2,12,2C6.4771,2,2,6.4771,2,12C2,17.5228,6.4771,22,12,22zM10.952,8.4999H14.324V7.0239H9.788C9.724,7.4079,9.628,7.9639,9.5,8.6919C9.38,9.4119,9.228,10.3519,9.044,11.5119L10.052,11.8119C10.268,11.7319,10.484,11.6719,10.7,11.6319C10.916,11.5839,11.136,11.5519,11.36,11.5359C11.912,11.5199,12.328,11.6479,12.608,11.9199C12.888,12.1919,13.028,12.5679,13.028,13.0479C13.028,13.5759,12.884,13.9999,12.596,14.3199C12.308,14.6319,11.888,14.7879,11.336,14.7879C10.952,14.7879,10.6,14.6999,10.28,14.5239C9.96,14.3479,9.66,14.1439,9.38,13.9119L8.54,15.1359C8.844,15.4239,9.232,15.6759,9.704,15.8919C10.176,16.1079,10.688,16.2159,11.24,16.2159C11.72,16.2159,12.168,16.1399,12.584,15.9879C13,15.8279,13.36,15.6079,13.664,15.3279C13.968,15.0399,14.204,14.6959,14.372,14.2959C14.548,13.8959,14.636,13.4559,14.636,12.9759C14.636,12.5759,14.572,12.2079,14.444,11.8719C14.316,11.5279,14.128,11.2319,13.88,10.9839C13.632,10.7279,13.324,10.5279,12.956,10.3839C12.588,10.2399,12.164,10.1679,11.684,10.1679C11.524,10.1679,11.356,10.1759,11.18,10.1919C11.012,10.1999,10.836,10.2199,10.652,10.2519L10.952,8.4999z"
  },
  ic24_number_6: {
    width: 24,
    height: 24,
    path: "M12,22C17.5228,22,22,17.5228,22,12C22,6.4771,17.5228,2,12,2C6.4771,2,2,6.4771,2,12C2,17.5228,6.4771,22,12,22zM13.112,10.5882C12.792,10.4762,12.456,10.4202,12.104,10.4202C11.736,10.4202,11.412,10.4682,11.132,10.5642L11,10.6242L11.3,10.3362C11.74,9.7762,12.176,9.2242,12.608,8.6802C13.04,8.1282,13.484,7.5722,13.94,7.0122H11.924L9.488,10.3002C9.144,10.7802,8.88,11.2482,8.696,11.7042C8.512,12.1602,8.42,12.5922,8.42,13.0002C8.42,13.4802,8.492,13.9202,8.636,14.3202C8.788,14.7202,9,15.0602,9.272,15.3402C9.544,15.6202,9.872,15.8402,10.256,16.0002C10.648,16.1522,11.088,16.2282,11.576,16.2282C12.056,16.2282,12.496,16.1482,12.896,15.9882C13.296,15.8282,13.636,15.6082,13.916,15.3282C14.196,15.0482,14.412,14.7242,14.564,14.3562C14.724,13.9802,14.804,13.5802,14.804,13.1562C14.804,12.7002,14.728,12.3002,14.576,11.9562C14.424,11.6122,14.224,11.3282,13.976,11.1042C13.728,10.8722,13.44,10.7002,13.112,10.5882zM10.424,14.4402C10.144,14.1522,10.004,13.7522,10.004,13.2402C10.004,12.7602,10.144,12.3802,10.424,12.1002C10.704,11.8122,11.084,11.6682,11.564,11.6682C12.052,11.6682,12.444,11.8002,12.74,12.0642C13.044,12.3282,13.196,12.7242,13.196,13.2522C13.196,13.4922,13.152,13.7122,13.064,13.9122C12.984,14.1122,12.868,14.2842,12.716,14.4282C12.564,14.5722,12.388,14.6842,12.188,14.7642C11.996,14.8362,11.784,14.8722,11.552,14.8722C11.088,14.8722,10.712,14.7282,10.424,14.4402z"
  },
  ic24_number_7: {
    width: 24,
    height: 24,
    path: "M12,22C17.5228,22,22,17.5228,22,12C22,6.4771,17.5228,2,12,2C6.4771,2,2,6.4771,2,12C2,17.5228,6.4771,22,12,22zM15.684,8.26V7.084H9.636V8.56H13.92C13.84,8.664,13.756,8.804,13.668,8.98V8.992C13.66,8.992,13.656,8.996,13.656,9.004L13.608,9.1L13.596,9.112V9.124C13.556,9.188,13.512,9.264,13.464,9.352C13.424,9.44,13.392,9.504,13.368,9.544C12.856,10.648,12.328,11.724,11.784,12.772C11.248,13.812,10.724,14.888,10.212,16H12.048L15.684,8.26z"
  },
  ic24_numkey: {
    width: 24,
    height: 24,
    path: "M9.003,6.0028H6V2.9998H9.003V6.0028zM14.071,6.0028H11.068V2.9998H14.071V6.0028zM16.089,6.0028H19.092V2.9998H16.089V6.0028zM9.003,11.0008H6V7.9978H9.003V11.0008zM11.068,11.0008H14.071V7.9978H11.068V11.0008zM19.092,11.0008H16.089V7.9978H19.092V11.0008zM6,15.9748H9.003V12.9718H6V15.9748zM14.071,15.9758H11.068V12.9728H14.071V15.9758zM11.068,20.9378H14.071V17.9348H11.068V20.9378zM19.092,15.9748H16.089V12.9718H19.092V15.9748z"
  },
  ic24_oil: {
    width: 24,
    height: 24,
    path: "M6.7402,6.537C11.4412,3.553,17.6092,5.046,20.5162,9.871C22.2342,12.723,22.4092,16.096,21.3052,18.996L19.7802,18.403C20.7092,15.969,20.5702,13.14,19.1292,10.749C19.0669,10.6456,18.9986,10.5481,18.9304,10.4507C18.9056,10.4152,18.8807,10.3797,18.8562,10.344L16.8702,12.329L15.8102,11.269L17.9022,9.177C16.4732,7.719,14.6002,6.868,12.6502,6.71V9.169H11.3502V6.706C10.0582,6.807,8.7712,7.211,7.5962,7.957C7.0392,8.31,6.5442,8.725,6.0992,9.179L8.1892,11.269L7.1292,12.329L5.1452,10.346C3.5672,12.669,3.1722,15.701,4.2072,18.408L2.6842,19C0.9582,14.471,2.5642,9.184,6.7402,6.537zM10.0001,15C10.0001,13.896,10.8961,13,12.0001,13C13.1041,13,14.0001,13.896,14.0001,15C14.0001,16.104,13.1041,17,12.0001,17C11.6251,17,11.2801,16.891,10.9801,16.712L6.3091,19.515L5.6911,18.485L10.1681,15.799C10.0611,15.554,10.0001,15.285,10.0001,15z"
  },
  ic24_oil_fill: {
    width: 24,
    height: 24,
    path: "M8,8H16V4.7999H8V8zM13.837,16.67C13.455,17.286,12.778,17.7,12,17.7C11.222,17.7,10.545,17.286,10.163,16.67C9.958,16.339,9.833,15.952,9.833,15.533C9.833,15.295,9.872,15.058,9.949,14.832C10.026,14.608,10.148,14.407,10.266,14.202C10.384,13.996,10.502,13.789,10.621,13.583C10.771,13.32,11.955,11.279,12,11.2C12.045,11.279,13.229,13.32,13.38,13.583C13.498,13.789,13.616,13.996,13.734,14.202C13.853,14.407,13.974,14.608,14.051,14.832C14.128,15.058,14.167,15.295,14.167,15.533C14.167,15.952,14.043,16.339,13.837,16.67V16.67zM5.5,21.8H18.5V2.1999H5.5V21.8z"
  },
  ic24_phone: {
    width: 24,
    height: 24,
    path: "M6,22H18.8V2H6V22zM7.4,4.8V19.2H17.4V4.8H7.4z"
  },
  ic24_phone_fill: {
    width: 24,
    height: 24,
    path: "M6.285,3.3323C6.285,3.3323,2.497,6.5423,7.929,15.1663V15.1663L8.008,15.2923C13.441,23.9183,17.257,20.7533,17.257,20.7533V20.7533L18.847,19.4183L15.646,14.3363L14.055,15.6693C14.055,15.6693,12.845,16.9743,10.48,13.2203V13.2203L10.401,13.0953C8.037,9.3413,9.487,8.4153,9.487,8.4153V8.4153L11.077,7.0823L7.876,1.9993L6.285,3.3323z"
  },
  ic24_pick_fill: {
    width: 24,
    height: 24,
    path: "M19.5499,20.9005L11.9999,13.5005L4.4499,20.9005V3.0005H19.5499V20.9005z"
  },
  ic24_pick_line: {
    width: 24,
    height: 24,
    path: "M4,3V20.977L11.55,13.297L19.1,20.977V3H4zM5.4,4.4H17.7V17.556L11.55,11.301L5.4,17.556V4.4z"
  },
  ic24_plus: {
    width: 24,
    height: 24,
    path: "M11.226,4V11.226H4V12.626H11.226V19.854H12.626V12.626H19.854V11.226H12.626V4H11.226z"
  },
  ic24_poi_current: {
    width: 24,
    height: 24,
    path: "M9.1661,8.9539C9.1661,10.5039,10.4261,11.7609,11.9791,11.7609C13.5331,11.7609,14.7921,10.5039,14.7921,8.9539C14.7921,7.4039,13.5331,6.1469,11.9791,6.1469C10.4261,6.1469,9.1661,7.4039,9.1661,8.9539zM12.2681,2.0059C15.1251,2.1199,17.5611,4.1119,18.5511,6.7879C19.5931,9.6029,18.6951,11.7579,17.1411,13.6909L11.9421,19.9999L6.7961,13.6909C5.7431,12.4059,5.0001,10.7949,5.0001,8.9649C5.0001,5.0219,8.2821,1.8449,12.2681,2.0059zM14.9996,21.0001C14.9996,21.5521,13.6566,22.0001,11.9996,22.0001C10.3436,22.0001,8.9996,21.5521,8.9996,21.0001C8.9996,20.4481,10.3436,20.0001,11.9996,20.0001C13.6566,20.0001,14.9996,20.4481,14.9996,21.0001z"
  },
  ic24_poi_fill: {
    width: 24,
    height: 24,
    path: "M11.7292,12.8317C10.0092,12.8317,8.6142,11.4367,8.6142,9.7167C8.6142,7.9967,10.0092,6.6017,11.7292,6.6017C13.4492,6.6017,14.8442,7.9967,14.8442,9.7167C14.8442,11.4367,13.4492,12.8317,11.7292,12.8317M19.0072,7.3137C17.9102,4.3437,15.2132,2.1337,12.0492,2.0067C7.6342,1.8287,4.0002,5.3537,4.0002,9.7287C4.0002,11.7597,4.8232,13.5467,5.9892,14.9737L11.6872,21.9747L17.4452,14.9737C19.1662,12.8287,20.1602,10.4367,19.0072,7.3137"
  },
  ic24_question: {
    width: 24,
    height: 24,
    path: "M11.8877,16.8028C12.5057,16.8028,13.0467,16.7028,13.5097,16.5008L10.8677,13.5818H14.4367L15.4567,14.7168C15.7027,14.2838,15.8887,13.8208,16.0127,13.3258C16.1367,12.8328,16.1977,12.3298,16.1977,11.8198C16.1977,11.1858,16.1057,10.5728,15.9197,9.9778C15.7347,9.3838,15.4567,8.8578,15.0857,8.4018C14.7147,7.9468,14.2627,7.5778,13.7297,7.3008C13.1967,7.0228,12.5827,6.8838,11.8877,6.8838C11.1607,6.8838,10.5317,7.0268,9.9987,7.3128C9.4657,7.5988,9.0167,7.9768,8.6547,8.4478C8.2907,8.9188,8.0207,9.4518,7.8437,10.0468C7.6657,10.6418,7.5767,11.2478,7.5767,11.8658C7.5767,12.4998,7.6697,13.1148,7.8547,13.7078C8.0397,14.3038,8.3147,14.8288,8.6777,15.2848C9.0407,15.7408,9.4917,16.1078,10.0337,16.3858C10.5747,16.6628,11.1917,16.8028,11.8877,16.8028V16.8028zM15.8737,19.1438C15.2857,19.4688,14.6577,19.7228,13.9847,19.9078C13.3127,20.0928,12.6057,20.1858,11.8647,20.1858C10.6427,20.1858,9.5307,19.9498,8.5277,19.4798C7.5227,19.0078,6.6647,18.3818,5.9547,17.6028C5.2437,16.8228,4.6917,15.9298,4.2967,14.9248C3.9037,13.9208,3.7067,12.8858,3.7067,11.8198C3.7067,10.7398,3.9107,9.6958,4.3207,8.6908C4.7297,7.6878,5.3017,6.7988,6.0347,6.0258C6.7687,5.2538,7.6377,4.6398,8.6427,4.1838C9.6467,3.7278,10.7437,3.4998,11.9337,3.4998C13.1547,3.4998,14.2667,3.7428,15.2707,4.2298C16.2757,4.7168,17.1327,5.3538,17.8437,6.1428C18.5537,6.9298,19.1027,7.8258,19.4897,8.8298C19.8747,9.8348,20.0687,10.8548,20.0687,11.8898C20.0687,12.9408,19.8827,13.9458,19.5127,14.9028C19.1407,15.8608,18.6167,16.7178,17.9357,17.4748L20.2997,20.0708H16.7307L15.8737,19.1438z"
  },
  ic24_radio_off: {
    width: 24,
    height: 24,
    path: "M12.0002,2C6.4772,2,2.0002,6.477,2.0002,12C2.0002,17.523,6.4772,22,12.0002,22C17.5222,22,22.0002,17.523,22.0002,12C22.0002,6.477,17.5222,2,12.0002,2M12.0002,3.4C16.7422,3.4,20.6002,7.258,20.6002,12C20.6002,16.742,16.7422,20.6,12.0002,20.6C7.2582,20.6,3.4002,16.742,3.4002,12C3.4002,7.258,7.2582,3.4,12.0002,3.4"
  },
  ic24_radio_on: {
    width: 24,
    height: 24,
    path: "M2,12C2,6.477,6.478,2,12,2C17.522,2,22,6.477,22,12C22,17.523,17.522,22,12,22C6.478,22,2,17.523,2,12zM20.8,12C20.8,7.147,16.853,3.2,12,3.2C7.147,3.2,3.2,7.147,3.2,12C3.2,16.853,7.147,20.8,12,20.8C16.853,20.8,20.8,16.853,20.8,12zM11.9504,17.9998C15.2364,17.9998,17.9004,15.3358,17.9004,12.0498C17.9004,8.7638,15.2364,6.0998,11.9504,6.0998C8.6644,6.0998,6.0004,8.7638,6.0004,12.0498C6.0004,15.3358,8.6644,17.9998,11.9504,17.9998z"
  },
  ic24_request: {
    width: 24,
    height: 24,
    path: "M4,3V20.348H19.063V7.068L15.048,3H4zM14.904,8.825L15.872,9.785L10.35,15.344L7.299,12.25L8.268,11.293L10.355,13.406L14.904,8.825z"
  },
  ic24_search: {
    width: 24,
    height: 24,
    path: "M10.5,16.6C7.136,16.6,4.4,13.863,4.4,10.5C4.4,7.137,7.136,4.4,10.5,4.4C13.863,4.4,16.6,7.137,16.6,10.5C16.6,13.863,13.863,16.6,10.5,16.6V16.6zM21.227,19.588L16.554,14.915C17.459,13.675,18,12.153,18,10.5C18,6.358,14.642,3,10.5,3C6.358,3,3,6.358,3,10.5C3,14.642,6.358,18,10.5,18C12.484,18,14.283,17.224,15.624,15.966L20.236,20.578L21.227,19.588z"
  },
  ic24_search_selected: {
    width: 24,
    height: 24,
    path: "M10.5,15C8.02,15,6,12.981,6,10.5C6,8.019,8.02,6,10.5,6C12.981,6,15,8.019,15,10.5C15,12.981,12.981,15,10.5,15V15zM21.36,19.239L16.755,14.634C17.54,13.448,18,12.028,18,10.5C18,6.358,14.643,3,10.5,3C6.358,3,3,6.358,3,10.5C3,14.642,6.358,18,10.5,18C12.028,18,13.448,17.54,14.634,16.755L19.239,21.36L21.36,19.239z"
  },
  ic24_setting: {
    width: 24,
    height: 24,
    path: "M12.449,16.313C10.258,16.313,8.474,14.53,8.474,12.338C8.474,10.147,10.258,8.364,12.449,8.364C14.64,8.364,16.423,10.147,16.423,12.338C16.423,14.53,14.64,16.313,12.449,16.313V16.313zM21.876,14.202V10.797H19.553C19.379,9.991,19.066,9.238,18.648,8.555L20.277,6.926L17.87,4.519L16.243,6.145C15.559,5.725,14.804,5.411,13.997,5.235V3H10.592V5.315C9.894,5.5,9.24,5.784,8.641,6.154L7.006,4.519L4.598,6.926L6.241,8.57C5.827,9.249,5.518,9.997,5.345,10.797H3V14.202H5.428C5.634,14.978,5.959,15.705,6.392,16.356L4.659,18.09L7.066,20.498L8.89,18.674C9.421,18.973,9.993,19.204,10.595,19.363V21.765H13.999V19.441C14.709,19.287,15.379,19.028,15.994,18.683L17.809,20.498L20.217,18.09L18.497,16.371C18.935,15.715,19.262,14.983,19.47,14.202H21.876z"
  },
  ic24_setting_line: {
    width: 24,
    height: 24,
    path: "M9.8002,2H14.2002V4.52C14.7152,4.671,15.2082,4.871,15.6722,5.119L17.4882,3.303L20.5992,6.414L18.8102,8.203C19.0912,8.704,19.3152,9.238,19.4802,9.8H22.0002V14.2H19.4802C19.3152,14.762,19.0912,15.296,18.8102,15.797L20.5992,17.586L17.4882,20.697L15.6722,18.881C15.2082,19.129,14.7152,19.329,14.2002,19.48V22H9.8002V19.48C9.2862,19.329,8.7942,19.13,8.3302,18.882L6.5132,20.697L3.4022,17.586L5.1902,15.799C4.9102,15.297,4.6842,14.762,4.5192,14.2H2.0002V9.8H4.5192C4.6842,9.238,4.9102,8.703,5.1902,8.201L3.4022,6.414L6.5132,3.303L8.3302,5.118C8.7942,4.87,9.2862,4.671,9.8002,4.52V2zM12.8002,4.52V3.4H11.2002V4.52V5.568L10.1942,5.863C9.7692,5.988,9.3642,6.152,8.9902,6.354L8.0742,6.843L7.3402,6.108L6.5132,5.282L5.3832,6.414L6.1802,7.212L6.9292,7.96L6.4122,8.885C6.1822,9.296,5.9982,9.736,5.8632,10.194L5.5672,11.2H4.5192H3.4002V12.8H4.5192H5.5682L5.8632,13.806C5.9982,14.264,6.1822,14.704,6.4122,15.115L6.9292,16.039L6.1802,16.788L5.3832,17.586L6.5132,18.718L7.3402,17.892L8.0742,17.157L8.9892,17.646C9.3642,17.848,9.7692,18.012,10.1942,18.137L11.2002,18.432V19.48V20.6H12.8002V19.48V18.432L13.8052,18.137C14.2302,18.012,14.6372,17.847,15.0122,17.646L15.9282,17.156L16.6622,17.891L17.4882,18.718L18.6202,17.586L17.8202,16.787L17.0722,16.038L17.5892,15.114C17.8182,14.703,18.0022,14.263,18.1372,13.806L18.4312,12.8H19.4802H20.5992V11.2H19.4802H18.4312L18.1372,10.194C18.0022,9.736,17.8172,9.296,17.5892,8.886L17.0722,7.962L17.8202,7.213L18.6202,6.414L17.4882,5.282L16.6622,6.109L15.9282,6.844L15.0122,6.354C14.6372,6.153,14.2302,5.988,13.8052,5.863L12.8002,5.568V4.52zM8,12C8,9.791,9.791,8,12,8C14.209,8,16,9.791,16,12C16,14.209,14.209,16,12,16C9.791,16,8,14.209,8,12zM14.6,12C14.6,10.566,13.434,9.4,12,9.4C10.566,9.4,9.4,10.566,9.4,12C9.4,13.434,10.566,14.6,12,14.6C13.434,14.6,14.6,13.434,14.6,12z"
  },
  ic24_share: {
    width: 24,
    height: 24,
    path: "M16.5468,14.9225C15.9978,14.9225,15.5008,15.1235,15.1068,15.4455L9.5338,12.2295C9.5608,12.0895,9.5768,11.9475,9.5768,11.8015C9.5768,11.6175,9.5498,11.4415,9.5088,11.2695L15.0948,8.0445C15.4908,8.3715,15.9928,8.5765,16.5468,8.5765C17.8108,8.5765,18.8358,7.5525,18.8358,6.2885C18.8358,5.0245,17.8108,3.9995,16.5468,3.9995C15.2828,3.9995,14.2578,5.0245,14.2578,6.2885C14.2578,6.5055,14.2978,6.7115,14.3548,6.9095L8.8158,10.1085C8.4098,9.7425,7.8778,9.5135,7.2888,9.5135C6.0248,9.5135,4.9998,10.5375,4.9998,11.8015C4.9998,13.0655,6.0248,14.0905,7.2888,14.0905C7.9118,14.0905,8.4758,13.8395,8.8888,13.4345L14.3548,16.5905C14.2978,16.7895,14.2578,16.9945,14.2578,17.2115C14.2578,18.4755,15.2828,19.4995,16.5468,19.4995C17.8108,19.4995,18.8358,18.4755,18.8358,17.2115C18.8358,15.9475,17.8108,14.9225,16.5468,14.9225"
  },
  ic24_socarpass: {
    width: 24,
    height: 24,
    path: "M21,16.8H22.4V4H3.1V5.4H21V16.8zM13.6,14.77C13.6,15.1842,13.2642,15.52,12.85,15.52C12.4358,15.52,12.1,15.1842,12.1,14.77C12.1,14.3558,12.4358,14.02,12.85,14.02C13.2642,14.02,13.6,14.3558,13.6,14.77zM7.95,12.1196C8.3642,12.1196,8.7,11.7838,8.7,11.3696C8.7,10.9554,8.3642,10.6196,7.95,10.6196C7.5358,10.6196,7.2,10.9554,7.2,11.3696C7.2,11.7838,7.5358,12.1196,7.95,12.1196zM1,19.2998V6.7998H19.6V19.2998H1zM7.95,9.6198C6.98,9.6198,6.2,10.3998,6.2,11.3698C6.2,12.3298,6.98,13.1198,7.95,13.1198C8.92,13.1198,9.7,12.3398,9.7,11.3698C9.7,10.3998,8.92,9.6198,7.95,9.6198zM11.65,9.7198L7.7,16.5998H9.01L12.96,9.7198H11.65zM11.1,14.7698C11.1,15.7398,11.88,16.5198,12.85,16.5198C13.82,16.5198,14.6,15.7298,14.6,14.7698C14.6,13.7998,13.82,13.0198,12.85,13.0198C11.88,13.0198,11.1,13.7998,11.1,14.7698z"
  },
  ic24_socarzone: {
    width: 24,
    height: 24,
    path: "M19.0072,7.3137C17.9102,4.3437,15.2132,2.1337,12.0492,2.0067C7.6342,1.8287,4.0002,5.3537,4.0002,9.7287C4.0002,11.7597,4.8232,13.5467,5.9892,14.9737L11.6872,21.9747L17.4452,14.9737C19.1662,12.8287,20.1602,10.4367,19.0072,7.3137"
  },
  ic24_socarzone_shortcut: {
    width: 24,
    height: 24,
    path: "M14.2719,13.4142L11.6399,12.0302L9.0079,13.4142L9.5099,10.4832L7.3809,8.4082L10.3239,7.9802L11.6399,5.3142L12.9569,7.9802L15.8979,8.4082L13.7689,10.4832L14.2719,13.4142zM19.0259,7.3212C17.9269,4.3482,15.2269,2.1342,12.0589,2.0062C7.6379,1.8282,4.0009,5.3592,4.0009,9.7392C4.0009,11.7722,4.8229,13.5622,5.9919,14.9912L11.6969,22.0002L17.4619,14.9912C19.1849,12.8422,20.1799,10.4472,19.0259,7.3212V7.3212z"
  },
  ic24_time: {
    width: 24,
    height: 24,
    path: "M2,12C2,6.477,6.477,2,12,2C17.523,2,22,6.477,22,12C22,17.523,17.523,22,12,22C6.477,22,2,17.523,2,12zM20.6,12C20.6,7.258,16.742,3.4,12,3.4C7.258,3.4,3.4,7.258,3.4,12C3.4,16.742,7.258,20.6,12,20.6C16.742,20.6,20.6,16.742,20.6,12zM11.2995,13.4004H16.9995V12.0004H12.7005V6.0004H11.2995V13.4004z"
  },
  ic24_time_fill: {
    width: 24,
    height: 24,
    path: "M16.9997,13.4005H11.2997V6.0005H12.6997V12.0005H16.9997V13.4005zM11.9997,2.0005C6.4777,2.0005,1.9997,6.4775,1.9997,12.0005C1.9997,17.5235,6.4777,22.0005,11.9997,22.0005C17.5227,22.0005,21.9997,17.5235,21.9997,12.0005C21.9997,6.4775,17.5227,2.0005,11.9997,2.0005V2.0005z"
  },
  ic24_top: {
    width: 24,
    height: 24,
    path: "M11.628,3L3,11.627L4.006,12.634L10.942,5.696V20.304H12.364V5.748L19.25,12.634L20.255,11.627L11.628,3z"
  },
  ic24_visibility_off: {
    width: 24,
    height: 24,
    path: "M11.9885,16.323C9.8215,16.323,8.0635,14.566,8.0635,12.398C8.0635,11.718,8.2565,11.092,8.5635,10.537L9.5405,11.504C9.4355,11.784,9.3635,12.08,9.3635,12.398C9.3635,13.845,10.5415,15.023,11.9885,15.023C12.3155,15.023,12.6205,14.948,12.9075,14.837L13.8845,15.802C13.3215,16.122,12.6835,16.323,11.9885,16.323zM2.9645,4.995L5.4675,7.473C3.8655,8.651,2.6505,10.244,2.0495,12.082C1.9835,12.286,1.9835,12.51,2.0495,12.713C3.3195,16.596,7.2825,19.433,11.9885,19.433C13.6355,19.433,15.1855,19.077,16.5665,18.457L19.1315,20.995L20.1155,20L3.9485,4L2.9645,4.995zM21.9274,12.0823C20.6574,8.1993,16.6954,5.3623,11.9884,5.3623C10.6124,5.3623,9.3024,5.6113,8.1014,6.0523L10.7434,8.6933C11.1364,8.5613,11.5504,8.4733,11.9884,8.4733C14.1564,8.4733,15.9134,10.2303,15.9134,12.3973C15.9134,12.8353,15.8254,13.2493,15.6934,13.6433L19.0014,16.9513C20.3614,15.8173,21.3884,14.3613,21.9274,12.7133C21.9944,12.5103,21.9944,12.2863,21.9274,12.0823zM11.9022,9.7806C11.9307,9.7766,11.9593,9.7727,11.9885,9.7727C13.4355,9.7727,14.6135,10.9507,14.6135,12.3977C14.6135,12.4274,14.6096,12.4558,14.6057,12.4842C14.6027,12.5055,14.5998,12.5268,14.5985,12.5487L11.8385,9.7877C11.8598,9.7864,11.881,9.7835,11.9022,9.7806z"
  },
  ic24_visibility_on: {
    width: 24,
    height: 24,
    path: "M8.0638,12.0355C8.0638,14.2035,9.8208,15.9605,11.9888,15.9605C14.1568,15.9605,15.9138,14.2035,15.9138,12.0355C15.9138,9.8675,14.1568,8.1105,11.9888,8.1105C9.8208,8.1105,8.0638,9.8675,8.0638,12.0355zM2.0508,11.7195C3.3198,7.8365,7.2828,5.0005,11.9888,5.0005C16.6948,5.0005,20.6588,7.8365,21.9278,11.7195C21.9948,11.9235,21.9948,12.1475,21.9278,12.3505C20.6588,16.2335,16.6948,19.0705,11.9888,19.0705C7.2828,19.0705,3.3198,16.2335,2.0508,12.3505C1.9828,12.1475,1.9828,11.9235,2.0508,11.7195zM11.9888,14.6602C10.5418,14.6602,9.3638,13.4832,9.3638,12.0352C9.3638,10.5882,10.5418,9.4102,11.9888,9.4102C13.4358,9.4102,14.6138,10.5882,14.6138,12.0352C14.6138,13.4832,13.4358,14.6602,11.9888,14.6602z"
  },
  ic24_warn_fill: {
    width: 24,
    height: 24,
    path: "M12.013,3L2,20.344H22.026L12.013,3zM11.382,14.983H12.782V9.282H11.382V14.983zM11.382,17.782H12.782V16.382H11.382V17.782z"
  },
  "ic24_warn_outline-1": {
    width: 24,
    height: 24,
    path: "M2,20.344L12.013,3L22.025,20.342V20.344H2zM19.602,18.943L12.013,5.8L4.423,18.943H19.602zM11.3816,14.9829H12.7816V9.2829H11.3816V14.9829zM11.3816,17.7809H12.7816V16.3819H11.3816V17.7809z"
  },
  ic24_warn_outline: {
    width: 24,
    height: 24,
    path: "M2.0001,12.0002C2.0001,6.4772,6.4771,2.0002,12.0001,2.0002C17.5231,2.0002,22.0001,6.4772,22.0001,12.0002C22.0001,17.5222,17.5231,22.0002,12.0001,22.0002C6.4771,22.0002,2.0001,17.5222,2.0001,12.0002zM20.6001,12.0002C20.6001,7.2582,16.7421,3.4002,12.0001,3.4002C7.2581,3.4002,3.4001,7.2582,3.4001,12.0002C3.4001,16.7422,7.2581,20.6002,12.0001,20.6002C16.7421,20.6002,20.6001,16.7422,20.6001,12.0002zM11.348,13.982H12.748V7.132H11.348V13.982zM11.347,16.982H12.747V15.582H11.347V16.982z"
  },
  ic24_way: {
    width: 24,
    height: 24,
    path: "M12.6,4V7.4H5V20.6H8.2V10.601H12.6V14L18.599,8.999L12.6,4z"
  },
  ic24_zone_default: {
    width: 24,
    height: 24,
    path: "M16.3848,8.5731C16.3388,8.5111,16.1788,8.3971,15.9038,8.2291C15.6298,8.0611,15.2858,7.8861,14.8728,7.7031C14.4608,7.5191,14.0108,7.3591,13.5228,7.2211C13.0338,7.0841,12.5458,7.0151,12.0568,7.0151C10.7138,7.0151,10.0418,7.4661,10.0418,8.3661C10.0418,8.6411,10.1138,8.8701,10.2598,9.0541C10.4038,9.2371,10.6178,9.4011,10.9008,9.5461C11.1828,9.6911,11.5378,9.8251,11.9658,9.9471C12.3928,10.0691,12.8888,10.2071,13.4528,10.3591C14.2328,10.5731,14.9338,10.8051,15.5608,11.0561C16.1868,11.3091,16.7168,11.6221,17.1528,11.9961C17.5868,12.3711,17.9228,12.8241,18.1588,13.3581C18.3968,13.8931,18.5148,14.5341,18.5148,15.2821C18.5148,16.1981,18.3428,16.9731,17.9988,17.6061C17.6558,18.2411,17.2018,18.7511,16.6368,19.1411C16.0718,19.5301,15.4228,19.8131,14.6908,19.9881C13.9568,20.1631,13.2018,20.2511,12.4238,20.2511C11.8278,20.2511,11.2178,20.2061,10.5908,20.1141C9.9658,20.0221,9.3548,19.8891,8.7598,19.7131C8.1638,19.5381,7.5878,19.3281,7.0308,19.0841C6.4728,18.8401,5.9578,18.5571,5.4858,18.2371L7.1338,14.9621C7.1938,15.0391,7.3928,15.1831,7.7298,15.3971C8.0648,15.6101,8.4808,15.8241,8.9768,16.0381C9.4728,16.2521,10.0258,16.4431,10.6378,16.6101C11.2468,16.7781,11.8648,16.8621,12.4918,16.8621C13.8198,16.8621,14.4848,16.4581,14.4848,15.6491C14.4848,15.3441,14.3848,15.0921,14.1868,14.8931C13.9888,14.6941,13.7128,14.5151,13.3628,14.3551C13.0108,14.1941,12.5948,14.0461,12.1138,13.9091C11.6328,13.7711,11.1108,13.6191,10.5458,13.4501C9.7978,13.2201,9.1488,12.9731,8.5988,12.7071C8.0498,12.4391,7.5948,12.1311,7.2368,11.7781C6.8778,11.4271,6.6108,11.0231,6.4348,10.5651C6.2588,10.1071,6.1718,9.5731,6.1718,8.9621C6.1718,8.1071,6.3318,7.3511,6.6528,6.6951C6.9728,6.0391,7.4088,5.4851,7.9578,5.0351C8.5068,4.5851,9.1448,4.2451,9.8698,4.0151C10.5948,3.7871,11.3618,3.6731,12.1718,3.6731C12.7368,3.6731,13.2928,3.7251,13.8438,3.8331C14.3928,3.9391,14.9188,4.0771,15.4228,4.2451C15.9268,4.4141,16.3968,4.6031,16.8318,4.8171C17.2658,5.0311,17.6668,5.2451,18.0338,5.4581L16.3848,8.5731z"
  },
  ic24_zoomin: {
    width: 24,
    height: 24,
    path: "M10.9802,3.9C7.0652,3.9,3.8802,7.085,3.8802,11C3.8802,14.915,7.0652,18.1,10.9802,18.1C14.8952,18.1,18.0802,14.915,18.0802,11C18.0802,7.085,14.8952,3.9,10.9802,3.9zM17.4332,16.523L21.4782,20.607L20.4832,21.592L16.4402,17.511C14.9632,18.751,13.0602,19.5,10.9802,19.5C6.2862,19.5,2.4802,15.694,2.4802,11C2.4802,6.306,6.2862,2.5,10.9802,2.5C15.6742,2.5,19.4802,6.306,19.4802,11C19.4802,13.11,18.7062,15.037,17.4332,16.523zM10.3804,6.5H11.5804V10.4H15.4804V11.6H11.5804V15.5H10.3804V11.6H6.4804V10.4H10.3804V6.5z"
  },
  ic24_zoomout: {
    width: 24,
    height: 24,
    path: "M10.9802,3.9C7.0652,3.9,3.8802,7.085,3.8802,11C3.8802,14.915,7.0652,18.1,10.9802,18.1C14.8952,18.1,18.0802,14.915,18.0802,11C18.0802,7.085,14.8952,3.9,10.9802,3.9zM17.4332,16.523L21.4782,20.607L20.4832,21.592L16.4402,17.511C14.9632,18.751,13.0602,19.5,10.9802,19.5C6.2862,19.5,2.4802,15.694,2.4802,11C2.4802,6.306,6.2862,2.5,10.9802,2.5C15.6742,2.5,19.4802,6.306,19.4802,11C19.4802,13.11,18.7062,15.037,17.4332,16.523zM15.4804,11.6H6.4804V10.4H15.4804V11.6z"
  },
  ic48_account: {
    width: 48,
    height: 48,
    path: "M23.6255,10.0002C19.7055,10.0002,16.5265,13.2322,16.5265,17.2202C16.5265,21.2072,19.7055,24.4392,23.6255,24.4392C27.5465,24.4392,30.7255,21.2072,30.7255,17.2202C30.7255,13.2322,27.5465,10.0002,23.6255,10.0002zM6.001,39.2982L16.062,29.1982H31.189L41.251,39.2982H30.935H21.548H6.001z"
  },
  ic48_airport: {
    width: 48,
    height: 48,
    path: "M35.4884,35.221L7.3264,24.971C4.8464,24.069,3.4494,21.655,4.2054,19.579C4.9604,17.504,7.5834,16.553,10.0624,17.455L17.8164,20.278L29.7104,13L35.8324,15.228L28.0204,23.992L33.3904,25.912L37.8474,23.7L43.5484,25.775L35.4884,35.221z"
  },
  ic48_answer: {
    width: 48,
    height: 48,
    path: "M27.9014,27.9101L23.9954,16.0971L19.9954,27.9101H27.9014zM20.5124,7.2981H27.4784L39.6674,40.7111H31.7604L29.1724,33.2291H18.7714L16.2304,40.7111H8.3234L20.5124,7.2981z"
  },
  ic48_bluetooth: {
    width: 48,
    height: 48,
    path: "M22.857,6V21.719L14.334,14.092L13,15.582L22.358,23.956L13,32.329L14.334,33.819L22.857,26.192V41.912L34.261,31.921L25.357,23.956L34.261,15.99L22.857,6zM24.858,10.411L31.243,16.005L24.858,21.719V10.411zM24.858,26.191L31.243,31.906L24.858,37.501V26.191z"
  },
  ic48_bluetooth_off: {
    width: 48,
    height: 48,
    path: "M33.3197,15.989L33.3189,15.9897L33.3194,15.9901L27.1832,21.4798L25.9257,22.605L25.9256,22.6049L25.9254,22.6051L25.3065,22.051L24.4257,21.263L30.3017,16.006L26.5685,12.7347L23.9167,10.4114V20.807L23.9164,20.8067V20.8071L21.9164,19.0171V6.0001L21.9167,6.0004V6L33.3197,15.989zM21.416,23.9551L8,11.9511L9.335,10.4611L21.917,21.7191V21.7011L24.426,23.9471L24.416,23.9561L39.334,37.3041L38.001,38.7931L31.803,33.2491L21.917,41.9111V26.1931L13.393,33.8191L12.059,32.3291L21.416,23.9551zM30.302,31.9061L23.917,26.1931V37.5001L30.302,31.9061z"
  },
  ic48_camera_front: {
    width: 48,
    height: 48,
    path: "M13.444,17.405L17.143,11H30.885L34.583,17.405H40.029V36.594H8V17.405H13.444zM13.444,19.405H10V34.594H38.028V19.405H34.583H33.429L32.852,18.405L29.731,13H18.298L15.177,18.405L14.599,19.405H13.444zM24.0268,16.9831C22.0058,16.9831,20.1058,17.7711,18.6768,19.1991C18.3948,19.4821,18.1308,19.8041,17.8818,20.1511L19.0578,21.3271C19.2888,20.9711,19.5478,20.6431,19.8348,20.3571C20.9898,19.2011,22.5078,18.6231,24.0268,18.6231C25.5458,18.6231,27.0638,19.2011,28.2188,20.3571C29.2208,21.3581,29.7878,22.6571,29.9048,24.0261H27.9448L30.6998,26.7811L33.4548,24.0261H31.5648C31.4478,22.2291,30.6958,20.5191,29.3768,19.1991C27.9468,17.7711,26.0478,16.9831,24.0268,16.9831zM17.3286,22.3029L14.5736,25.0569H16.4866C16.6006,26.8609,17.3546,28.5749,18.6776,29.8979C20.1056,31.3259,22.0066,32.1139,24.0266,32.1139C26.0476,32.1139,27.9466,31.3259,29.3766,29.8979C29.6566,29.6169,29.9206,29.2969,30.1676,28.9519L28.9916,27.7759C28.7606,28.1319,28.5026,28.4579,28.2196,28.7409C27.0636,29.8969,25.5456,30.4749,24.0266,30.4749C22.5086,30.4749,20.9896,29.8969,19.8346,28.7409C18.8296,27.7349,18.2656,26.4299,18.1516,25.0569H20.0826L17.3286,22.3029z"
  },
  ic48_car_filter: {
    width: 48,
    height: 48,
    path: "M13.606,7.622L8.499,18.422H36.922L31.814,7.622H13.606zM8.815,24.839C8.8,26.141,9.852,27.22,11.155,27.235C12.456,27.251,13.535,26.198,13.55,24.896C13.565,23.593,12.514,22.514,11.21,22.499C9.908,22.484,8.828,23.537,8.815,24.839zM33.556,22.499C32.604,22.488,31.776,23.05,31.392,23.86C27.62,24.6,24.612,27.443,23.62,31.117H22.625H14.211V34.242C14.211,35.394,13.277,36.328,12.126,36.328H12.12H10.214H10.21C9.059,36.328,8.125,35.396,8.125,34.244V31.032H5V31.027V18.398V18.382L11.518,5H33.481L40,18.382V25.519C39.997,25.518,39.997,25.785,39.998,26.192C38.79,25.127,37.328,24.35,35.712,23.959C35.357,23.114,34.526,22.51,33.556,22.499zM33.342,28.0277C30.188,28.0277,27.622,30.5937,27.622,33.7477C27.622,36.9017,30.188,39.4677,33.342,39.4677C36.496,39.4677,39.061,36.9017,39.061,33.7477C39.061,30.5937,36.496,28.0277,33.342,28.0277zM39.46,38.4427L43.03,42.0137L41.616,43.4277L38.047,39.8587C36.743,40.8637,35.115,41.4677,33.342,41.4677C29.078,41.4677,25.622,38.0117,25.622,33.7477C25.622,29.4837,29.078,26.0277,33.342,26.0277C37.605,26.0277,41.061,29.4837,41.061,33.7477C41.061,35.5167,40.46,37.1417,39.46,38.4427z"
  },
  ic48_checkonly: {
    width: 48,
    height: 48,
    path: "M38.923,12L18.693,32.233L8.415,21.955L7,23.369L18.693,35.061L40.339,13.416V13.414L38.925,12H38.923z"
  },
  ic48_clean: {
    width: 48,
    height: 48,
    path: "M29.9286,31.5286C30.4857,33.1357,31.0214,35,31.0214,35C31.0214,35,31.5357,33.1143,32.1143,31.5286C33.3571,28.0143,36.0143,25.2071,39.5714,24.0929L43,23.0429C43,23.0429,41.1143,22.5286,39.5071,21.95C35.9929,20.7071,33.1643,18.0714,32.05,14.5143V14.4714C31.4929,12.8643,30.9571,11,30.9571,11C30.9571,11,30.4429,12.8857,29.8643,14.4714C28.6429,17.9857,25.9857,20.8143,22.4286,21.9071L19,22.9571C19,22.9571,20.8857,23.4714,22.4929,24.05C26.0071,25.2929,28.8357,27.9286,29.95,31.4857M12.2986,37.6767C12.6712,38.7507,13.0219,40,13.0219,40C13.0219,40,13.3726,38.7507,13.7452,37.6767C14.5781,35.3315,16.3534,33.4685,18.7205,32.7233L21,32.0219C21,32.0219,19.7507,31.6712,18.6767,31.2986C16.3315,30.4658,14.4466,28.7123,13.7014,26.3452V26.3233C13.3288,25.2493,12.9781,24,12.9781,24C12.9781,24,12.6274,25.2493,12.2548,26.3233C11.4219,28.6685,9.6466,30.5315,7.2794,31.2767L5,31.9781C5,31.9781,6.2493,32.3288,7.3233,32.7014C9.6685,33.5342,11.5534,35.2877,12.2986,37.6548M15.3905,18.2575C15.6699,19.063,15.9329,20,15.9329,20C15.9329,20,16.196,19.063,16.4754,18.2575C17.1001,16.4986,18.4316,15.1014,20.2069,14.5425L21.9165,14.0164C21.9165,14.0164,20.9795,13.7534,20.174,13.474C18.4151,12.8493,17.0014,11.5342,16.4425,9.7589V9.7425C16.1631,8.937,15.9001,8,15.9001,8C15.9001,8,15.6371,8.937,15.3576,9.7425C14.7329,11.5014,13.4014,12.8986,11.6261,13.4575L9.9165,13.9836C9.9165,13.9836,10.8535,14.2466,11.659,14.526C13.4179,15.1507,14.8316,16.4658,15.3905,18.2411"
  },
  ic48_deliverycar: {
    width: 48,
    height: 48,
    path: "M35.201,36.5C35.977,36.5,36.645,36.05,36.976,35.4C37.116,35.128,37.201,34.826,37.201,34.5C37.201,34.094,37.078,33.716,36.869,33.4C36.51,32.859,35.896,32.5,35.201,32.5C34.504,32.5,33.891,32.859,33.534,33.4C33.325,33.716,33.201,34.094,33.201,34.5C33.201,34.826,33.287,35.128,33.425,35.4C33.756,36.05,34.424,36.5,35.201,36.5zM17.5,36.5C18.277,36.5,18.945,36.05,19.276,35.4C19.415,35.128,19.5,34.826,19.5,34.5C19.5,34.094,19.377,33.716,19.168,33.4C18.809,32.859,18.197,32.5,17.5,32.5C16.804,32.5,16.191,32.859,15.833,33.4C15.624,33.716,15.5,34.094,15.5,34.5C15.5,34.826,15.586,35.128,15.724,35.4C16.055,36.05,16.723,36.5,17.5,36.5zM31.131,13L36.131,20.4H43.201V35.4H39.09C38.679,37.172,37.096,38.5,35.201,38.5C33.305,38.5,31.722,37.172,31.311,35.4H21.389C20.978,37.172,19.395,38.5,17.5,38.5C15.605,38.5,14.022,37.172,13.611,35.4H8.701V31H10.701V33.4H13.674C14.154,31.731,15.679,30.5,17.5,30.5C19.322,30.5,20.846,31.731,21.328,33.4H31.374C31.854,31.731,33.379,30.5,35.201,30.5C37.022,30.5,38.547,31.731,39.027,33.4H41.201V26.7H38.1V25.7001V24.7H41.201V22.4H35.068L30.068,15H10.8V17H8.8V13H31.131zM11.9,29.0029H5.001V27.0029H11.9V29.0029zM7.201,25.0399H14.1V23.0399H7.201V25.0399zM11.8,20.9999H4.901V18.9999H11.8V20.9999z"
  },
  ic48_driverlicense: {
    width: 48,
    height: 48,
    path: "M5,36.8423H42.589V10.9993H5V36.8423zM7.094,34.7483H40.494V13.0943H7.094V34.7483zM19.9769,26.1095L24.2119,30.2895H19.8699H15.9179H9.3739L13.6099,26.1095H19.9769zM16.7936,23.7259C18.4436,23.7259,19.7816,22.3879,19.7816,20.7379C19.7816,19.0879,18.4436,17.7499,16.7936,17.7499C15.1426,17.7499,13.8046,19.0879,13.8046,20.7379C13.8046,22.3879,15.1426,23.7259,16.7936,23.7259z"
  },
  ic48_gps: {
    width: 48,
    height: 48,
    path: "M24,34.8013C18.045,34.8013,13.2,29.9563,13.2,24.0013C13.2,18.0463,18.045,13.2013,24,13.2013C29.955,13.2013,34.8,18.0463,34.8,24.0013C34.8,29.9563,29.955,34.8013,24,34.8013V34.8013zM36.749,23.0013C36.264,16.7323,31.27,11.7383,25,11.2513V7.1013H23V11.2513C16.73,11.7383,11.737,16.7313,11.251,23.0003H7V25.0003H11.25C11.736,31.2703,16.73,36.2643,23,36.7503V40.9013H25V36.7503C31.27,36.2643,36.264,31.2703,36.75,25.0013H40.9V23.0013H36.749zM24,18.8633C21.163,18.8633,18.863,21.1633,18.863,24.0003C18.863,26.8363,21.163,29.1363,24,29.1363C26.837,29.1363,29.137,26.8363,29.137,24.0003C29.137,21.1633,26.837,18.8633,24,18.8633V18.8633z"
  },
  ic48_help: {
    width: 48,
    height: 48,
    path: "M23.9508,39.901C15.1548,39.901,7.9998,32.746,7.9998,23.95C7.9998,15.155,15.1548,8,23.9508,8C32.7458,8,39.9008,15.155,39.9008,23.95C39.9008,32.746,32.7458,39.901,23.9508,39.901zM23.9508,6C14.0368,6,5.9998,14.037,5.9998,23.95C5.9998,33.864,14.0368,41.901,23.9508,41.901C33.8638,41.901,41.9008,33.864,41.9008,23.95C41.9008,14.037,33.8638,6,23.9508,6zM23.9508,13.0831C20.1098,13.0831,16.9858,16.2071,16.9858,20.0471H18.9858C18.9858,17.3101,21.2138,15.0831,23.9508,15.0831C26.6878,15.0831,28.9148,17.3101,28.9148,20.0471C28.9148,22.7851,26.6878,25.0111,23.9508,25.0111H22.9508V31.0061H24.9508V26.9391C28.3188,26.4531,30.9148,23.5481,30.9148,20.0471C30.9148,16.2071,27.7908,13.0831,23.9508,13.0831zM24.95,35.0959H22.951V33.0959H24.95V35.0959z"
  },
  ic48_info: {
    width: 48,
    height: 48,
    path: "M24,6C14.1,6,6,14,6,24C6,33.9,14,42,24,42C33.9,42,42,34,42,24C42,14.1,33.9,6,24,6zM24,40C15.2,40,8,32.8,8,24C8,15.2,15.2,8,24,8C32.8,8,40,15.2,40,24C40,32.8,32.8,40,24,40zM25.1,14.3999H22.9V16.5999H25.1V14.3999zM25.1,19H22.9V33.6H25.1V19z"
  },
  ic48_key_close: {
    width: 48,
    height: 48,
    path: "M36.045,40.5845H11V22.9005H36.045V40.5845zM23.522,4.9995C28.182,4.9995,31.973,8.7905,31.973,13.4505V20.9005H38.045V42.5845H9V20.9005H15.072V13.4505C15.072,8.7905,18.863,4.9995,23.522,4.9995zM17.072,13.4505V20.9005H29.973V13.4505C29.973,9.8935,27.08,6.9995,23.522,6.9995C19.965,6.9995,17.072,9.8935,17.072,13.4505zM23.5235,33.1567L19.7535,36.9257L18.3395,35.5117L22.1075,31.7427L18.3395,27.9737L19.7535,26.5597L23.5235,30.3287L27.2915,26.5597L28.7055,27.9737L24.9375,31.7427L28.7055,35.5117L27.2915,36.9257L23.5235,33.1567z"
  },
  ic48_key_horn: {
    width: 48,
    height: 48,
    path: "M33.9999,24C33.9999,22.283,32.6769,20.885,30.9999,20.73V27.27C32.6769,27.116,33.9999,25.717,33.9999,24zM6.9999,26.764L28.9999,37.764V10.247L6.9999,21.332V26.764zM30.9999,7V18.73C33.7799,18.89,35.9999,21.18,35.9999,24C35.9999,26.82,33.7799,29.111,30.9999,29.27V41L4.9999,28V20.1L30.9999,7zM36.1599,14.7013L37.5839,13.2983C40.4319,16.1883,41.9999,19.9883,41.9999,24.0003C41.9999,27.9553,40.4689,31.7173,37.6879,34.5943L36.2509,33.2053C38.6679,30.7033,39.9999,27.4343,39.9999,24.0003C39.9999,20.5173,38.6359,17.2153,36.1599,14.7013z"
  },
  ic48_key_light: {
    width: 48,
    height: 48,
    path: "M24.288,7L5,40.065H43.576L24.288,7zM24.288,10.97L40.093,38.065H8.482L24.288,10.97zM22.597,22.507L17.929,30.51L16.174,33.518H19.657H28.992H32.475L30.72,30.51L26.052,22.507L24.325,19.545L22.597,22.507zM24.325,23.514L28.992,31.517H19.657L24.325,23.514z"
  },
  ic48_key_open: {
    width: 48,
    height: 48,
    path: "M23.5225,7.0002C19.9655,7.0002,17.0715,9.8932,17.0715,13.4502V20.9001H38.045V42.5841H9V20.9001H15.0715V13.4502C15.0715,8.7902,18.8625,5.0002,23.5225,5.0002C28.1815,5.0002,31.9725,8.7902,31.9725,13.4502H29.9725C29.9725,9.8932,27.0795,7.0002,23.5225,7.0002zM11,22.9001V40.5841H36.045V22.9001H11zM23.5559,27.7544C25.6759,27.7544,27.3999,29.4784,27.3999,31.5984C27.3999,33.7174,25.6759,35.4424,23.5559,35.4424C21.4369,35.4424,19.7119,33.7174,19.7119,31.5984C19.7119,29.4784,21.4369,27.7544,23.5559,27.7544zM23.5559,37.4424C26.7839,37.4424,29.3999,34.8254,29.3999,31.5984C29.3999,28.3704,26.7839,25.7544,23.5559,25.7544C20.3279,25.7544,17.7119,28.3704,17.7119,31.5984C17.7119,34.8254,20.3279,37.4424,23.5559,37.4424z"
  },
  ic48_key_return: {
    width: 48,
    height: 48,
    path: "M36.6452,23.4165C36.6502,23.5565,36.6662,23.6925,36.6662,23.8335C36.6662,30.9095,30.9102,36.6665,23.8332,36.6665C16.7572,36.6665,10.9992,30.9095,10.9992,23.8335C10.9992,16.7565,16.7572,10.9995,23.8332,10.9995C28.1122,10.9995,31.8952,13.1135,34.2272,16.3425H28.6612V18.3425H37.6162V9.3875H35.6162V14.8595C32.9082,11.3045,28.6472,8.9995,23.8332,8.9995C15.6412,8.9995,8.9992,15.6415,8.9992,23.8335C8.9992,32.0255,15.6412,38.6665,23.8332,38.6665C32.0252,38.6665,38.6662,32.0255,38.6662,23.8335C38.6662,23.6925,38.6492,23.5565,38.6452,23.4165H36.6452z"
  },
  ic48_location: {
    width: 48,
    height: 48,
    path: "M23.9326,25.5414C20.8396,25.5414,18.3336,23.0344,18.3336,19.9424C18.3336,16.8514,20.8396,14.3444,23.9326,14.3444C27.0246,14.3444,29.5306,16.8514,29.5306,19.9424C29.5306,23.0344,27.0246,25.5414,23.9326,25.5414M37.0126,15.6244C35.0406,10.2854,30.1936,6.3134,24.5066,6.0844C16.5736,5.7644,10.0396,12.1024,10.0396,19.9644C10.0396,23.6144,11.5196,26.8274,13.6166,29.3914L23.8576,41.9734L34.2056,29.3914C37.2996,25.5354,39.0856,21.2364,37.0126,15.6244"
  },
  ic48_over26: {
    width: 48,
    height: 48,
    path: "M35.467,28.186V24.776H38.7V23.111H35.467V19.702H33.723V23.111H30.489V24.776H33.723V28.186H35.467zM20.905,25.929C20.905,28.505,22.522,30.234,25.114,30.234C27.692,30.234,29.42,28.394,29.42,26.137C29.42,23.688,27.676,22.487,25.82,22.487C25.322,22.487,24.891,22.551,24.523,22.679L24.347,22.759L24.746,22.375C24.8898,22.192,25.0331,22.0094,25.1762,21.8272C26.1959,20.5281,27.2016,19.247,28.268,17.942H25.579L22.329,22.327C21.417,23.608,20.905,24.84,20.905,25.929zM11.401,29.93H19.74V27.914H15.899C15.53,27.914,15.147,27.929,14.714,28.042L17.196,25.545C18.38,24.312,19.565,22.92,19.613,21.239C19.613,19.19,18.06,17.765,15.835,17.765C13.642,17.765,12.057,18.918,11.673,21.367L13.77,21.719C13.786,21.399,13.818,21.159,13.898,20.919C14.155,20.214,14.794,19.606,15.691,19.606C16.732,19.606,17.388,20.182,17.388,21.287C17.388,22.519,16.635,23.48,15.418,24.696L11.401,28.65V29.93zM4,24C4,12.954,12.954,4,24,4C35.046,4,44,12.954,44,24C44,35.046,35.046,44,24,44C12.954,44,4,35.046,4,24zM23.0179,26.2489C23.0179,24.9679,23.8189,24.1519,25.0989,24.1519C26.3959,24.1519,27.2759,24.8559,27.2759,26.2649C27.2759,27.5609,26.2989,28.4259,25.0829,28.4259C23.8509,28.4259,23.0179,27.6099,23.0179,26.2489z"
  },
  ic48_question: {
    width: 48,
    height: 48,
    path: "M23.7646,33.6959C25.0226,33.6959,26.1246,33.4929,27.0686,33.0829L21.6876,27.1359H28.9556L31.0346,29.4479C31.5366,28.5669,31.9146,27.6219,32.1666,26.6149C32.4186,25.6099,32.5436,24.5869,32.5436,23.5469C32.5436,22.2559,32.3566,21.0069,31.9786,19.7939C31.6006,18.5839,31.0346,17.5119,30.2786,16.5829C29.5236,15.6569,28.6026,14.9069,27.5166,14.3429C26.4316,13.7759,25.1806,13.4919,23.7646,13.4919C22.2846,13.4919,21.0026,13.7829,19.9166,14.3659C18.8296,14.9489,17.9176,15.7189,17.1786,16.6779C16.4386,17.6389,15.8876,18.7249,15.5266,19.9349C15.1636,21.1469,14.9836,22.3829,14.9836,23.6409C14.9836,24.9319,15.1716,26.1839,15.5496,27.3939C15.9266,28.6069,16.4866,29.6759,17.2256,30.6049C17.9646,31.5339,18.8856,32.2799,19.9876,32.8479C21.0886,33.4119,22.3476,33.6959,23.7646,33.6959V33.6959zM31.8836,38.4649C30.6876,39.1269,29.4066,39.6449,28.0366,40.0229C26.6676,40.3989,25.2276,40.5879,23.7166,40.5879C21.2296,40.5879,18.9636,40.1089,16.9196,39.1499C14.8726,38.1889,13.1266,36.9139,11.6786,35.3259C10.2316,33.7379,9.1066,31.9189,8.3036,29.8719C7.5006,27.8269,7.0996,25.7179,7.0996,23.5469C7.0996,21.3449,7.5176,19.2199,8.3506,17.1739C9.1846,15.1289,10.3486,13.3199,11.8436,11.7449C13.3386,10.1729,15.1086,8.9218,17.1546,7.9919C19.2006,7.0639,21.4356,6.5998,23.8586,6.5998C26.3446,6.5998,28.6106,7.0959,30.6566,8.0869C32.7026,9.0778,34.4486,10.3759,35.8966,11.9829C37.3436,13.5869,38.4606,15.4119,39.2476,17.4569C40.0346,19.5039,40.4286,21.5809,40.4286,23.6899C40.4286,25.8289,40.0506,27.8759,39.2956,29.8259C38.5396,31.7779,37.4696,33.5229,36.0846,35.0649L40.9006,40.3529H33.6296L31.8836,38.4649z"
  },
  ic48_smile: {
    width: 48,
    height: 48,
    path: "M23.9508,39.901C15.1548,39.901,7.9998,32.746,7.9998,23.95C7.9998,15.155,15.1548,8,23.9508,8C32.7458,8,39.9008,15.155,39.9008,23.95C39.9008,32.746,32.7458,39.901,23.9508,39.901zM23.9508,6C14.0368,6,5.9998,14.037,5.9998,23.95C5.9998,33.864,14.0368,41.901,23.9508,41.901C33.8638,41.901,41.9008,33.864,41.9008,23.95C41.9008,14.037,33.8638,6,23.9508,6zM15.951,18.0959C15.951,19.2005,16.8464,20.0959,17.951,20.0959C19.0556,20.0959,19.951,19.2005,19.951,18.0959C19.951,16.9914,19.0556,16.0959,17.951,16.0959C16.8464,16.0959,15.951,16.9914,15.951,18.0959zM30,20C28.8954,20,28,19.1046,28,18C28,16.8954,28.8954,16,30,16C31.1046,16,32,16.8954,32,18C32,19.1046,31.1046,20,30,20zM15,26C14.9915,29.2,17.388,34,24.3066,34C30.4224,34,33,28.8,33,26"
  },
  ic48_warn_electricity: {
    width: 48,
    height: 48,
    path: "M19,36.6001H28.989V22.0001H19V36.6001zM24.047,5.5991L4.047,40.0001H44.047L24.047,5.5991zM21,26.5361H27V24.0001H21V26.5361zM21.5,32.2471L24,28.0001V30.6841H26.5L24,34.9171V32.2471H21.5z"
  },
  ic48_warn_fill: {
    width: 48,
    height: 48,
    path: "M22.818,29.819H25.164V20.272H22.818V29.819zM22.819,34.508H25.164V32.163H22.819V34.508zM23.897,5.7L4.094,40H43.7L23.897,5.7z"
  },
  ic48_warn_oil: {
    width: 48,
    height: 48,
    path: "M19,36.6001H28.989V22.0001H19V36.6001zM24.047,5.5991L4.047,40.0001H44.047L24.047,5.5991zM25.3262,31.2164C25.2352,31.0584,25.1442,30.8994,25.0542,30.7414C25.0118,30.668,24.8639,30.4126,24.6915,30.115C24.3916,29.5975,24.0178,28.9521,23.9962,28.9134C23.9801,28.9414,23.78,29.2867,23.557,29.6715C23.2943,30.1247,22.9999,30.6327,22.9372,30.7414C22.8472,30.8994,22.7562,31.0584,22.6652,31.2164L22.6466,31.2484C22.5617,31.3946,22.4772,31.54,22.4222,31.6994C22.3632,31.8724,22.3332,32.0554,22.3332,32.2374C22.3332,32.5584,22.4292,32.8564,22.5862,33.1104C22.8792,33.5824,23.3982,33.9004,23.9962,33.9004C24.5932,33.9004,25.1122,33.5824,25.4052,33.1104C25.5622,32.8564,25.6582,32.5584,25.6582,32.2374C25.6582,32.0554,25.6282,31.8724,25.5692,31.6994C25.5142,31.5401,25.4297,31.3946,25.3448,31.2485L25.3262,31.2164zM27,26.5361H21V24.0001H27V26.5361z"
  }
};

// src/iconDist/iconPalette.json
var iconPalette_default = {
  "gray-50": "#f9f9fb",
  "gray-100": "#f2f3f8",
  "gray-200": "#e5e8ef",
  "gray-300": "#c8d1dc",
  "gray-400": "#b4bbcb",
  "gray-500": "#99a1b1",
  "gray-600": "#697383",
  "gray-800": "#354153",
  "gray-900": "#262f3c",
  "gray-1000": "#141a24",
  "blue-50": "#ebf5ff",
  "lightblue-100": "#d6f4ff",
  "lightblue-200": "#8fdfff",
  "lightblue-300": "#54c9ff",
  "lightblue-400": "#33beff",
  "blue-500": "#0078ff",
  "blue-600": "#0069ff",
  "lightblue-800": "#0086ec",
  "indigo-50": "#eceffe",
  "indigo-800": "#1c36e0",
  "blue-100": "#d6ebff",
  "blue-300": "#6bb5ff",
  "blue-400": "#3393ff",
  "blue-700": "#0052e0",
  "blue-800": "#0042c7",
  "blue-900": "#0033a9",
  "orange-50": "#fff8e6",
  "orange-200": "#ffdd99",
  "orange-300": "#ffc566",
  "orange-400": "#ffa940",
  "orange-500": "#ff8800",
  "orange-600": "#fa7900",
  "orange-700": "#f56a00",
  "orange-800": "#ec5704",
  "red-50": "#fff0f3",
  "red-100": "#ffdbdf",
  "red-200": "#ffa1ac",
  "red-400": "#ff576a",
  "red-500": "#ff3a5b",
  "red-600": "#f51441",
  "red-800": "#d30831",
  "red-900": "#c10027",
  "green-50": "#e6fef0",
  "green-100": "#d3fde5",
  "green-200": "#a0fcc8",
  "green-400": "#14e28f",
  "green-500": "#04ca81",
  "green-600": "#00bb83",
  "green-700": "#00ae82",
  "service-socar": "#0078ff",
  "service-business": "#0033a9",
  "text-strong": "#141a24",
  "text-primary": "#354153",
  "text-secondary": "#697383",
  "text-tertiary": "#99a1b1",
  "text-disabled": "#cbd1dc",
  "background-regular": "#f2f3f8",
  white: "#ffffff",
  black: "#000000",
  "border-regular": "#e5e8ef",
  "notification-red": "#ff3a5b",
  "indigo-600": "#3554f8",
  "gray-900_rgb": "rgb(40, 50, 60)",
  white_rgb: "rgb(255, 255, 255)"
};
var Icon = ({
  icon,
  color,
  style,
  className,
  width,
  height,
  viewBox
}) => {
  const { width: iconWidth, height: iconHeight, path } = svgIcons_default[icon];
  const w = width != null ? width : iconWidth;
  const h = height != null ? height : iconHeight;
  const defaultViewBox = `0 0 ${iconWidth} ${iconHeight}`;
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: w,
      height: h,
      fill: iconPalette_default[color],
      fillRule: "evenodd",
      clipRule: "evenodd",
      xmlns: "http://www.w3.org/2000/svg",
      style: __spreadValues({
        minWidth: w
      }, style),
      className,
      viewBox: viewBox != null ? viewBox : defaultViewBox,
      children: /* @__PURE__ */ jsx("path", { d: path })
    }
  );
};
var Icon_default = Icon;

// src/components/Icon/type.ts
var ICON_NAME = {
  "gr_icon_credit": "gr_icon_credit",
  "ic12_24_chevron_right2": "ic12_24_chevron_right2",
  "ic12_24_divider_vertical": "ic12_24_divider_vertical",
  "ic12_24_divider_vertical_small": "ic12_24_divider_vertical_small",
  "ic12_24_field_dash": "ic12_24_field_dash",
  "ic12_24_field_slash": "ic12_24_field_slash",
  "ic12_24_hidden_circle_fill": "ic12_24_hidden_circle_fill",
  "ic12_24_hidden_star": "ic12_24_hidden_star",
  "ic12_24_hidden_star2": "ic12_24_hidden_star2",
  "ic12_24_hidden_wave": "ic12_24_hidden_wave",
  "ic12_24_new": "ic12_24_new",
  "ic12_24_plus": "ic12_24_plus",
  "ic12_warn_fill": "ic12_warn_fill",
  "ic18_precontract": "ic18_precontract",
  "ic18_answer": "ic18_answer",
  "ic18_arrow_right": "ic18_arrow_right",
  "ic18_arrow_round_trip": "ic18_arrow_round_trip",
  "ic18_business": "ic18_business",
  "ic18_car_front": "ic18_car_front",
  "ic18_car_front_fill": "ic18_car_front_fill",
  "ic18_check_on": "ic18_check_on",
  "ic18_checkonly_on": "ic18_checkonly_on",
  "ic18_chevron_left": "ic18_chevron_left",
  "ic18_chevron_less": "ic18_chevron_less",
  "ic18_chevron_more": "ic18_chevron_more",
  "ic18_chevron_right": "ic18_chevron_right",
  "ic18_close": "ic18_close",
  "ic18_credit": "ic18_credit",
  "ic18_delete": "ic18_delete",
  "ic18_delete_field": "ic18_delete_field",
  "ic18_delivery": "ic18_delivery",
  "ic18_description_dash": "ic18_description_dash",
  "ic18_description_dash2": "ic18_description_dash2",
  "ic18_description_line": "ic18_description_line",
  "ic18_electricity": "ic18_electricity",
  "ic18_fast_off": "ic18_fast_off",
  "ic18_fast_on": "ic18_fast_on",
  "ic18_help": "ic18_help",
  "ic18_hot": "ic18_hot",
  "ic18_info_fill": "ic18_info_fill",
  "ic18_info_line": "ic18_info_line",
  "ic18_key_return": "ic18_key_return",
  "ic18_letter_b": "ic18_letter_b",
  "ic18_letter_c": "ic18_letter_c",
  "ic18_letter_d": "ic18_letter_d",
  "ic18_letter_e": "ic18_letter_e",
  "ic18_minus": "ic18_minus",
  "ic18_noti": "ic18_noti",
  "ic18_num_01": "ic18_num_01",
  "ic18_num_02": "ic18_num_02",
  "ic18_num_03": "ic18_num_03",
  "ic18_oil": "ic18_oil",
  "ic18_parking": "ic18_parking",
  "ic18_person": "ic18_person",
  "ic18_phone_fill": "ic18_phone_fill",
  "ic18_pick_fill": "ic18_pick_fill",
  "ic18_plus": "ic18_plus",
  "ic18_poi": "ic18_poi",
  "ic18_poi_fill": "ic18_poi_fill",
  "ic18_premium": "ic18_premium",
  "ic18_question": "ic18_question",
  "ic18_reset": "ic18_reset",
  "ic18_return": "ic18_return",
  "ic18_sale": "ic18_sale",
  "ic18_search": "ic18_search",
  "ic18_share": "ic18_share",
  "ic18_shine": "ic18_shine",
  "ic18_socarzone": "ic18_socarzone",
  "ic18_time": "ic18_time",
  "ic18_time_fill": "ic18_time_fill",
  "ic18_train": "ic18_train",
  "ic18_warn_fill": "ic18_warn_fill",
  "ic18_warn_outline": "ic18_warn_outline",
  "ic24_account_off": "ic24_account_off",
  "ic24_adddrivers": "ic24_adddrivers",
  "ic24_airport": "ic24_airport",
  "ic24_answer": "ic24_answer",
  "ic24_arrow_fill": "ic24_arrow_fill",
  "ic24_back": "ic24_back",
  "ic24_camera": "ic24_camera",
  "ic24_camera_front": "ic24_camera_front",
  "ic24_camera_non": "ic24_camera_non",
  "ic24_car_filter": "ic24_car_filter",
  "ic24_car_filter_line": "ic24_car_filter_line",
  "ic24_car_front": "ic24_car_front",
  "ic24_car_front_fill": "ic24_car_front_fill",
  "ic24_car_search_line": "ic24_car_search_line",
  "ic24_change": "ic24_change",
  "ic24_charge_electricity": "ic24_charge_electricity",
  "ic24_chat": "ic24_chat",
  "ic24_chat_line": "ic24_chat_line",
  "ic24_check_on": "ic24_check_on",
  "ic24_checkonly": "ic24_checkonly",
  "ic24_checksheet": "ic24_checksheet",
  "ic24_chevron_left": "ic24_chevron_left",
  "ic24_chevron_right": "ic24_chevron_right",
  "ic24_close": "ic24_close",
  "ic24_credit": "ic24_credit",
  "ic24_creditcard": "ic24_creditcard",
  "ic24_creditcard2": "ic24_creditcard2",
  "ic24_delete": "ic24_delete",
  "ic24_delete_field": "ic24_delete_field",
  "ic24_delivery": "ic24_delivery",
  "ic24_discount": "ic24_discount",
  "ic24_discount_fill": "ic24_discount_fill",
  "ic24_download": "ic24_download",
  "ic24_driverlicense": "ic24_driverlicense",
  "ic24_driverlicense_fill": "ic24_driverlicense_fill",
  "ic24_electricity_fill": "ic24_electricity_fill",
  "ic24_etc_share": "ic24_etc_share",
  "ic24_expand_less": "ic24_expand_less",
  "ic24_expand_more": "ic24_expand_more",
  "ic24_filter": "ic24_filter",
  "ic24_filter_on": "ic24_filter_on",
  "ic24_flash_off": "ic24_flash_off",
  "ic24_flash_on": "ic24_flash_on",
  "ic24_flashlight_off": "ic24_flashlight_off",
  "ic24_flashlight_on": "ic24_flashlight_on",
  "ic24_forward": "ic24_forward",
  "ic24_help": "ic24_help",
  "ic24_help_fill": "ic24_help_fill",
  "ic24_history": "ic24_history",
  "ic24_history_line": "ic24_history_line",
  "ic24_home": "ic24_home",
  "ic24_home_line": "ic24_home_line",
  "ic24_income": "ic24_income",
  "ic24_info_fill": "ic24_info_fill",
  "ic24_inquire": "ic24_inquire",
  "ic24_inquire_line": "ic24_inquire_line",
  "ic24_key_close": "ic24_key_close",
  "ic24_key_close_fill": "ic24_key_close_fill",
  "ic24_key_horn": "ic24_key_horn",
  "ic24_key_horn_fill": "ic24_key_horn_fill",
  "ic24_key_light": "ic24_key_light",
  "ic24_key_light_fill": "ic24_key_light_fill",
  "ic24_key_open": "ic24_key_open",
  "ic24_key_open_fill": "ic24_key_open_fill",
  "ic24_key_return": "ic24_key_return",
  "ic24_letter_b": "ic24_letter_b",
  "ic24_letter_c": "ic24_letter_c",
  "ic24_letter_d": "ic24_letter_d",
  "ic24_letter_e": "ic24_letter_e",
  "ic24_map": "ic24_map",
  "ic24_menu": "ic24_menu",
  "ic24_minus": "ic24_minus",
  "ic24_more_horiz": "ic24_more_horiz",
  "ic24_morepic": "ic24_morepic",
  "ic24_morepic_line": "ic24_morepic_line",
  "ic24_morepic_video": "ic24_morepic_video",
  "ic24_mylocation": "ic24_mylocation",
  "ic24_mypage": "ic24_mypage",
  "ic24_noti": "ic24_noti",
  "ic24_noti_on": "ic24_noti_on",
  "ic24_number_1": "ic24_number_1",
  "ic24_number_2": "ic24_number_2",
  "ic24_number_3": "ic24_number_3",
  "ic24_number_4": "ic24_number_4",
  "ic24_number_5": "ic24_number_5",
  "ic24_number_6": "ic24_number_6",
  "ic24_number_7": "ic24_number_7",
  "ic24_numkey": "ic24_numkey",
  "ic24_oil": "ic24_oil",
  "ic24_oil_fill": "ic24_oil_fill",
  "ic24_phone": "ic24_phone",
  "ic24_phone_fill": "ic24_phone_fill",
  "ic24_pick_fill": "ic24_pick_fill",
  "ic24_pick_line": "ic24_pick_line",
  "ic24_plus": "ic24_plus",
  "ic24_poi_current": "ic24_poi_current",
  "ic24_poi_fill": "ic24_poi_fill",
  "ic24_question": "ic24_question",
  "ic24_radio_off": "ic24_radio_off",
  "ic24_radio_on": "ic24_radio_on",
  "ic24_request": "ic24_request",
  "ic24_search": "ic24_search",
  "ic24_search_selected": "ic24_search_selected",
  "ic24_setting": "ic24_setting",
  "ic24_setting_line": "ic24_setting_line",
  "ic24_share": "ic24_share",
  "ic24_socarpass": "ic24_socarpass",
  "ic24_socarzone": "ic24_socarzone",
  "ic24_socarzone_shortcut": "ic24_socarzone_shortcut",
  "ic24_time": "ic24_time",
  "ic24_time_fill": "ic24_time_fill",
  "ic24_top": "ic24_top",
  "ic24_visibility_off": "ic24_visibility_off",
  "ic24_visibility_on": "ic24_visibility_on",
  "ic24_warn_fill": "ic24_warn_fill",
  "ic24_warn_outline-1": "ic24_warn_outline-1",
  "ic24_warn_outline": "ic24_warn_outline",
  "ic24_way": "ic24_way",
  "ic24_zone_default": "ic24_zone_default",
  "ic24_zoomin": "ic24_zoomin",
  "ic24_zoomout": "ic24_zoomout",
  "ic48_account": "ic48_account",
  "ic48_airport": "ic48_airport",
  "ic48_answer": "ic48_answer",
  "ic48_bluetooth": "ic48_bluetooth",
  "ic48_bluetooth_off": "ic48_bluetooth_off",
  "ic48_camera_front": "ic48_camera_front",
  "ic48_car_filter": "ic48_car_filter",
  "ic48_checkonly": "ic48_checkonly",
  "ic48_clean": "ic48_clean",
  "ic48_deliverycar": "ic48_deliverycar",
  "ic48_driverlicense": "ic48_driverlicense",
  "ic48_gps": "ic48_gps",
  "ic48_help": "ic48_help",
  "ic48_info": "ic48_info",
  "ic48_key_close": "ic48_key_close",
  "ic48_key_horn": "ic48_key_horn",
  "ic48_key_light": "ic48_key_light",
  "ic48_key_open": "ic48_key_open",
  "ic48_key_return": "ic48_key_return",
  "ic48_location": "ic48_location",
  "ic48_over26": "ic48_over26",
  "ic48_question": "ic48_question",
  "ic48_smile": "ic48_smile",
  "ic48_warn_electricity": "ic48_warn_electricity",
  "ic48_warn_fill": "ic48_warn_fill",
  "ic48_warn_oil": "ic48_warn_oil"
};
var ButtonContent = ({
  loading,
  iconFront,
  text,
  iconRear,
  loadingAnimation
}) => {
  const { View } = useLottie({
    loop: true,
    autoplay: true,
    animationData: loadingAnimation,
    style: {
      margin: "auto",
      height: 16,
      width: 48
    }
  });
  const validIconFrontName = iconFront && Object.prototype.hasOwnProperty.call(ICON_NAME, iconFront);
  const validIconRearName = iconRear && Object.prototype.hasOwnProperty.call(ICON_NAME, iconRear);
  const hasIcon = iconFront !== void 0 || iconRear !== void 0;
  return loading ? View : /* @__PURE__ */ jsxs(
    "span",
    {
      className: "content",
      style: {
        display: hasIcon ? "flex" : "inline-block",
        alignItems: hasIcon ? "flex-start" : "inherit",
        paddingLeft: !validIconFrontName && iconFront ? "8px" : "0px",
        paddingRight: !validIconRearName && iconRear ? "2px" : "0px"
      },
      children: [
        validIconFrontName && /* @__PURE__ */ jsx(
          Icon_default,
          {
            icon: iconFront,
            color: "black",
            className: "icon-front",
            style: { marginRight: "8px" }
          }
        ),
        text,
        validIconRearName && /* @__PURE__ */ jsx(
          Icon_default,
          {
            icon: iconRear,
            color: "black",
            style: { marginLeft: "2px" }
          }
        )
      ]
    }
  );
};
var Button = (props) => {
  const _a = props, {
    type,
    iconFront,
    iconRear,
    disabled,
    loading,
    onClick,
    text,
    color,
    style,
    className,
    tagName = "button",
    href,
    nativeType = "button"
  } = _a, rest = __objRest(_a, [
    "type",
    "iconFront",
    "iconRear",
    "disabled",
    "loading",
    "onClick",
    "text",
    "color",
    "style",
    "className",
    "tagName",
    "href",
    "nativeType"
  ]);
  const [loadingAnimation, setLoadingAnimation] = useState();
  useEffect(() => {
    const assetPrefix = `/animations/${"light" }`;
    const fileName = import_lodash.default.includes(["largeFill", "regularFill"], type) ? "basic_loading_white.json" : "basic_loading_grey040.json";
    assetLoader_default.load(`${`${assetPrefix}/${fileName}`}`).then((data) => setLoadingAnimation(data));
  }, [type]);
  if (loading && !loadingAnimation) {
    return /* @__PURE__ */ jsx("div", {});
  }
  const Button2 = () => {
    return /* @__PURE__ */ jsx(
      "button",
      __spreadProps(__spreadValues({
        type: nativeType,
        onClick,
        disabled,
        className: `
          design-system-button
          ${type}-button-${color}
          ${disabled ? "disabled" : ""}
          ${className != null ? className : ""}
        `,
        style
      }, rest), {
        children: /* @__PURE__ */ jsx(
          ButtonContent,
          __spreadValues({}, {
            loading,
            iconFront,
            text,
            iconRear,
            loadingAnimation
          })
        )
      })
    );
  };
  const Anchor = () => {
    return /* @__PURE__ */ jsx(
      "a",
      {
        href,
        onClick,
        className: `
          design-system-button
          ${type}-button-${color}
          ${disabled ? "disabled" : ""}
          ${className != null ? className : ""}
        `,
        style,
        children: /* @__PURE__ */ jsx(
          ButtonContent,
          __spreadValues({}, {
            loading,
            iconFront,
            text,
            iconRear,
            loadingAnimation
          })
        )
      }
    );
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    tagName === "button" && /* @__PURE__ */ jsx(Button2, {}),
    tagName === "a" && /* @__PURE__ */ jsx(Anchor, {})
  ] });
};
var Button_default = Button;

// src/components/CheckBox/index.tsx
var import_lodash2 = __toESM(require_lodash());

// src/libs/calcColor.ts
var disabledColor = "gray-400";
var calcIconColor = ({
  selected,
  disabled,
  isIconBlue
}) => {
  const selectedIconColor = isIconBlue ? "blue-500" : "gray-800";
  if (disabled)
    return disabledColor;
  return selected ? selectedIconColor : disabledColor;
};
var calcTextColor = ({ selected, disabled }) => {
  const textColor = selected ? "gray-800" : "gray-600";
  return disabled ? disabledColor : textColor;
};

// src/libs/calcIconSize.ts
var calcIconSize = (size) => {
  return size ? "body2" : "body3";
};
var calcIconSize_default = calcIconSize;
var CheckColor = /* @__PURE__ */ ((CheckColor2) => {
  CheckColor2["GREY"] = "grey";
  CheckColor2["BLUE"] = "blue";
  return CheckColor2;
})(CheckColor || {});
var CheckDisplay = /* @__PURE__ */ ((CheckDisplay2) => {
  CheckDisplay2["BLOCK"] = "block";
  CheckDisplay2["INLINE"] = "inline";
  return CheckDisplay2;
})(CheckDisplay || {});
var CheckIcon = {
  CHECK: "check",
  CHECK_ONLY: "checkonly",
  TEXT_ONLY: "textonly"
};
var CheckSize = /* @__PURE__ */ ((CheckSize2) => {
  CheckSize2[CheckSize2["SMALL"] = 0] = "SMALL";
  CheckSize2[CheckSize2["MEDIUM"] = 1] = "MEDIUM";
  return CheckSize2;
})(CheckSize || {});
var CheckBoxGroup = ({
  items,
  name,
  checkedValues: defaultCheckedValues = [],
  size,
  color,
  display,
  icon,
  link,
  disabled,
  readOnly,
  onChange
}) => {
  const [checkedValues, setCheckedValues] = useState(defaultCheckedValues);
  const handleChange = (event) => {
    if (readOnly)
      return;
    const targetItem = event.target;
    const { value, checked } = targetItem;
    if (onChange)
      onChange(event);
    if (checked) {
      setCheckedValues((prev) => [...prev, value]);
      return;
    }
    setCheckedValues(
      (prev) => prev.filter((checkedValue) => checkedValue !== value)
    );
  };
  return /* @__PURE__ */ jsx(Fragment, { children: items.map(({ id, label, value }) => /* @__PURE__ */ jsx(
    CheckBox_default,
    {
      id,
      name,
      value,
      label,
      selected: checkedValues.includes(value),
      size,
      color,
      display,
      icon,
      link,
      disabled,
      readOnly,
      onChange: handleChange
    },
    `${name}-${value}`
  )) });
};
var CheckBoxGroup_default = CheckBoxGroup;
var calcIconStyle = (type) => {
  if (type === "check")
    return `ic24_${type}_on`;
  if (type === "checkonly")
    return `ic24_${type}`;
  return null;
};
var CheckBox = ({
  id: checkId = (0, import_lodash2.uniqueId)("check-"),
  name,
  value,
  label,
  selected = false,
  size = 0 /* SMALL */,
  color = "grey" /* GREY */,
  display = "block" /* BLOCK */,
  icon = "check",
  link,
  disabled = false,
  readOnly = false,
  onChange
}) => {
  const hasIcon = icon !== "textonly";
  const checkIconSize = calcIconSize_default(size);
  const labelColor = calcTextColor({ selected, disabled });
  const labelClassName = `${link ? "has-link " : ""}${labelColor}`;
  const textClassName = `check-text ${checkIconSize}`;
  const isIconBlue = color === "blue" /* BLUE */;
  const iconStyle = calcIconStyle(icon);
  const iconColor = calcIconColor({ selected, disabled, isIconBlue });
  const handleChange = (event) => {
    onChange(event);
  };
  return /* @__PURE__ */ jsxs(CheckBoxWrapper, { display, children: [
    /* @__PURE__ */ jsxs("label", { htmlFor: checkId, className: labelClassName, children: [
      /* @__PURE__ */ jsx(
        "input",
        {
          id: checkId,
          type: "checkbox",
          name,
          value,
          checked: selected,
          disabled,
          readOnly,
          onChange: handleChange
        }
      ),
      hasIcon && iconStyle !== null && /* @__PURE__ */ jsx(Icon_default, { className: "check-icon", icon: iconStyle, color: iconColor }),
      /* @__PURE__ */ jsx("span", { className: textClassName, children: label })
    ] }),
    link && /* @__PURE__ */ jsx(LinkButton, { size: checkIconSize, link })
  ] });
};
var CheckBox_default = CheckBox;
var CheckBoxWrapper = ({ children, display }) => {
  const wrapperClassName = `check-wrapper check-${display}`;
  return /* @__PURE__ */ jsx("div", { className: wrapperClassName, children });
};
var LinkButton = ({ size, link }) => {
  const isWebViewCheck = isWebview();
  const chevronIcon = /* @__PURE__ */ jsx(Icon_default, { className: "check-chevron", icon: "ic24_chevron_right", color: "black" });
  const handleLink = () => {
    openExternalBrowser(link);
  };
  if (isWebViewCheck) {
    return /* @__PURE__ */ jsx("button", { type: "button", onClick: handleLink, className: size, children: chevronIcon });
  }
  return /* @__PURE__ */ jsx("a", { href: link, target: "_blank", rel: "noreferrer", className: size, children: chevronIcon });
};
var ANIMATIONS = {
  basicWhite: {
    file: "basic_loading_white.json",
    width: 48,
    height: 16
  },
  basicWhiteDimmed: {
    file: "basic_loading_white_dim.json",
    width: 80,
    height: 80
  },
  basicGrey: {
    file: "basic_loading_grey040.json",
    width: 48,
    height: 16
  },
  basicBlue: {
    file: "basic_loading_blue050.json",
    width: 48,
    height: 16
  },
  basicCoral: {
    file: "basic_loading_coral050.json",
    width: 48,
    height: 16
  },
  circularBlue: {
    file: "circular_loading_blue050.json",
    width: 24,
    height: 24
  },
  circularCoral: {
    file: "circular_loading_coral050.json",
    width: 24,
    height: 24
  }
};
var LoadingTypeEnum = /* @__PURE__ */ ((LoadingTypeEnum2) => {
  LoadingTypeEnum2["basicWhite"] = "basicWhite";
  LoadingTypeEnum2["basicWhiteDimmed"] = "basicWhiteDimmed";
  LoadingTypeEnum2["basicBlue"] = "basicBlue";
  LoadingTypeEnum2["basicGrey"] = "basicGrey";
  LoadingTypeEnum2["basicCoral"] = "basicCoral";
  LoadingTypeEnum2["circularBlue"] = "circularBlue";
  LoadingTypeEnum2["circularCoral"] = "circularCoral";
  return LoadingTypeEnum2;
})(LoadingTypeEnum || {});
var Loading = ({
  type = "basicWhiteDimmed",
  inline = false,
  height = 0,
  style = {},
  className = ""
}) => {
  const animation = ANIMATIONS[type];
  const [animationData, setAnimationData] = useState();
  const { View } = useLottie({
    animationData,
    loop: true,
    autoplay: true,
    style: { height: animation.height, width: animation.width }
  });
  const assetPrefix = `/animations/${"light" }`;
  useEffect(() => {
    assetLoader_default.load(`${assetPrefix}/${animation.file}`).then((data) => setAnimationData(data));
  }, [assetPrefix, animation.file]);
  if (!animationData) {
    return /* @__PURE__ */ jsx("div", {});
  }
  const heightClass = inline && height > 0 ? `height-${height}px` : "";
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: `
        Loading ${inline ? "" : "full-screen"}
        ${heightClass}
        ${className}
      `,
      style,
      children: /* @__PURE__ */ jsx("div", { className: "animation-box", children: View })
    }
  );
};
var Loading_default = Loading;

// src/components/Navigation/index.tsx
var import_lodash3 = __toESM(require_lodash());
var UnitWrapper = ({
  className = "",
  onClick,
  children
}) => {
  return /* @__PURE__ */ jsx(
    "button",
    {
      type: "button",
      className: `action-button ${className}`,
      onClick,
      children
    }
  );
};
var UnitButton_default = UnitWrapper;
var BackButton = ({ iconColor = "gray-800", onClick }) => {
  return /* @__PURE__ */ jsx(UnitButton_default, { onClick, children: /* @__PURE__ */ jsx(Icon_default, { icon: "ic24_back", color: iconColor }) });
};
var BackButton_default = BackButton;
var CloseButton = ({ iconColor = "gray-800", onClick }) => {
  return /* @__PURE__ */ jsx(UnitButton_default, { onClick, children: /* @__PURE__ */ jsx(Icon_default, { icon: "ic24_close", color: iconColor }) });
};
var CloseButton_default = CloseButton;
var IconButton = ({ iconColor, iconName, onClick }) => {
  return /* @__PURE__ */ jsx(UnitButton_default, { onClick, children: /* @__PURE__ */ jsx(Icon_default, { icon: iconName, color: iconColor }) });
};
var IconButton_default = IconButton;
var TextButton = ({
  textButtonClassName,
  text,
  color,
  onClick
}) => {
  const colorStyle = color && { style: { color } };
  return /* @__PURE__ */ jsx(UnitButton_default, { className: "text", onClick, children: /* @__PURE__ */ jsx("span", __spreadProps(__spreadValues({ className: textButtonClassName }, colorStyle), { children: text })) });
};
var TextButton_default = TextButton;

// src/components/Navigation/type.ts
var UnitStyle = /* @__PURE__ */ ((UnitStyle2) => {
  UnitStyle2["BACK"] = "back";
  UnitStyle2["CLOSE"] = "close";
  UnitStyle2["ICON"] = "icon";
  UnitStyle2["TEXT"] = "text";
  return UnitStyle2;
})(UnitStyle || {});
var defaultBackFunction = (canGoBack = true) => {
  canGoBack ? window.history.back() : closeWebView();
};

// src/components/Navigation/utils/getColorClassName.ts
var getColorClassName = (navStyle) => {
  if (navStyle === "reverse") {
    return {
      navBgColor: "bg-gray-900",
      iconColor: "white",
      pathNameColor: "white",
      unitTextColor: "white"
    };
  }
  return {
    navBgColor: "bg-white",
    iconColor: "gray-800",
    pathNameColor: "initial",
    unitTextColor: "text-primary"
  };
};

// src/components/Navigation/utils/getVisibleClassName.ts
var getVisibleClassName = (isTrue) => isTrue ? "visible" : "";

// src/components/Navigation/utils/nullFunction.ts
var nullFunction = () => null;
var minimumAppVersion = "13.1.0";
var currentAppVersion = getCookie("application_version");
var isWebViewActionBarAvailable = currentAppVersion && !isLowerVersion(currentAppVersion, minimumAppVersion);
var Navigation = ({
  pageName = "",
  navStyle = "default",
  style,
  leftUnit1 = { unitStyle: "back" /* BACK */, clickFunction: defaultBackFunction },
  leftUnit2 = null,
  rightUnit1 = {
    unitStyle: "close" /* CLOSE */,
    clickFunction: closeWebView
  },
  rightUnit2 = null,
  showBackButton = true,
  navHeight = 0,
  showPageTitle = false
}) => {
  const [isAnimationVisible, setAnimationVisible] = useState(false);
  const isNavStyleLine = navStyle === "line";
  const classNames = useMemo(
    () => ({
      lineAnimationClassName: getVisibleClassName(
        isNavStyleLine && isAnimationVisible
      ),
      titleAnimationClassName: getVisibleClassName(
        showPageTitle || isAnimationVisible
      )
    }),
    [isAnimationVisible, showPageTitle]
  );
  const { navBgColor, iconColor, pathNameColor, unitTextColor } = getColorClassName(navStyle);
  const { lineAnimationClassName, titleAnimationClassName } = classNames;
  const navClassName = `action-bar ${navBgColor} ${navStyle} ${lineAnimationClassName}`;
  const pageNameClassName = `title2 text-ellipsis-1 page-name ${pathNameColor} ${titleAnimationClassName}`;
  const handleScroll = (0, import_lodash3.throttle)(() => {
    setAnimationVisible(window.scrollY > navHeight);
  }, 200);
  useEffect(() => {
    var _a;
    window.onClickBackButton = ((_a = leftUnit1 == null ? void 0 : leftUnit1.clickFunction) == null ? void 0 : _a.bind(showBackButton)) || nullFunction;
  }, [leftUnit1]);
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [showPageTitle]);
  const renderUnit = (unitProps) => {
    const clickFunction = (unitProps == null ? void 0 : unitProps.clickFunction) || nullFunction;
    switch (unitProps == null ? void 0 : unitProps.unitStyle) {
      case "back" /* BACK */:
        return /* @__PURE__ */ jsx(BackButton_default, { iconColor, onClick: clickFunction });
      case "close" /* CLOSE */:
        return /* @__PURE__ */ jsx(CloseButton_default, { iconColor, onClick: clickFunction });
      case "icon" /* ICON */:
        return /* @__PURE__ */ jsx(
          IconButton_default,
          {
            iconColor,
            iconName: unitProps.iconName,
            onClick: clickFunction
          }
        );
      case "text" /* TEXT */:
        return /* @__PURE__ */ jsx(
          TextButton_default,
          {
            textButtonClassName: unitTextColor,
            text: unitProps.text,
            color: unitProps.color,
            onClick: clickFunction
          }
        );
      default:
        return null;
    }
  };
  if (!navHeight)
    return null;
  return /* @__PURE__ */ jsxs("nav", { className: navClassName, style: __spreadValues({ height: navHeight }, style), children: [
    /* @__PURE__ */ jsxs("div", { className: "left-part", children: [
      showBackButton && leftUnit1 && /* @__PURE__ */ jsx("div", { className: "L1", children: renderUnit(leftUnit1) }),
      leftUnit2 && /* @__PURE__ */ jsx("div", { className: "L2", children: renderUnit(leftUnit2) })
    ] }),
    /* @__PURE__ */ jsx("h2", { className: pageNameClassName, children: pageName }),
    /* @__PURE__ */ jsxs("div", { className: "right-part", children: [
      rightUnit2 && /* @__PURE__ */ jsx("div", { className: "R2", children: renderUnit(rightUnit2) }),
      rightUnit1 && /* @__PURE__ */ jsx("div", { className: "R1", children: renderUnit(rightUnit1) })
    ] })
  ] });
};
var Navigation_default = Navigation;

// src/components/Radio/index.tsx
var import_lodash4 = __toESM(require_lodash());
var RadioColor = /* @__PURE__ */ ((RadioColor2) => {
  RadioColor2["GREY"] = "grey";
  RadioColor2["BLUE"] = "blue";
  return RadioColor2;
})(RadioColor || {});
var RadioDisplay = /* @__PURE__ */ ((RadioDisplay2) => {
  RadioDisplay2["BLOCK"] = "block";
  RadioDisplay2["INLINE"] = "inline";
  return RadioDisplay2;
})(RadioDisplay || {});
var RadioSize = /* @__PURE__ */ ((RadioSize2) => {
  RadioSize2[RadioSize2["SMALL"] = 0] = "SMALL";
  RadioSize2[RadioSize2["MEDIUM"] = 1] = "MEDIUM";
  return RadioSize2;
})(RadioSize || {});
var RadioGroup = ({
  items,
  name,
  defaultValue,
  size,
  color,
  display,
  disabled,
  readOnly,
  onChange
}) => {
  const [radioValue, setRadioValue] = useState(defaultValue);
  const handleChange = (event) => {
    if (readOnly)
      return;
    const targetItem = event.target;
    if (onChange)
      onChange(event);
    setRadioValue(targetItem.value);
  };
  return /* @__PURE__ */ jsx(Fragment, { children: items.map(({ id, label, value }) => /* @__PURE__ */ jsx(
    Radio_default,
    {
      id,
      name,
      value,
      label,
      size,
      color,
      display,
      selected: radioValue === value,
      disabled,
      readOnly,
      onChange: handleChange
    },
    `${name}-${value}`
  )) });
};
var RadioGroup_default = RadioGroup;
var Radio = ({
  id: radioId = (0, import_lodash4.uniqueId)("radio-"),
  name,
  value,
  label,
  size = 0 /* SMALL */,
  color = "grey" /* GREY */,
  display = "block" /* BLOCK */,
  selected,
  disabled = false,
  readOnly = false,
  onChange
}) => {
  const radioSize = calcIconSize_default(size);
  const labelClassName = calcTextColor({ selected, disabled });
  const textClassName = `radio-text ${radioSize}`;
  const isIconBlue = color === "blue" /* BLUE */;
  const iconColor = calcIconColor({ selected, disabled, isIconBlue });
  const iconStyle = selected ? "on" : "off";
  const handleChange = (event) => {
    onChange(event);
  };
  return /* @__PURE__ */ jsx(RadioWrapper, { display, children: /* @__PURE__ */ jsxs("label", { htmlFor: radioId, className: labelClassName, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        id: radioId,
        type: "radio",
        name,
        value,
        checked: selected,
        disabled,
        readOnly,
        onChange: handleChange
      }
    ),
    /* @__PURE__ */ jsx(
      Icon_default,
      {
        icon: `ic24_radio_${iconStyle}`,
        color: iconColor,
        className: "radio-icon"
      }
    ),
    /* @__PURE__ */ jsx("span", { className: textClassName, children: label })
  ] }) });
};
var Radio_default = Radio;
var RadioWrapper = ({ children, display }) => {
  const wrapperClassName = `radio-wrapper radio-${display}`;
  return /* @__PURE__ */ jsx("div", { className: wrapperClassName, children });
};
var useSnackbar = () => {
  const snackbarRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [content, setContent] = useState("");
  const openSnackbar = useCallback((content2) => {
    setContent(content2);
    setIsOpen(true);
  }, []);
  const closeSnackbar = useCallback(() => {
    setIsOpen(false);
  }, []);
  return {
    isOpen,
    content,
    openSnackbar,
    closeSnackbar,
    snackbarRef
  };
};
var Snackbar = (_a) => {
  var _b = _a, {
    type = "basic",
    isOpen = false,
    content,
    buttonText = "\uD655\uC778",
    handleButtonClick,
    closeSnackbar
  } = _b, restHtmlDivProps = __objRest(_b, [
    "type",
    "isOpen",
    "content",
    "buttonText",
    "handleButtonClick",
    "closeSnackbar"
  ]);
  var _a2;
  const hasButton = type !== "basic";
  const { snackbarRef } = useSnackbar();
  const fadeOut = (isInstant = false) => {
    var _a3, _b2, _c;
    if (isInstant) {
      (_a3 = snackbarRef.current) == null ? void 0 : _a3.classList.replace("fade-out-long", "fade-out");
      return;
    }
    if (type === "basic") {
      (_b2 = snackbarRef.current) == null ? void 0 : _b2.classList.add("fade-out-basic");
    } else {
      (_c = snackbarRef.current) == null ? void 0 : _c.classList.add("fade-out-long");
    }
  };
  const handleAnimationEnd = useCallback(({ animationName }) => {
    var _a3;
    switch (animationName) {
      case "snackbar-fade-in":
        fadeOut();
        break;
      case "snackbar-fade-out":
        if ((_a3 = snackbarRef.current) == null ? void 0 : _a3.className.match(/fade-out/)) {
          closeSnackbar();
        }
        break;
    }
  }, []);
  const handleClose = (event) => {
    fadeOut(true);
    handleButtonClick == null ? void 0 : handleButtonClick(event);
  };
  return isOpen ? /* @__PURE__ */ jsxs(
    "div",
    __spreadProps(__spreadValues({}, restHtmlDivProps), {
      className: `design-system-snackbar ${type} ${(_a2 = restHtmlDivProps.className) != null ? _a2 : ""}`,
      ref: snackbarRef,
      onAnimationEnd: handleAnimationEnd,
      children: [
        /* @__PURE__ */ jsx("div", { className: "textbox subtitle3", children: content }),
        hasButton && /* @__PURE__ */ jsx("div", { className: "buttonbox", children: /* @__PURE__ */ jsx("button", { type: "button", className: "subtitle3", onClick: handleClose, children: buttonText }) })
      ]
    })
  ) : null;
};
var Snackbar_default = Snackbar;
var Tag = (props) => {
  const { text, color, style, className } = props;
  const colorSuffix = color.replace("drivingmodeBasic", "drivingmode-basic");
  return /* @__PURE__ */ jsx(
    "span",
    {
      className: `design-system-tag tag-${colorSuffix} ${className}`,
      style,
      children: text
    }
  );
};
var Tag_default = Tag;

// src/components/Tags/index.tsx
var import_lodash5 = __toESM(require_lodash());
var Tags = (props) => {
  var _a;
  const { texts = [], colors = [], style, classNames } = props;
  const defaultColor = (_a = import_lodash5.default.first(colors)) != null ? _a : "basic";
  return /* @__PURE__ */ jsx("div", { className: `design-system-tags ${classNames}`, style, children: texts.map((txt) => {
    var _a2;
    return /* @__PURE__ */ jsx(Tag_default, { text: txt, color: (_a2 = colors.shift()) != null ? _a2 : defaultColor });
  }) });
};
var Tags_default = Tags;
var import_lodash6 = __toESM(require_lodash());
var Label = ({ props, textFieldInputId }) => {
  const { label } = props;
  return label ? /* @__PURE__ */ jsx(
    "label",
    {
      htmlFor: textFieldInputId,
      className: "text-field-label text-ellipsis-1 body2 primary",
      children: label
    }
  ) : null;
};
var Label_default = Label;
var SubText = ({ props }) => {
  const {
    inputText,
    type = "text",
    helperText,
    isError = false,
    errorText,
    disabled = false,
    characterLimit
  } = props;
  const showErrorText = isError && errorText;
  const showHelperText = !isError && helperText;
  const showCharacterCounter = type === "textarea" && !disabled && characterLimit;
  const showSubText = showErrorText || showHelperText || showCharacterCounter;
  return showSubText ? /* @__PURE__ */ jsxs("div", { className: "subtext", children: [
    showErrorText && /* @__PURE__ */ jsx("span", { className: "caption2 red-500 text-ellipsis-1", children: errorText }),
    showHelperText && /* @__PURE__ */ jsx("span", { className: "caption2 text-secondary text-ellipsis-1", children: helperText }),
    showCharacterCounter && /* @__PURE__ */ jsx("span", { className: "character-limit caption2 text-secondary", children: `${inputText == null ? void 0 : inputText.length}/${characterLimit}` })
  ] }) : null;
};
var SubText_default = SubText;
var Input = ({ props, textFieldInputId }) => {
  const {
    name,
    inputText,
    onChange,
    defaultValue,
    type = "text",
    placeholder,
    disabled = false,
    readOnly = false,
    inputClassName,
    inputStyle,
    characterLimit,
    inputMode,
    autoComplete,
    autoFocus
  } = props;
  const textTyping = (text) => {
    let typedText = text;
    if (characterLimit && text.length > characterLimit) {
      typedText = text.substr(0, characterLimit);
    }
    if (onChange)
      onChange(typedText);
  };
  return type === "textarea" ? /* @__PURE__ */ jsx(
    "textarea",
    {
      id: textFieldInputId,
      name,
      className: `text-field-input body2 primary textarea ${inputClassName != null ? inputClassName : ""}`,
      style: inputStyle,
      value: inputText,
      defaultValue,
      onChange: (e) => textTyping(e.target.value),
      placeholder,
      disabled,
      readOnly,
      autoFocus
    }
  ) : /* @__PURE__ */ jsx(
    "input",
    {
      id: textFieldInputId,
      name,
      className: `text-field-input body2 primary ${inputClassName != null ? inputClassName : ""}`,
      style: inputStyle,
      type,
      value: inputText,
      defaultValue,
      onChange: (e) => textTyping(e.target.value),
      placeholder,
      disabled,
      readOnly,
      inputMode,
      autoComplete,
      autoFocus
    }
  );
};
var Input_default = Input;

// src/libs/time.ts
var getSecondsUntilExpiredAt = (expiredAt) => {
  const seconds = Math.floor((expiredAt - Date.now()) / 1e3);
  return seconds;
};
var secToMinAndSec = ({
  seconds,
  minuteDigit = 2,
  secondDigit = 2
}) => {
  const minutes = Math.floor(seconds / 60);
  const sec = seconds % 60;
  const convertedMinutes = minutes.toString().padStart(minuteDigit, "0");
  const convertedSeconds = sec.toString().padStart(secondDigit, "0");
  return {
    minutes,
    seconds: sec,
    convertedTime: `${convertedMinutes}:${convertedSeconds}`
  };
};
var Timer = ({
  expiredAt,
  expirationTerm,
  timeoutText = "\uC2DC\uAC04 \uB9CC\uB8CC",
  isTimeout,
  setIsTimeout,
  disabled
}) => {
  const [remainedTime, setRemainedTime] = useState(
    getSecondsUntilExpiredAt(expiredAt)
  );
  const showTimer = expiredAt && !disabled;
  const text = isTimeout ? timeoutText : secToMinAndSec({ seconds: remainedTime }).convertedTime;
  const className = isTimeout ? "body3 red-500 time" : "body2 text-secondary time";
  const timerInterval = useRef(null);
  useEffect(() => {
    const countDown = (expiredAt2) => {
      const seconds = getSecondsUntilExpiredAt(expiredAt2);
      setRemainedTime(seconds);
      if (seconds <= 0) {
        setIsTimeout(true);
        timerInterval.current && clearInterval(timerInterval.current);
      }
    };
    if (expiredAt && expiredAt > 0) {
      setRemainedTime(getSecondsUntilExpiredAt(expiredAt));
      timerInterval.current = window.setInterval(() => {
        countDown(expiredAt);
      }, 1e3);
      setIsTimeout(false);
    }
    return () => {
      timerInterval.current && clearInterval(timerInterval.current);
    };
  }, [expiredAt, setIsTimeout]);
  return showTimer ? /* @__PURE__ */ jsx("span", { className, children: text }) : null;
};
var Timer_default = Timer;
var AddOns = ({
  props,
  textFieldInputId,
  textFieldAddOnsId,
  isTimeout,
  setIsTimeout
}) => {
  const {
    inputText,
    onChange,
    isError = false,
    disabled = false,
    clearButtonDisabled = false,
    errorIcon,
    timer
  } = props;
  const textClear = () => {
    var _a;
    if (onChange)
      onChange("");
    (_a = document.getElementById(textFieldInputId)) == null ? void 0 : _a.focus();
  };
  const showTextClearButton = !clearButtonDisabled && inputText && !disabled;
  return /* @__PURE__ */ jsxs("div", { id: textFieldAddOnsId, className: "text-field-add-ons", children: [
    showTextClearButton && /* @__PURE__ */ jsx("button", { type: "button", onClick: textClear, className: "text-clear-button", children: /* @__PURE__ */ jsx(Icon_default, { icon: "ic24_delete_field", color: "gray-400" }) }),
    isError && errorIcon && /* @__PURE__ */ jsx(Icon_default, { icon: errorIcon, color: "red-500" }),
    timer && /* @__PURE__ */ jsx(
      Timer_default,
      __spreadValues({
        isTimeout,
        setIsTimeout,
        disabled
      }, timer)
    )
  ] });
};
var AddOns_default = AddOns;
var InputContainer = ({
  props,
  textFieldInputId,
  textFieldAddOnsId,
  isTimeout,
  setIsTimeout
}) => {
  return /* @__PURE__ */ jsxs("div", { className: "text-field-input-container", children: [
    /* @__PURE__ */ jsx(Input_default, { props, textFieldInputId }),
    /* @__PURE__ */ jsx(
      AddOns_default,
      {
        props,
        textFieldInputId,
        textFieldAddOnsId,
        isTimeout,
        setIsTimeout
      }
    )
  ] });
};
var InputContainer_default = InputContainer;
var TextField = (props) => {
  const {
    id,
    isError = false,
    disabled = false,
    wrapperClassName,
    wrapperStyle
  } = props;
  const textFieldInputId = id != null ? id : (0, import_lodash6.uniqueId)("text-field-input-");
  const textFieldAddOnsId = id ? `text-field-add-ons-${id}` : (0, import_lodash6.uniqueId)("text-field-add-ons-");
  const [isTimeout, setIsTimeout] = useState(false);
  const getClassName = () => {
    const classNames = ["text-field"];
    if (wrapperClassName)
      classNames.push(wrapperClassName);
    if (disabled) {
      classNames.push("disabled");
    } else if (isError || isTimeout)
      classNames.push("error");
    return classNames.join(" ");
  };
  useEffect(() => {
    const textFieldAddOns = document.getElementById(textFieldAddOnsId);
    textFieldAddOns == null ? void 0 : textFieldAddOns.addEventListener("mousedown", (e) => {
      e.preventDefault();
      e.stopPropagation();
    });
    return () => {
      textFieldAddOns == null ? void 0 : textFieldAddOns.removeEventListener("mousedown", (e) => {
        e.preventDefault();
        e.stopPropagation();
      });
    };
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: getClassName(), style: wrapperStyle, children: [
    /* @__PURE__ */ jsx(Label_default, { props, textFieldInputId }),
    /* @__PURE__ */ jsx(
      InputContainer_default,
      {
        props,
        textFieldInputId,
        textFieldAddOnsId,
        isTimeout,
        setIsTimeout
      }
    ),
    /* @__PURE__ */ jsx(SubText_default, { props })
  ] });
};
var TextField_default = TextField;
var useResize = (callback) => {
  useEffect(() => {
    window.addEventListener("resize", callback);
    return () => {
      window.removeEventListener("resize", callback);
    };
  }, [callback]);
};
var useResize_default = useResize;
var useTooltip = () => {
  const tooltipRef = useRef(null);
  const [isVisible, setIsVisible] = useState(true);
  const setTooltipFadeIn = useCallback(() => {
    var _a;
    (_a = tooltipRef.current) == null ? void 0 : _a.classList.add("fade-in");
  }, []);
  const setTooltipFadeOut = useCallback(({ isLate }) => {
    const tooltip = tooltipRef.current;
    tooltip == null ? void 0 : tooltip.classList.remove("fade-in");
    tooltip == null ? void 0 : tooltip.classList.add(isLate ? "fade-out-late" : "fade-out");
  }, []);
  return {
    tooltipRef,
    isVisible,
    setIsVisible,
    setTooltipFadeIn,
    setTooltipFadeOut
  };
};
var useTooltipAlign = (tooltipRef) => {
  const getTooltipPosition = useCallback(() => {
    const $tooltip = tooltipRef.current;
    const $target = $tooltip == null ? void 0 : $tooltip.previousElementSibling;
    if (!$tooltip || !$target)
      return;
    const ARROW_WIDTH = 18;
    const ARROW_HEIGHT = 8;
    const HORIZONTAL_ARROW_GAP = 16;
    const VERTICAL_ARROW_GAP = 8;
    const target = $target.getBoundingClientRect();
    const tooltip = $tooltip.getBoundingClientRect();
    const startXPositionAt = {
      left: -16 - ARROW_WIDTH / 2,
      mid: -tooltip.width / 2,
      right: -tooltip.width + HORIZONTAL_ARROW_GAP + ARROW_WIDTH / 2
    };
    const offsetAt = {
      start: 0,
      center: target.width / 2,
      end: target.width
    };
    const yPositionAt = {
      top: target.height + ARROW_HEIGHT + VERTICAL_ARROW_GAP,
      bottom: -tooltip.height - ARROW_HEIGHT - VERTICAL_ARROW_GAP
    };
    return {
      startXPositionAt,
      offsetAt,
      yPositionAt
    };
  }, [tooltipRef]);
  const alignTooltip = useCallback(
    ({ arrowPosition, tooltipAlign }) => {
      const horizontalArrowPosition = arrowPosition.split("-")[1];
      const $tooltip = tooltipRef.current;
      const tooltipPosition = getTooltipPosition();
      if (!$tooltip || !tooltipPosition)
        return;
      const { startXPositionAt, offsetAt, yPositionAt } = tooltipPosition;
      const verticalArrowPosition = arrowPosition.match(/top/) ? "top" : "bottom";
      const isKeyOfStartXPositionAt = (value) => {
        return Object.keys(startXPositionAt).includes(value);
      };
      if (!isKeyOfStartXPositionAt(horizontalArrowPosition))
        return;
      const startXPosition = startXPositionAt[horizontalArrowPosition];
      const xPosition = `${startXPosition + offsetAt[tooltipAlign]}px`;
      const yPosition = `${yPositionAt[verticalArrowPosition]}px`;
      $tooltip.style.transform = `translate(${xPosition}, ${yPosition})`;
    },
    [getTooltipPosition, tooltipRef]
  );
  return {
    alignTooltip
  };
};
var Tooltip = ({
  text,
  show = false,
  children,
  arrowPosition = "bottom-mid",
  type = "basic",
  tooltipAlign = "center",
  containerStyle,
  style,
  handleCloseButtonClick,
  additionalButtons,
  isFixed = false
}) => {
  const {
    tooltipRef,
    isVisible,
    setIsVisible,
    setTooltipFadeIn,
    setTooltipFadeOut
  } = useTooltip();
  const { alignTooltip } = useTooltipAlign(tooltipRef);
  const handleTooltipAnimationEnd = () => {
    var _a;
    const isFadeOutEnd = (_a = tooltipRef.current) == null ? void 0 : _a.className.match(/fade-out/);
    if (type === "basic" && !isFadeOutEnd) {
      setTooltipFadeOut({ isLate: true });
      return;
    }
    if (isFadeOutEnd) {
      setIsVisible(false);
    }
  };
  const handleCloseButton = (e) => {
    setTooltipFadeOut({ isLate: false });
    handleCloseButtonClick == null ? void 0 : handleCloseButtonClick(e);
  };
  useEffect(() => {
    const isTooltipFadeOut = !show && !isVisible;
    if (isTooltipFadeOut) {
      setIsVisible(true);
    }
  }, [show, isVisible]);
  useLayoutEffect(() => {
    if (isFixed || !show)
      return;
    setTooltipFadeIn();
  }, [isFixed, setTooltipFadeIn, show]);
  useLayoutEffect(() => {
    if (!show)
      return;
    alignTooltip({ arrowPosition, tooltipAlign });
  }, [alignTooltip, arrowPosition, tooltipAlign, show, text]);
  useResize_default(() => {
    alignTooltip({ arrowPosition, tooltipAlign });
  });
  const horizontalArrowPosition = arrowPosition.split("-")[1];
  const tooltipClassName = `design-tooltip z-idx-top ${arrowPosition.match(/top/) ? "up-arrow" : "down-arrow"} ${horizontalArrowPosition} ${type === "icon" ? "tooltip-flex" : ""}`;
  const isTooltipRenderPossible = show && text && isVisible;
  const tooltipChild = {
    basic: null,
    icon: /* @__PURE__ */ jsx("button", { type: "button", "aria-label": "\uB2EB\uAE30", onClick: handleCloseButton, children: /* @__PURE__ */ jsx(Icon_default, { icon: "ic18_close", color: "white" }) }),
    buttons: /* @__PURE__ */ jsxs("div", { className: "button-group", children: [
      /* @__PURE__ */ jsx("button", { type: "button", onClick: handleCloseButton, children: "\uB2EB\uAE30" }),
      additionalButtons == null ? void 0 : additionalButtons.map(({ name, handler }, index) => /* @__PURE__ */ jsx("button", { type: "button", onClick: handler, children: name }, `${name}-${index}`))
    ] })
  };
  return /* @__PURE__ */ jsx(Fragment, { children: show ? /* @__PURE__ */ jsxs("div", { className: "design-tooltip-container", style: containerStyle, children: [
    children,
    isTooltipRenderPossible && /* @__PURE__ */ jsxs(
      "div",
      {
        onAnimationEnd: handleTooltipAnimationEnd,
        style,
        ref: tooltipRef,
        role: "tooltip",
        className: tooltipClassName,
        children: [
          text,
          tooltipChild[type]
        ]
      }
    )
  ] }) : children });
};
var Tooltip_default = Tooltip;
/*! Bundled license information:

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)
*/

export { Button_default as Button, CheckBox_default as CheckBox, CheckBoxGroup_default as CheckBoxGroup, CheckColor, CheckDisplay, CheckIcon, CheckSize, Icon_default as Icon, Loading_default as Loading, LoadingTypeEnum, Navigation_default as Navigation, Radio_default as Radio, RadioColor, RadioDisplay, RadioGroup_default as RadioGroup, RadioSize, Snackbar_default as Snackbar, Tag_default as Tag, Tags_default as Tags, TextField_default as TextField, Tooltip_default as Tooltip, UnitStyle, isWebViewActionBarAvailable, useSnackbar };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=index.js.map